// Generated by content/generate.mjs. Edit the approved sources, then regenerate; never edit this module.
import { ContentPage, ContentRules } from '../types'

export const CONTENT_PAGES: Record<string, ContentPage> = {
  'canetas-emagrecedoras': {
    slug: 'canetas-emagrecedoras',
    title: 'Canetas emagrecedoras: quais existem no Brasil, como funcionam e preços | Medleve',
    description:
      'Guia das canetas emagrecedoras no Brasil: Wegovy, Poviztra, Mounjaro, Ozempic, Ozivy e Semavy. Veja quais têm indicação para obesidade, quanto se perde nos estudos, preços e receita.',
    h1: 'Canetas emagrecedoras: quais existem no Brasil e como funcionam',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: '"Caneta emagrecedora" é o nome popular dos medicamentos injetáveis semanais à base de semaglutida ou tirzepatida. No Brasil, três têm indicação aprovada pela Anvisa para obesidade ou sobrepeso com comorbidade: Wegovy, Poviztra e Mounjaro. Ozempic, Ozivy e Semavy são aprovados para diabetes tipo 2. Nos estudos, a perda média de peso foi de cerca de 15% com semaglutida 2,4 mg e de até 21% com tirzepatida. Todas exigem receita com retenção.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'O que são canetas emagrecedoras?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'São canetas de aplicação subcutânea que contêm agonistas de ' },
              { kind: 'link', url: '/glp-1', children: [{ kind: 'text', text: 'GLP-1' }] },
              {
                kind: 'text',
                text: '. O termo é popular, não técnico: nem toda caneta dessa classe foi aprovada para emagrecimento.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quais canetas estão disponíveis no Brasil?',
        blocks: [
          {
            kind: 'table',
            header: [
              [{ kind: 'text', text: 'Caneta' }],
              [{ kind: 'text', text: 'Princípio ativo' }],
              [{ kind: 'text', text: 'Dose máxima semanal' }],
              [{ kind: 'text', text: 'Indicação para obesidade na bula' }]
            ],
            rows: [
              [
                [{ kind: 'link', url: '/wegovy', children: [{ kind: 'text', text: 'Wegovy' }] }],
                [{ kind: 'text', text: 'Semaglutida' }],
                [{ kind: 'text', text: '2,4 mg' }],
                [{ kind: 'text', text: 'Sim' }]
              ],
              [
                [{ kind: 'link', url: '/poviztra', children: [{ kind: 'text', text: 'Poviztra' }] }],
                [{ kind: 'text', text: 'Semaglutida' }],
                [{ kind: 'text', text: '2,4 mg' }],
                [{ kind: 'text', text: 'Sim' }]
              ],
              [
                [{ kind: 'link', url: '/mounjaro', children: [{ kind: 'text', text: 'Mounjaro' }] }],
                [{ kind: 'text', text: 'Tirzepatida' }],
                [{ kind: 'text', text: '15 mg' }],
                [{ kind: 'text', text: 'Sim' }]
              ],
              [
                [{ kind: 'link', url: '/ozempic', children: [{ kind: 'text', text: 'Ozempic' }] }],
                [{ kind: 'text', text: 'Semaglutida' }],
                [{ kind: 'text', text: '1 mg' }],
                [{ kind: 'text', text: 'Não (diabetes tipo 2)' }]
              ],
              [
                [{ kind: 'link', url: '/ozivy', children: [{ kind: 'text', text: 'Ozivy' }] }],
                [{ kind: 'text', text: 'Semaglutida sintética' }],
                [{ kind: 'text', text: '1 mg' }],
                [{ kind: 'text', text: 'Não (diabetes tipo 2)' }]
              ],
              [
                [{ kind: 'link', url: '/semavy', children: [{ kind: 'text', text: 'Semavy' }] }],
                [{ kind: 'text', text: 'Semaglutida sintética' }],
                [{ kind: 'text', text: '1 mg' }],
                [{ kind: 'text', text: 'Não (diabetes tipo 2)' }]
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Em 2026, a Anvisa também registrou ' },
              {
                kind: 'link',
                url: 'https://revistaoeste.com/brasil/anvisa-aprova-14-novas-canetas-para-diabetes-e-obesidade/',
                children: [{ kind: 'text', text: 'outras canetas e os primeiros genéricos de semaglutida' }]
              },
              { kind: 'text', text: '.' }
            ]
          }
        ]
      },
      {
        heading: 'Quanto se perde de peso?',
        blocks: [
          {
            kind: 'table',
            header: [
              [{ kind: 'text', text: 'Medicamento' }],
              [{ kind: 'text', text: 'Estudo' }],
              [{ kind: 'text', text: 'Perda média de peso' }]
            ],
            rows: [
              [
                [{ kind: 'text', text: 'Semaglutida 2,4 mg' }],
                [
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2032183',
                    children: [{ kind: 'text', text: 'STEP 1' }]
                  },
                  { kind: 'text', text: ', 68 semanas' }
                ],
                [{ kind: 'text', text: '14,9%' }]
              ],
              [
                [{ kind: 'text', text: 'Tirzepatida 15 mg' }],
                [
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2206038',
                    children: [{ kind: 'text', text: 'SURMOUNT-1' }]
                  },
                  { kind: 'text', text: ', 72 semanas' }
                ],
                [{ kind: 'text', text: '20,9%' }]
              ],
              [
                [{ kind: 'text', text: 'Comparação direta' }],
                [
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2416394',
                    children: [{ kind: 'text', text: 'SURMOUNT-5' }]
                  },
                  { kind: 'text', text: ', 72 semanas' }
                ],
                [{ kind: 'text', text: '20,2% (tirzepatida) vs. 13,7% (semaglutida)' }]
              ],
              [
                [{ kind: 'text', text: 'Semaglutida 1 mg, em diabetes tipo 2' }],
                [
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1016/S0140-6736%2821%2900213-0',
                    children: [{ kind: 'text', text: 'STEP 2' }]
                  },
                  { kind: 'text', text: ', 68 semanas' }
                ],
                [{ kind: 'text', text: '7,0%' }]
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'São médias de estudos em que todos recebiam também orientação de dieta e exercício. Há pessoas que perdem mais e pessoas que perdem menos.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quem pode usar?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A indicação aprovada para tratamento do peso é para adultos com IMC ≥ 30 kg/m², ou IMC ≥ 27 kg/m² com pelo menos uma comorbidade relacionada ao peso, como hipertensão, diabetes tipo 2, colesterol alterado ou apneia do sono. A decisão é do médico, depois de avaliar histórico, exames e contraindicações.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Como saber qual tratamento é adequado?',
        blocks: [
          {
            kind: 'paragraph',
            children: [{ kind: 'text', text: 'Não existe a melhor caneta para todos. O médico considera:' }]
          },
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'text', text: 'diagnóstico (obesidade, sobrepeso com comorbidade, diabetes tipo 2);' }],
              [{ kind: 'text', text: 'quanto de peso é necessário perder;' }],
              [{ kind: 'text', text: 'doenças associadas, como doença cardiovascular ou apneia do sono;' }],
              [{ kind: 'text', text: 'tolerância a efeitos gastrointestinais;' }],
              [{ kind: 'text', text: 'custo mensal e possibilidade de manter o tratamento.' }]
            ]
          }
        ]
      },
      {
        heading: 'Quanto custam?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Preços públicos divulgados pelos fabricantes em seus programas, consultados em 09/10/2026:'
              }
            ]
          },
          {
            kind: 'table',
            header: [
              [{ kind: 'text', text: 'Caneta' }],
              [{ kind: 'text', text: 'Preço no programa do fabricante' }],
              [{ kind: 'text', text: 'Combos e condições' }]
            ],
            rows: [
              [
                [{ kind: 'link', url: '/wegovy', children: [{ kind: 'text', text: 'Wegovy' }] }],
                [
                  { kind: 'text', text: 'R$ 899 a R$ 1.749 por caneta (' },
                  {
                    kind: 'link',
                    url: 'https://www.programanovodia.com.br/produtos.html',
                    children: [{ kind: 'text', text: 'NovoDia' }]
                  },
                  { kind: 'text', text: ', e-commerce)' }
                ],
                [{ kind: 'text', text: 'Loja física: R$ 949 a R$ 1.849' }]
              ],
              [
                [{ kind: 'link', url: '/poviztra', children: [{ kind: 'text', text: 'Poviztra' }] }],
                [
                  { kind: 'text', text: 'R$ 445 a R$ 1.169 por caneta (' },
                  {
                    kind: 'link',
                    url: 'https://olhardigital.com.br/2026/08/22/medicina-e-saude/eurofarma-reduz-preco-do-poviztra-caneta-com-semaglutida-para-doses-de-17-mg-e-24-mg/',
                    children: [{ kind: 'text', text: 'EuroCuida' }]
                  },
                  { kind: 'text', text: ')' }
                ],
                [{ kind: 'text', text: 'Doses de 1,7 e 2,4 mg: exige compra nos 80 dias anteriores' }]
              ],
              [
                [{ kind: 'link', url: '/mounjaro', children: [{ kind: 'text', text: 'Mounjaro' }] }],
                [
                  { kind: 'text', text: 'R$ 1.422,52 a R$ 3.499 por caixa (' },
                  {
                    kind: 'link',
                    url: 'https://www.lillymelhorparavoce.com.br/medicamentos-participantes/mounjaro',
                    children: [{ kind: 'text', text: 'Lilly Melhor Para Você' }]
                  },
                  { kind: 'text', text: ', e-commerce)' }
                ],
                [{ kind: 'text', text: 'Combos de 2 caixas: R$ 1.125 a R$ 2.299 por caixa' }]
              ],
              [
                [{ kind: 'link', url: '/ozempic', children: [{ kind: 'text', text: 'Ozempic' }] }],
                [
                  { kind: 'text', text: 'R$ 975 a R$ 999 por caneta (' },
                  {
                    kind: 'link',
                    url: 'https://www.programanovodia.com.br/produtos.html',
                    children: [{ kind: 'text', text: 'NovoDia' }]
                  },
                  { kind: 'text', text: ', e-commerce)' }
                ],
                [{ kind: 'text', text: 'Loja física: R$ 1.075 a R$ 1.099' }]
              ],
              [
                [{ kind: 'link', url: '/ozivy', children: [{ kind: 'text', text: 'Ozivy' }] }],
                [
                  { kind: 'text', text: 'R$ 333 por caneta de 1 mg (' },
                  {
                    kind: 'link',
                    url: 'https://guiadafarmacia.com.br/ems-lanca-nova-condicao-de-precos-para-tratamento-com-ozivy/',
                    children: [{ kind: 'text', text: 'Vida + Leve' }]
                  },
                  { kind: 'text', text: ')' }
                ],
                [{ kind: 'text', text: 'No combo de 3 canetas por R$ 999' }]
              ],
              [
                [{ kind: 'link', url: '/semavy', children: [{ kind: 'text', text: 'Semavy' }] }],
                [
                  { kind: 'text', text: 'R$ 333 por caneta de 1 mg (' },
                  {
                    kind: 'link',
                    url: 'https://www.voysaude.com.br/blog/semavy-o-que-e-preco',
                    children: [{ kind: 'text', text: 'Mantecorp Saúde' }]
                  },
                  { kind: 'text', text: ')' }
                ],
                [{ kind: 'text', text: 'A partir de R$ 278,89 no portal do programa' }]
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Todos os programas exigem cadastro e receita médica. Os valores mudam com frequência: confira a página do fabricante antes de comprar.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Efeitos colaterais',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Os mais comuns são náusea, diarreia, vômito e constipação, principalmente no início e a cada aumento de dose. Subir a dose devagar, comer porções menores e evitar refeições gordurosas ajuda. Sinais de alerta: dor abdominal forte e persistente, vômitos que impedem a hidratação e alteração súbita da visão.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Perda de massa muscular',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Qualquer emagrecimento envolve perda de gordura e de massa magra. Manter boa ingestão de proteínas e fazer exercício de força durante o tratamento ajuda a preservar músculo. Esse acompanhamento faz parte do tratamento.'
              }
            ]
          }
        ]
      },
      {
        heading: 'E quando parar?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Sem o medicamento, a tendência é recuperar parte do peso. Na ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1111/dom.14725',
                children: [{ kind: 'text', text: 'extensão do STEP 1' }]
              },
              { kind: 'text', text: ', cerca de dois terços do peso perdido voltaram em um ano. No ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1001/jama.2023.24945',
                children: [{ kind: 'text', text: 'SURMOUNT-4' }]
              },
              { kind: 'text', text: ', quem interrompeu a tirzepatida recuperou 14,0% do peso em 52 semanas.' }
            ]
          }
        ]
      },
      {
        heading: 'Toda caneta precisa de receita?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Sim. Desde junho de 2025, a farmácia ' },
              {
                kind: 'link',
                url: 'https://portal.afya.com.br/saude/medicamentos-agonistas-glp-1-terao-retencao-de-receita',
                children: [{ kind: 'text', text: 'retém uma via da receita' }]
              },
              {
                kind: 'text',
                text: ', que vale 90 dias. Canetas vendidas sem receita, em redes sociais ou sem registro na Anvisa não têm garantia de origem, dose ou conservação.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Onde comprar depois da receita',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Com a receita, você pode comprar na farmácia de sua preferência ou em uma farmácia parceira disponível na plataforma da Medleve.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'O que são canetas emagrecedoras?',
        answer: [
          {
            kind: 'text',
            text: 'São medicamentos injetáveis semanais à base de semaglutida ou tirzepatida, que reduzem o apetite e aumentam a saciedade.'
          }
        ]
      },
      {
        question: 'Quais canetas estão disponíveis no Brasil?',
        answer: [
          {
            kind: 'text',
            text: 'Wegovy, Poviztra, Mounjaro, Ozempic, Ozivy e Semavy, entre outras registradas em 2026.'
          }
        ]
      },
      {
        question: 'Toda caneta emagrecedora usa semaglutida?',
        answer: [{ kind: 'text', text: 'Não. Mounjaro usa tirzepatida. As demais citadas usam semaglutida.' }]
      },
      {
        question: 'Qual a diferença entre semaglutida e tirzepatida?',
        answer: [
          {
            kind: 'text',
            text: 'A semaglutida age no receptor de GLP-1. A tirzepatida age em GIP e GLP-1 e levou a maior perda de peso na comparação direta.'
          }
        ]
      },
      {
        question: 'Toda caneta precisa de receita?',
        answer: [{ kind: 'text', text: 'Sim, com retenção de uma via pela farmácia.' }]
      },
      {
        question: 'Mounjaro, Wegovy, Ozempic, Poviztra, Semavy e Ozivy têm a mesma indicação?',
        answer: [
          {
            kind: 'text',
            text: 'Não. Wegovy, Poviztra e Mounjaro têm indicação para obesidade. Ozempic, Semavy e Ozivy são aprovados para diabetes tipo 2.'
          }
        ]
      },
      {
        question: 'Como saber qual tratamento é adequado?',
        answer: [
          {
            kind: 'text',
            text: 'Pela avaliação médica, que considera diagnóstico, comorbidades, contraindicações e custo.'
          }
        ]
      },
      {
        question: 'Quais são os principais efeitos colaterais?',
        answer: [{ kind: 'text', text: 'Náusea, diarreia, vômito e constipação.' }]
      },
      {
        question: 'É possível fazer avaliação médica online?',
        answer: [{ kind: 'text', text: 'Sim. Na Medleve, a consulta é por mensagem ou vídeo.' }]
      },
      {
        question: 'Onde comprar o medicamento após receber a receita?',
        answer: [
          { kind: 'text', text: 'Na farmácia de sua preferência ou em uma farmácia parceira disponível na plataforma.' }
        ]
      }
    ],
    sources: [
      { title: 'Wilding JPH et al. STEP 1. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2032183' },
      { title: 'Davies M et al. STEP 2. Lancet, 2021.', url: 'https://doi.org/10.1016/S0140-6736%2821%2900213-0' },
      { title: 'Jastreboff AM et al. SURMOUNT-1. NEJM, 2022.', url: 'https://doi.org/10.1056/NEJMoa2206038' },
      { title: 'Aronne LJ et al. SURMOUNT-5. NEJM, 2025.', url: 'https://doi.org/10.1056/NEJMoa2416394' },
      { title: 'Aronne LJ et al. SURMOUNT-4. JAMA, 2024.', url: 'https://doi.org/10.1001/jama.2023.24945' },
      {
        title: 'Wilding JPH et al. Extensão do STEP 1. Diabetes Obes Metab, 2022.',
        url: 'https://doi.org/10.1111/dom.14725'
      },
      {
        title: 'Revista Oeste. Anvisa aprova 14 novas canetas para diabetes e obesidade.',
        url: 'https://revistaoeste.com/brasil/anvisa-aprova-14-novas-canetas-para-diabetes-e-obesidade/'
      },
      {
        title: 'Afya. Medicamentos agonistas GLP-1 terão retenção de receita.',
        url: 'https://portal.afya.com.br/saude/medicamentos-agonistas-glp-1-terao-retencao-de-receita'
      }
    ],
    unresolved: [],
    article: {
      points: [
        'Só Wegovy, Poviztra e Mounjaro têm indicação de bula para obesidade.',
        'A perda média de peso nos estudos vai de cerca de 15% (semaglutida 2,4 mg) a 21% (tirzepatida 15 mg).',
        'Todas as canetas exigem receita com retenção.'
      ],
      info: {
        after: 'Toda caneta precisa de receita?',
        text: 'Caneta vendida sem receita, em redes sociais ou com rótulo em outro idioma é sinal de produto irregular. Confira o registro no site da Anvisa.'
      },
      tip: {
        after: 'Perda de massa muscular',
        text: 'Durante o tratamento, inclua uma fonte de proteína em cada refeição e faça exercício de força duas a três vezes por semana. Isso ajuda a preservar a massa muscular.'
      }
    }
  },
  'consulta-emagrecimento-online': {
    slug: 'consulta-emagrecimento-online',
    title: 'Consulta de emagrecimento online: como funciona, preço e receita | Medleve',
    description:
      'Consulta médica online para obesidade e sobrepeso, por mensagem ou vídeo. Veja como funciona a avaliação, o que o médico analisa e quando a receita digital é emitida.',
    h1: 'Consulta de emagrecimento online: como funciona',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A consulta de emagrecimento online é uma avaliação médica feita por telemedicina, por mensagem ou vídeo. O médico analisa histórico de saúde, peso, altura, medicamentos em uso e objetivos, e define se há indicação de tratamento para obesidade ou sobrepeso. Quando há indicação clínica, ele pode emitir uma receita digital, válida em todo o Brasil. A consulta não garante prescrição: a decisão é do médico.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'Como funciona a consulta na Medleve?',
        blocks: [
          {
            kind: 'list',
            ordered: true,
            items: [
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Questionário de saúde.' }] },
                {
                  kind: 'text',
                  text: ' Você informa peso, altura, histórico, doenças, medicamentos e tratamentos anteriores.'
                }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Escolha do atendimento.' }] },
                { kind: 'text', text: ' Por mensagem ou por vídeo.' }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Avaliação médica.' }] },
                { kind: 'text', text: ' O médico analisa as informações, tira dúvidas e pode pedir exames.' }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Conduta.' }] },
                {
                  kind: 'text',
                  text: ' Se houver indicação clínica, o médico define o tratamento e emite a receita digital.'
                }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Acompanhamento.' }] },
                { kind: 'text', text: ' Avaliação de resposta, efeitos adversos e ajustes de dose.' }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Consulta por mensagem ou por vídeo',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Por mensagem:' }] },
                { kind: 'text', text: ' você responde no seu tempo e recebe a avaliação do médico por escrito.' }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Por vídeo:' }] },
                { kind: 'text', text: ' atendimento em tempo real, em poucos minutos.' }
              ]
            ]
          }
        ]
      },
      {
        heading: 'O que o médico avalia?',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'text', text: 'IMC e, quando possível, circunferência da cintura.' }],
              [
                {
                  kind: 'text',
                  text: 'Doenças relacionadas ao peso: hipertensão, diabetes tipo 2, colesterol alterado, apneia do sono, gordura no fígado.'
                }
              ],
              [{ kind: 'text', text: 'Histórico de pancreatite, doença da vesícula e doenças da tireoide.' }],
              [{ kind: 'text', text: 'Gravidez, planejamento de gravidez e amamentação.' }],
              [{ kind: 'text', text: 'Medicamentos em uso e tratamentos anteriores para perda de peso.' }]
            ]
          }
        ]
      },
      {
        heading: 'Quem tem indicação de tratamento com medicamento?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'As bulas dos medicamentos aprovados para obesidade indicam o uso em adultos com IMC ≥ 30 kg/m², ou IMC ≥ 27 kg/m² com pelo menos uma comorbidade relacionada ao peso. Fora desses critérios, o tratamento se baseia em alimentação, atividade física e acompanhamento.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quais tratamentos podem ser considerados?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Mudanças de estilo de vida fazem parte de todo tratamento. Quando há indicação, o médico pode considerar medicamentos da classe '
              },
              { kind: 'link', url: '/glp-1', children: [{ kind: 'text', text: 'GLP-1' }] },
              { kind: 'text', text: ', como ' },
              { kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'semaglutida' }] },
              { kind: 'text', text: ' e ' },
              { kind: 'link', url: '/tirzepatida', children: [{ kind: 'text', text: 'tirzepatida' }] },
              { kind: 'text', text: '. Nos estudos, esses medicamentos levaram a perdas médias de ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2032183',
                children: [{ kind: 'text', text: '14,9%' }]
              },
              { kind: 'text', text: ' a ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2206038',
                children: [{ kind: 'text', text: '20,9%' }]
              },
              { kind: 'text', text: ' do peso em cerca de 70 semanas.' }
            ]
          }
        ]
      },
      {
        heading: 'A consulta garante prescrição?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Não. O médico só prescreve quando há indicação clínica e ausência de contraindicações. O paciente pode manifestar preferência por um medicamento, mas a escolha final é do profissional.'
              }
            ]
          }
        ]
      },
      {
        heading: 'A receita digital vale?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Sim. A telemedicina é regulamentada no Brasil pela ' },
              {
                kind: 'link',
                url: 'https://sistemas.cfm.org.br/normas/visualizar/resolucoes/BR/2022/2314',
                children: [{ kind: 'text', text: 'Resolução CFM nº 2.314/2022' }]
              },
              { kind: 'text', text: '. Para os agonistas de GLP-1, a ' },
              {
                kind: 'link',
                url: 'https://sincofarmasp.com.br/2026/01/19/anvisa-estabelece-novas-regras-para-prescricao-e-dispensacao-de-medicamentos-agonistas-de-glp-1/',
                children: [{ kind: 'text', text: 'receita digital é aceita' }]
              },
              {
                kind: 'text',
                text: ' quando tem assinatura eletrônica válida e atende às exigências da Anvisa. A receita vale 90 dias e uma via fica retida na farmácia.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Onde comprar o medicamento?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A Medleve é uma plataforma de saúde digital e atua como intermediadora. Depois da prescrição, você pode comprar na farmácia de sua preferência ou usar uma farmácia parceira disponível na plataforma.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quem são os médicos?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Os atendimentos são feitos por médicos com CRM ativo. Conheça a ' },
              { kind: 'link', url: '/equipe-medica', children: [{ kind: 'text', text: 'equipe médica' }] },
              { kind: 'text', text: '. O conteúdo médico do site é revisado pelo ' },
              {
                kind: 'link',
                url: '/equipe-medica/carlos-seraphim',
                children: [{ kind: 'text', text: 'Dr. Carlos Seraphim' }]
              },
              { kind: 'text', text: ', endocrinologista.' }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'Como funciona uma consulta para emagrecimento online?',
        answer: [
          {
            kind: 'text',
            text: 'Você preenche um questionário de saúde, é atendido por um médico por mensagem ou vídeo e recebe a conduta. Se houver indicação, a receita é digital.'
          }
        ]
      },
      { question: 'A consulta pode ser feita por mensagem?', answer: [{ kind: 'text', text: 'Sim.' }] },
      { question: 'A consulta pode ser feita por vídeo?', answer: [{ kind: 'text', text: 'Sim, em tempo real.' }] },
      {
        question: 'Quanto tempo demora para falar com um médico por vídeo?',
        answer: [{ kind: 'text', text: 'Em poucos minutos.' }]
      },
      {
        question: 'A consulta garante prescrição?',
        answer: [{ kind: 'text', text: 'Não. A prescrição depende de indicação clínica e é decisão do médico.' }]
      },
      {
        question: 'É possível receber receita digital?',
        answer: [{ kind: 'text', text: 'Sim, quando o médico indica o tratamento.' }]
      },
      {
        question: 'O médico pode avaliar tratamentos com GLP-1?',
        answer: [
          {
            kind: 'text',
            text: 'Sim. Ele avalia se medicamentos como semaglutida ou tirzepatida são adequados ao seu caso.'
          }
        ]
      },
      {
        question: 'Quais informações são avaliadas pelo médico?',
        answer: [
          {
            kind: 'text',
            text: 'Peso, altura, histórico de saúde, doenças associadas, medicamentos em uso, contraindicações e objetivos.'
          }
        ]
      },
      {
        question: 'Preciso fazer acompanhamento?',
        answer: [
          { kind: 'text', text: 'Sim. O acompanhamento permite ajustar doses, monitorar efeitos e avaliar resultados.' }
        ]
      },
      {
        question: 'Onde compro o medicamento depois da consulta?',
        answer: [
          { kind: 'text', text: 'Na farmácia de sua preferência ou em uma farmácia parceira disponível na plataforma.' }
        ]
      }
    ],
    sources: [
      {
        title: 'Conselho Federal de Medicina. Resolução CFM nº 2.314/2022 (telemedicina).',
        url: 'https://sistemas.cfm.org.br/normas/visualizar/resolucoes/BR/2022/2314'
      },
      {
        title: 'Sincofarma-SP. Novas regras para prescrição e dispensação de agonistas de GLP-1.',
        url: 'https://sincofarmasp.com.br/2026/01/19/anvisa-estabelece-novas-regras-para-prescricao-e-dispensacao-de-medicamentos-agonistas-de-glp-1/'
      },
      { title: 'Wilding JPH et al. STEP 1. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2032183' },
      { title: 'Jastreboff AM et al. SURMOUNT-1. NEJM, 2022.', url: 'https://doi.org/10.1056/NEJMoa2206038' },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' }
    ],
    unresolved: [],
    article: {
      points: [
        'A consulta é feita por mensagem ou vídeo, com médicos com CRM ativo.',
        'A receita digital é emitida apenas quando há indicação clínica.',
        'Depois da receita, você compra na farmácia que preferir.'
      ],
      info: {
        after: 'A receita digital vale?',
        text: 'A receita de GLP-1 vale 90 dias, e a farmácia retém uma via a cada compra. Para tratamento contínuo, o médico indica o uso contínuo na receita.'
      },
      tip: {
        after: 'O que o médico avalia?',
        text: 'Antes da consulta, tenha em mãos peso e altura atuais, a lista dos remédios que você usa e, se tiver, exames recentes de glicemia, colesterol e função dos rins e do fígado.'
      }
    }
  },
  'glp-1': {
    slug: 'glp-1',
    title: 'GLP-1: o que é, como funciona e quais medicamentos existem no Brasil | Medleve',
    description:
      'Entenda o que é GLP-1, como agem semaglutida e tirzepatida, quais marcas estão aprovadas pela Anvisa e o que os principais estudos mostram sobre perda de peso.',
    h1: 'GLP-1: o que é, como funciona e quais medicamentos existem no Brasil',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'GLP-1 é um hormônio produzido no intestino após as refeições. Ele estimula a liberação de insulina, retarda o esvaziamento do estômago e aumenta a saciedade. Os medicamentos chamados de "GLP-1" imitam essa ação por vários dias. No Brasil, os principais são a semaglutida (Wegovy, Poviztra, Ozempic, Ozivy, Semavy) e a tirzepatida (Mounjaro), todos de aplicação semanal e vendidos com retenção de receita.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'O que é GLP-1?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'GLP-1 é a sigla em inglês para peptídeo semelhante ao glucagon tipo 1. O hormônio natural dura poucos minutos no sangue. Os medicamentos dessa classe são moléculas modificadas para resistir à degradação e agir por cerca de uma semana.'
              }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Eles foram desenvolvidos para o diabetes tipo 2. A perda de peso observada nos estudos levou a programas de pesquisa específicos para obesidade, e hoje há medicamentos com as duas indicações.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Como os medicamentos GLP-1 funcionam?',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'No cérebro:' }] },
                { kind: 'text', text: ' aumentam a saciedade e reduzem a fome e o interesse por comida.' }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'No estômago:' }] },
                { kind: 'text', text: ' retardam o esvaziamento gástrico, prolongando a sensação de estômago cheio.' }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'No pâncreas:' }] },
                { kind: 'text', text: ' estimulam a insulina e reduzem o glucagon de forma dependente da glicose.' }
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'A ' },
              { kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'semaglutida' }] },
              { kind: 'text', text: ' atua apenas no receptor de GLP-1. A ' },
              { kind: 'link', url: '/tirzepatida', children: [{ kind: 'text', text: 'tirzepatida' }] },
              { kind: 'text', text: ' atua em dois receptores, GIP e GLP-1.' }
            ]
          }
        ]
      },
      {
        heading: 'Quais medicamentos GLP-1 existem no Brasil?',
        blocks: [
          {
            kind: 'table',
            header: [
              [{ kind: 'text', text: 'Medicamento' }],
              [{ kind: 'text', text: 'Princípio ativo' }],
              [{ kind: 'text', text: 'Fabricante' }],
              [{ kind: 'text', text: 'Indicação aprovada pela Anvisa' }]
            ],
            rows: [
              [
                [{ kind: 'link', url: '/wegovy', children: [{ kind: 'text', text: 'Wegovy' }] }],
                [{ kind: 'text', text: 'Semaglutida 2,4 mg' }],
                [{ kind: 'text', text: 'Novo Nordisk' }],
                [
                  {
                    kind: 'text',
                    text: 'Obesidade e sobrepeso com comorbidade; adolescentes a partir de 12 anos; redução de risco cardiovascular'
                  }
                ]
              ],
              [
                [{ kind: 'link', url: '/poviztra', children: [{ kind: 'text', text: 'Poviztra' }] }],
                [{ kind: 'text', text: 'Semaglutida 2,4 mg' }],
                [{ kind: 'text', text: 'Novo Nordisk (parceria comercial com a Eurofarma)' }],
                [{ kind: 'text', text: 'Obesidade e sobrepeso com comorbidade; adolescentes a partir de 12 anos' }]
              ],
              [
                [{ kind: 'link', url: '/ozempic', children: [{ kind: 'text', text: 'Ozempic' }] }],
                [{ kind: 'text', text: 'Semaglutida até 1 mg' }],
                [{ kind: 'text', text: 'Novo Nordisk' }],
                [{ kind: 'text', text: 'Diabetes tipo 2' }]
              ],
              [
                [{ kind: 'link', url: '/ozivy', children: [{ kind: 'text', text: 'Ozivy' }] }],
                [{ kind: 'text', text: 'Semaglutida sintética até 1 mg' }],
                [{ kind: 'text', text: 'EMS' }],
                [{ kind: 'text', text: 'Diabetes tipo 2' }]
              ],
              [
                [{ kind: 'link', url: '/semavy', children: [{ kind: 'text', text: 'Semavy' }] }],
                [{ kind: 'text', text: 'Semaglutida sintética até 1 mg' }],
                [{ kind: 'text', text: 'Hypera Pharma' }],
                [{ kind: 'text', text: 'Diabetes tipo 2' }]
              ],
              [
                [{ kind: 'link', url: '/mounjaro', children: [{ kind: 'text', text: 'Mounjaro' }] }],
                [{ kind: 'text', text: 'Tirzepatida até 15 mg' }],
                [{ kind: 'text', text: 'Eli Lilly' }],
                [
                  {
                    kind: 'text',
                    text: 'Diabetes tipo 2; obesidade e sobrepeso com comorbidade; apneia obstrutiva do sono com obesidade'
                  }
                ]
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A patente da semaglutida expirou no Brasil em 20 de março de 2026. Desde então, a Anvisa registrou novas canetas, incluindo '
              },
              {
                kind: 'link',
                url: 'https://www.bemparana.com.br/bem-estar/nova-caneta-de-semaglutida-sintetica-produzida-no-brasil-e-a-semavy-da-hypera-pharma/',
                children: [{ kind: 'text', text: 'Ozivy e Semavy' }]
              },
              { kind: 'text', text: ' e os ' },
              {
                kind: 'link',
                url: 'https://revistaoeste.com/brasil/anvisa-aprova-14-novas-canetas-para-diabetes-e-obesidade/',
                children: [{ kind: 'text', text: 'primeiros genéricos' }]
              },
              {
                kind: 'text',
                text: '. A lista acima cobre as marcas com página própria na Medleve; a bula vigente de cada produto está no '
              },
              {
                kind: 'link',
                url: 'https://consultas.anvisa.gov.br/#/bulario/',
                children: [{ kind: 'text', text: 'Bulário Eletrônico da Anvisa' }]
              },
              { kind: 'text', text: '.' }
            ]
          }
        ]
      },
      {
        heading: 'O que os estudos mostram sobre perda de peso?',
        blocks: [
          {
            kind: 'table',
            header: [
              [{ kind: 'text', text: 'Estudo' }],
              [{ kind: 'text', text: 'Medicamento e dose' }],
              [{ kind: 'text', text: 'Duração' }],
              [{ kind: 'text', text: 'Perda média de peso' }],
              [{ kind: 'text', text: 'Placebo' }]
            ],
            rows: [
              [
                [
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2032183',
                    children: [{ kind: 'text', text: 'STEP 1' }]
                  },
                  { kind: 'text', text: ' (NEJM, 2021)' }
                ],
                [{ kind: 'text', text: 'Semaglutida 2,4 mg' }],
                [{ kind: 'text', text: '68 semanas' }],
                [{ kind: 'text', text: '14,9%' }],
                [{ kind: 'text', text: '2,4%' }]
              ],
              [
                [
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2206038',
                    children: [{ kind: 'text', text: 'SURMOUNT-1' }]
                  },
                  { kind: 'text', text: ' (NEJM, 2022)' }
                ],
                [{ kind: 'text', text: 'Tirzepatida 5, 10 e 15 mg' }],
                [{ kind: 'text', text: '72 semanas' }],
                [{ kind: 'text', text: '15,0%, 19,5% e 20,9%' }],
                [{ kind: 'text', text: '3,1%' }]
              ],
              [
                [
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2416394',
                    children: [{ kind: 'text', text: 'SURMOUNT-5' }]
                  },
                  { kind: 'text', text: ' (NEJM, 2025)' }
                ],
                [{ kind: 'text', text: 'Tirzepatida vs. semaglutida 2,4 mg' }],
                [{ kind: 'text', text: '72 semanas' }],
                [{ kind: 'text', text: '20,2% vs. 13,7%' }],
                [{ kind: 'text', text: 'sem placebo' }]
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Todos os participantes desses estudos também receberam orientação de alimentação e atividade física. Os números são médias: a resposta individual varia.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Todo GLP-1 serve para emagrecimento?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Não. Cada medicamento tem uma indicação de bula. Wegovy, Poviztra e Mounjaro têm indicação aprovada para obesidade e sobrepeso com comorbidade. Ozempic, Ozivy e Semavy são aprovados para diabetes tipo 2, em doses de até 1 mg. O uso fora da indicação de bula é uma decisão do médico, tomada caso a caso.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Efeitos colaterais mais comuns',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Os mais frequentes são gastrointestinais: náusea, diarreia, vômito e constipação. No STEP 1, '
              },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2032183',
                children: [{ kind: 'text', text: 'náusea ocorreu em 44,2% e diarreia em 31,5% dos participantes' }]
              },
              {
                kind: 'text',
                text: ' com semaglutida 2,4 mg, em geral de intensidade leve a moderada e mais frequentes durante o aumento de dose. Eventos menos comuns e que exigem atenção incluem pancreatite e doenças da vesícula biliar.'
              }
            ]
          }
        ]
      },
      {
        heading: 'O que acontece ao parar o tratamento?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A obesidade é uma doença crônica, e o efeito do medicamento depende da continuidade. Na '
              },
              {
                kind: 'link',
                url: 'https://doi.org/10.1111/dom.14725',
                children: [{ kind: 'text', text: 'extensão do STEP 1' }]
              },
              {
                kind: 'text',
                text: ', um ano após a suspensão os participantes haviam recuperado cerca de dois terços do peso perdido. No '
              },
              {
                kind: 'link',
                url: 'https://doi.org/10.1001/jama.2023.24945',
                children: [{ kind: 'text', text: 'SURMOUNT-4' }]
              },
              {
                kind: 'text',
                text: ', quem trocou a tirzepatida por placebo recuperou 14,0% do peso em 52 semanas, enquanto quem continuou perdeu mais 5,5%. A decisão de manter, reduzir ou interromper deve ser tomada com o médico.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Como é a prescrição no Brasil?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Desde junho de 2025, os agonistas de GLP-1 são vendidos ' },
              {
                kind: 'link',
                url: 'https://portal.afya.com.br/saude/medicamentos-agonistas-glp-1-terao-retencao-de-receita',
                children: [{ kind: 'text', text: 'com retenção de receita' }]
              },
              { kind: 'text', text: ' (RDC 973/2025 da Anvisa). A receita é emitida em duas vias e vale 90 dias. A ' },
              {
                kind: 'link',
                url: 'https://sincofarmasp.com.br/2026/01/19/anvisa-estabelece-novas-regras-para-prescricao-e-dispensacao-de-medicamentos-agonistas-de-glp-1/',
                children: [{ kind: 'text', text: 'receita digital é aceita' }]
              },
              { kind: 'text', text: ' quando tem assinatura eletrônica válida e atende às exigências da Anvisa.' }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Na Medleve, a ' },
              {
                kind: 'link',
                url: '/consulta-emagrecimento-online',
                children: [{ kind: 'text', text: 'consulta é online' }]
              },
              {
                kind: 'text',
                text: ', por mensagem ou vídeo. O médico avalia o caso e, se houver indicação clínica, emite a receita digital.'
              }
            ]
          }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'O que é GLP-1?',
        answer: [
          {
            kind: 'text',
            text: 'É um hormônio intestinal que aumenta a saciedade, retarda o esvaziamento do estômago e ajuda a controlar a glicose. Os medicamentos GLP-1 imitam essa ação por cerca de uma semana.'
          }
        ]
      },
      {
        question: 'Para que servem os medicamentos GLP-1?',
        answer: [
          {
            kind: 'text',
            text: 'Para tratar diabetes tipo 2 e, em alguns casos, obesidade ou sobrepeso com comorbidade. A indicação depende do medicamento e da dose.'
          }
        ]
      },
      {
        question: 'Quais medicamentos GLP-1 existem no Brasil?',
        answer: [
          {
            kind: 'text',
            text: 'Entre os principais estão Wegovy, Poviztra, Ozempic, Ozivy e Semavy (semaglutida) e Mounjaro (tirzepatida). Há também genéricos de semaglutida registrados em 2026.'
          }
        ]
      },
      {
        question: 'Qual a diferença entre semaglutida e tirzepatida?',
        answer: [
          {
            kind: 'text',
            text: 'A semaglutida ativa o receptor de GLP-1. A tirzepatida ativa GIP e GLP-1. No estudo SURMOUNT-5, a perda média de peso foi de 20,2% com tirzepatida e 13,7% com semaglutida.'
          }
        ]
      },
      {
        question: 'Todo GLP-1 serve para emagrecimento?',
        answer: [
          {
            kind: 'text',
            text: 'Não. Wegovy, Poviztra e Mounjaro têm indicação para obesidade. Ozempic, Ozivy e Semavy são aprovados para diabetes tipo 2.'
          }
        ]
      },
      {
        question: 'GLP-1 precisa de receita?',
        answer: [
          {
            kind: 'text',
            text: 'Sim. A venda exige receita em duas vias, com retenção de uma delas pela farmácia. A receita vale 90 dias.'
          }
        ]
      },
      {
        question: 'Quais são os efeitos colaterais mais comuns?',
        answer: [
          {
            kind: 'text',
            text: 'Náusea, diarreia, vômito e constipação, principalmente no início e nos aumentos de dose.'
          }
        ]
      },
      {
        question: 'Mounjaro é GLP-1?',
        answer: [
          {
            kind: 'text',
            text: 'Mounjaro é tirzepatida, um agonista duplo de GIP e GLP-1. Costuma ser incluído na classe dos "GLP-1" por agir também nesse receptor.'
          }
        ]
      },
      {
        question: 'Wegovy é GLP-1?',
        answer: [
          {
            kind: 'text',
            text: 'Sim. Wegovy é semaglutida 2,4 mg, um agonista do receptor de GLP-1 aprovado para obesidade.'
          }
        ]
      },
      {
        question: 'Ozempic é GLP-1?',
        answer: [
          { kind: 'text', text: 'Sim. Ozempic é semaglutida em doses de até 1 mg, aprovada para diabetes tipo 2.' }
        ]
      },
      {
        question: 'Poviztra, Semavy e Ozivy são GLP-1?',
        answer: [
          {
            kind: 'text',
            text: 'Sim, os três contêm semaglutida. Poviztra é aprovado para obesidade; Semavy e Ozivy, para diabetes tipo 2.'
          }
        ]
      }
    ],
    sources: [
      {
        title: 'Wilding JPH et al. Once-Weekly Semaglutide in Adults with Overweight or Obesity (STEP 1). NEJM, 2021.',
        url: 'https://doi.org/10.1056/NEJMoa2032183'
      },
      {
        title: 'Jastreboff AM et al. Tirzepatide Once Weekly for the Treatment of Obesity (SURMOUNT-1). NEJM, 2022.',
        url: 'https://doi.org/10.1056/NEJMoa2206038'
      },
      {
        title:
          'Aronne LJ et al. Tirzepatide as Compared with Semaglutide for the Treatment of Obesity (SURMOUNT-5). NEJM, 2025.',
        url: 'https://doi.org/10.1056/NEJMoa2416394'
      },
      {
        title:
          'Wilding JPH et al. Weight regain and cardiometabolic effects after withdrawal of semaglutide (extensão do STEP 1). Diabetes Obes Metab, 2022.',
        url: 'https://doi.org/10.1111/dom.14725'
      },
      {
        title:
          'Aronne LJ et al. Continued Treatment With Tirzepatide for Maintenance of Weight Reduction (SURMOUNT-4). JAMA, 2024.',
        url: 'https://doi.org/10.1001/jama.2023.24945'
      },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' },
      {
        title: 'Afya. Medicamentos agonistas GLP-1 terão retenção de receita.',
        url: 'https://portal.afya.com.br/saude/medicamentos-agonistas-glp-1-terao-retencao-de-receita'
      },
      {
        title: 'Sincofarma-SP. Novas regras para prescrição e dispensação de agonistas de GLP-1.',
        url: 'https://sincofarmasp.com.br/2026/01/19/anvisa-estabelece-novas-regras-para-prescricao-e-dispensacao-de-medicamentos-agonistas-de-glp-1/'
      }
    ],
    unresolved: [],
    article: {
      points: [
        'GLP-1 é um hormônio intestinal que aumenta a saciedade e ajuda a controlar a glicose.',
        'Só Wegovy, Poviztra e Mounjaro têm indicação de bula para obesidade.',
        'No estudo SURMOUNT-5, a perda média de peso foi de 20,2% com tirzepatida e 13,7% com semaglutida.',
        'A venda exige receita em duas vias, válida por 90 dias.'
      ],
      info: {
        after: 'Todo GLP-1 serve para emagrecimento?',
        text: '"Caneta emagrecedora" é um nome popular. Ozempic, Ozivy e Semavy são aprovados para diabetes tipo 2, e não para obesidade.'
      },
      tip: {
        after: 'Efeitos colaterais mais comuns',
        text: 'Nas primeiras semanas e depois de cada aumento de dose, prefira refeições menores, coma devagar e pare ao sentir saciedade. Frituras e alimentos muito gordurosos costumam piorar a náusea.'
      }
    }
  },
  'mounjaro-ou-ozempic': {
    slug: 'mounjaro-ou-ozempic',
    title: 'Mounjaro ou Ozempic: diferenças, indicações e resultados | Medleve',
    description:
      'Mounjaro é tirzepatida; Ozempic é semaglutida de até 1 mg. Compare indicações aprovadas pela Anvisa, resultados do estudo SURPASS-2, doses e preço.',
    h1: 'Mounjaro ou Ozempic: quais são as diferenças?',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Mounjaro (tirzepatida) e Ozempic (semaglutida) são canetas semanais de moléculas diferentes. Os dois são aprovados para diabetes tipo 2. Só o Mounjaro tem indicação de bula para obesidade ou sobrepeso com comorbidade. No estudo SURPASS-2, em pessoas com diabetes tipo 2, a tirzepatida reduziu mais a hemoglobina glicada e o peso do que a semaglutida 1 mg.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'Comparação',
        blocks: [
          {
            kind: 'table',
            header: [[], [{ kind: 'text', text: 'Mounjaro' }], [{ kind: 'text', text: 'Ozempic' }]],
            rows: [
              [
                [{ kind: 'text', text: 'Princípio ativo' }],
                [{ kind: 'link', url: '/tirzepatida', children: [{ kind: 'text', text: 'Tirzepatida' }] }],
                [{ kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'Semaglutida' }] }]
              ],
              [
                [{ kind: 'text', text: 'Mecanismo' }],
                [{ kind: 'text', text: 'GIP + GLP-1' }],
                [{ kind: 'text', text: 'GLP-1' }]
              ],
              [
                [{ kind: 'text', text: 'Fabricante' }],
                [{ kind: 'text', text: 'Eli Lilly' }],
                [{ kind: 'text', text: 'Novo Nordisk' }]
              ],
              [
                [{ kind: 'text', text: 'Indicações aprovadas' }],
                [
                  {
                    kind: 'text',
                    text: 'Diabetes tipo 2; obesidade/sobrepeso com comorbidade; apneia do sono com obesidade'
                  }
                ],
                [{ kind: 'text', text: 'Diabetes tipo 2 (inclui risco cardiovascular e doença renal)' }]
              ],
              [
                [{ kind: 'text', text: 'Doses' }],
                [{ kind: 'text', text: '2,5 a 15 mg/semana' }],
                [{ kind: 'text', text: '0,25 a 1 mg/semana' }]
              ],
              [
                [{ kind: 'text', text: 'Preço no programa do fabricante' }],
                [
                  {
                    kind: 'link',
                    url: 'https://www.lillymelhorparavoce.com.br/medicamentos-participantes/mounjaro',
                    children: [{ kind: 'text', text: 'R$ 1.422,52 a R$ 3.499,00' }]
                  },
                  { kind: 'text', text: ' por caixa (Lilly Melhor Para Você, e-commerce)' }
                ],
                [
                  {
                    kind: 'link',
                    url: 'https://www.programanovodia.com.br/produtos.html',
                    children: [{ kind: 'text', text: 'R$ 975 a R$ 999' }]
                  },
                  { kind: 'text', text: ' por caneta (NovoDia, e-commerce)' }
                ]
              ]
            ]
          }
        ]
      },
      {
        heading: 'O que mostrou a comparação direta?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'O ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2107519',
                children: [{ kind: 'text', text: 'SURPASS-2' }]
              },
              {
                kind: 'text',
                text: ' comparou tirzepatida (5, 10 e 15 mg) com semaglutida 1 mg em 1.879 adultos com diabetes tipo 2, por 40 semanas. A hemoglobina glicada caiu 2,01, 2,24 e 2,30 pontos com tirzepatida, contra 1,86 com semaglutida. A perda de peso foi de 7,6 kg, 9,3 kg e 11,2 kg, contra 5,7 kg.'
              }
            ]
          }
        ]
      },
      {
        heading: 'E para emagrecimento?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'O Mounjaro tem indicação aprovada para obesidade. O Ozempic não tem: a semaglutida aprovada para esse uso é a de 2,4 mg, vendida como '
              },
              { kind: 'link', url: '/wegovy', children: [{ kind: 'text', text: 'Wegovy' }] },
              { kind: 'text', text: ' e ' },
              { kind: 'link', url: '/poviztra', children: [{ kind: 'text', text: 'Poviztra' }] },
              { kind: 'text', text: '. Por isso, a comparação mais adequada para perda de peso é ' },
              { kind: 'link', url: '/mounjaro-ou-wegovy', children: [{ kind: 'text', text: 'Mounjaro ou Wegovy' }] },
              { kind: 'text', text: '.' }
            ]
          }
        ]
      },
      {
        heading: 'Onde o Ozempic tem mais evidência',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'O Ozempic tem estudos de desfechos em diabetes tipo 2: redução de eventos cardiovasculares no '
              },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa1607141',
                children: [{ kind: 'text', text: 'SUSTAIN-6' }]
              },
              { kind: 'text', text: ' e de progressão de doença renal no ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2403347',
                children: [{ kind: 'text', text: 'FLOW' }]
              },
              { kind: 'text', text: '.' }
            ]
          }
        ]
      },
      {
        heading: 'Efeitos colaterais',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Semelhantes: náusea, diarreia, vômito e constipação. Em pessoas com diabetes que usam insulina ou sulfonilureias, há risco de hipoglicemia com os dois.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'Qual a diferença entre Mounjaro e Ozempic?',
        answer: [
          {
            kind: 'text',
            text: 'Mounjaro é tirzepatida; Ozempic é semaglutida. Têm mecanismos, doses e indicações diferentes.'
          }
        ]
      },
      {
        question: 'Os dois são indicados para obesidade?',
        answer: [
          {
            kind: 'text',
            text: 'Não. Só o Mounjaro tem essa indicação na bula. Ozempic é aprovado para diabetes tipo 2.'
          }
        ]
      },
      {
        question: 'Qual controla melhor o diabetes?',
        answer: [
          {
            kind: 'text',
            text: 'No SURPASS-2, a tirzepatida reduziu mais a hemoglobina glicada do que a semaglutida 1 mg.'
          }
        ]
      },
      { question: 'Qual custa mais?', answer: [{ kind: 'text', text: 'O Mounjaro.' }] },
      {
        question: 'Os efeitos colaterais são iguais?',
        answer: [{ kind: 'text', text: 'São parecidos, principalmente gastrointestinais.' }]
      },
      {
        question: 'É possível trocar de Ozempic para Mounjaro?',
        answer: [{ kind: 'text', text: 'Sim, com orientação médica.' }]
      }
    ],
    sources: [
      { title: 'Frías JP et al. SURPASS-2. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2107519' },
      { title: 'Marso SP et al. SUSTAIN-6. NEJM, 2016.', url: 'https://doi.org/10.1056/NEJMoa1607141' },
      { title: 'Perkovic V et al. FLOW. NEJM, 2024.', url: 'https://doi.org/10.1056/NEJMoa2403347' },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' }
    ],
    unresolved: [],
    article: {
      points: [
        'Mounjaro é tirzepatida; Ozempic é semaglutida de até 1 mg.',
        'Só o Mounjaro tem indicação de bula para obesidade.',
        'No SURPASS-2, a tirzepatida reduziu mais a glicada e o peso do que a semaglutida 1 mg.'
      ],
      info: {
        after: 'E para emagrecimento?',
        text: 'Para perda de peso, a comparação adequada do Mounjaro é com o Wegovy, a semaglutida aprovada para obesidade.'
      },
      tip: {
        after: 'Efeitos colaterais',
        text: 'Se você tem diabetes, meça a glicemia com mais frequência nas primeiras semanas depois de iniciar ou trocar o medicamento e leve os registros para a consulta.'
      }
    }
  },
  'mounjaro-ou-ozivy': {
    slug: 'mounjaro-ou-ozivy',
    title: 'Mounjaro ou Ozivy: diferenças, indicações e preço | Medleve',
    description:
      'Mounjaro é tirzepatida, com indicação para obesidade e diabetes. Ozivy é semaglutida sintética nacional, aprovada para diabetes tipo 2. Compare indicações, doses e preço.',
    h1: 'Mounjaro ou Ozivy: quais são as diferenças?',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Mounjaro e Ozivy são canetas semanais com princípios ativos diferentes. Mounjaro é tirzepatida, da Eli Lilly, aprovada para diabetes tipo 2, obesidade ou sobrepeso com comorbidade e apneia do sono. Ozivy é semaglutida sintética, da EMS, aprovada exclusivamente para diabetes tipo 2, em doses de até 1 mg. Ozivy custa bem menos, mas não tem indicação de bula para emagrecimento.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'Comparação',
        blocks: [
          {
            kind: 'table',
            header: [[], [{ kind: 'text', text: 'Mounjaro' }], [{ kind: 'text', text: 'Ozivy' }]],
            rows: [
              [
                [{ kind: 'text', text: 'Princípio ativo' }],
                [{ kind: 'link', url: '/tirzepatida', children: [{ kind: 'text', text: 'Tirzepatida' }] }],
                [
                  { kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'Semaglutida' }] },
                  { kind: 'text', text: ' sintética' }
                ]
              ],
              [
                [{ kind: 'text', text: 'Fabricante' }],
                [{ kind: 'text', text: 'Eli Lilly' }],
                [{ kind: 'text', text: 'EMS (Brasil)' }]
              ],
              [
                [{ kind: 'text', text: 'Indicações aprovadas' }],
                [
                  {
                    kind: 'text',
                    text: 'Diabetes tipo 2; obesidade/sobrepeso com comorbidade; apneia do sono com obesidade'
                  }
                ],
                [{ kind: 'text', text: 'Diabetes tipo 2' }]
              ],
              [
                [{ kind: 'text', text: 'Doses' }],
                [{ kind: 'text', text: '2,5 a 15 mg/semana' }],
                [{ kind: 'text', text: '0,25 a 1 mg/semana' }]
              ],
              [
                [{ kind: 'text', text: 'Preço no programa do fabricante' }],
                [
                  {
                    kind: 'link',
                    url: 'https://www.lillymelhorparavoce.com.br/medicamentos-participantes/mounjaro',
                    children: [{ kind: 'text', text: 'R$ 1.422,52 a R$ 3.499,00' }]
                  },
                  { kind: 'text', text: ' por caixa (Lilly Melhor Para Você, e-commerce)' }
                ],
                [
                  {
                    kind: 'link',
                    url: 'https://guiadafarmacia.com.br/ems-lanca-nova-condicao-de-precos-para-tratamento-com-ozivy/',
                    children: [{ kind: 'text', text: '3 canetas de 1 mg por R$ 999' }]
                  },
                  { kind: 'text', text: ' (programa Vida + Leve)' }
                ]
              ]
            ]
          }
        ]
      },
      {
        heading: 'O que dizem os estudos?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Não há estudo comparando Mounjaro e Ozivy. A comparação disponível é entre as moléculas: no '
              },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2107519',
                children: [{ kind: 'text', text: 'SURPASS-2' }]
              },
              {
                kind: 'text',
                text: ', em diabetes tipo 2, a tirzepatida reduziu mais a glicada e o peso do que a semaglutida 1 mg (7,6 a 11,2 kg contra 5,7 kg). Esse estudo usou a semaglutida de referência, não o Ozivy.'
              }
            ]
          }
        ]
      },
      {
        heading: 'E para emagrecimento?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'O Mounjaro tem indicação aprovada. O ' },
              { kind: 'link', url: '/ozivy', children: [{ kind: 'text', text: 'Ozivy' }] },
              {
                kind: 'text',
                text: ' não tem, e sua dose máxima (1 mg) é menor que a da semaglutida aprovada para obesidade (2,4 mg).'
              }
            ]
          }
        ]
      },
      {
        heading: 'Conservação',
        blocks: [
          {
            kind: 'paragraph',
            children: [{ kind: 'text', text: 'O Ozivy deve permanecer na geladeira antes e depois do primeiro uso.' }]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'Qual a diferença entre Mounjaro e Ozivy?',
        answer: [
          {
            kind: 'text',
            text: 'São moléculas diferentes: tirzepatida e semaglutida. Mounjaro tem indicação para obesidade; Ozivy, apenas para diabetes tipo 2.'
          }
        ]
      },
      {
        question: 'Ozivy é um genérico do Mounjaro?',
        answer: [{ kind: 'text', text: 'Não. São princípios ativos diferentes.' }]
      },
      { question: 'Os dois são indicados para obesidade?', answer: [{ kind: 'text', text: 'Não. Só o Mounjaro.' }] },
      { question: 'Qual custa menos?', answer: [{ kind: 'text', text: 'O Ozivy.' }] },
      {
        question: 'Existe estudo comparando os dois?',
        answer: [{ kind: 'text', text: 'Não. Existe comparação entre tirzepatida e semaglutida de referência.' }]
      },
      {
        question: 'Qual é mais adequado para mim?',
        answer: [{ kind: 'text', text: 'Depende do diagnóstico e da avaliação médica.' }]
      }
    ],
    sources: [
      { title: 'Frías JP et al. SURPASS-2. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2107519' },
      {
        title: 'Revista Oeste. Anvisa aprova 14 novas canetas para diabetes e obesidade.',
        url: 'https://revistaoeste.com/brasil/anvisa-aprova-14-novas-canetas-para-diabetes-e-obesidade/'
      },
      { title: 'Drogaria Araujo. Ozivy: bula, doses e preço.', url: 'https://www.araujo.com.br/ozivy.html' },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' }
    ],
    unresolved: [],
    article: {
      points: [
        'Mounjaro e Ozivy têm princípios ativos diferentes: tirzepatida e semaglutida.',
        'Só o Mounjaro tem indicação para obesidade; o Ozivy é aprovado para diabetes tipo 2.',
        'Não há estudo comparando diretamente os dois produtos.'
      ],
      info: {
        after: 'E para emagrecimento?',
        text: 'Preço menor não significa tratamento equivalente: Ozivy e Mounjaro têm moléculas, doses e indicações diferentes.'
      },
      tip: {
        after: 'Conservação',
        text: 'Antes de decidir pelo preço, calcule o custo do tratamento completo, incluindo a fase de aumento de dose e a manutenção, e não só o da primeira caixa.'
      }
    }
  },
  'mounjaro-ou-wegovy': {
    slug: 'mounjaro-ou-wegovy',
    title: 'Mounjaro ou Wegovy: diferenças, resultados e preço | Medleve',
    description:
      'Mounjaro (tirzepatida) e Wegovy (semaglutida) são aprovados para obesidade no Brasil. Compare mecanismo, perda de peso nos estudos, doses, efeitos e preço.',
    h1: 'Mounjaro ou Wegovy: quais são as diferenças?',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Mounjaro e Wegovy são canetas semanais aprovadas pela Anvisa para obesidade e sobrepeso com comorbidade. Mounjaro é tirzepatida, que age em GIP e GLP-1. Wegovy é semaglutida 2,4 mg, que age em GLP-1. No estudo SURMOUNT-5, que comparou os dois diretamente, a perda média de peso em 72 semanas foi de 20,2% com tirzepatida e 13,7% com semaglutida. Wegovy tem indicação aprovada para redução de risco cardiovascular.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'Comparação',
        blocks: [
          {
            kind: 'table',
            header: [[], [{ kind: 'text', text: 'Mounjaro' }], [{ kind: 'text', text: 'Wegovy' }]],
            rows: [
              [
                [{ kind: 'text', text: 'Princípio ativo' }],
                [{ kind: 'link', url: '/tirzepatida', children: [{ kind: 'text', text: 'Tirzepatida' }] }],
                [{ kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'Semaglutida' }] }]
              ],
              [
                [{ kind: 'text', text: 'Mecanismo' }],
                [{ kind: 'text', text: 'GIP + GLP-1' }],
                [{ kind: 'text', text: 'GLP-1' }]
              ],
              [
                [{ kind: 'text', text: 'Fabricante' }],
                [{ kind: 'text', text: 'Eli Lilly' }],
                [{ kind: 'text', text: 'Novo Nordisk' }]
              ],
              [
                [{ kind: 'text', text: 'Indicações aprovadas' }],
                [
                  {
                    kind: 'text',
                    text: 'Diabetes tipo 2; obesidade/sobrepeso com comorbidade; apneia do sono com obesidade'
                  }
                ],
                [
                  {
                    kind: 'text',
                    text: 'Obesidade/sobrepeso com comorbidade; adolescentes ≥ 12 anos; risco cardiovascular; MASH'
                  }
                ]
              ],
              [
                [{ kind: 'text', text: 'Doses' }],
                [{ kind: 'text', text: '2,5 a 15 mg/semana' }],
                [{ kind: 'text', text: '0,25 a 2,4 mg/semana' }]
              ],
              [
                [{ kind: 'text', text: 'Perda média de peso' }],
                [
                  { kind: 'text', text: '20,9% com 15 mg (' },
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2206038',
                    children: [{ kind: 'text', text: 'SURMOUNT-1' }]
                  },
                  { kind: 'text', text: ')' }
                ],
                [
                  { kind: 'text', text: '14,9% (' },
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2032183',
                    children: [{ kind: 'text', text: 'STEP 1' }]
                  },
                  { kind: 'text', text: ')' }
                ]
              ],
              [
                [{ kind: 'text', text: 'Preço no programa do fabricante (e-commerce)' }],
                [
                  {
                    kind: 'link',
                    url: 'https://www.lillymelhorparavoce.com.br/medicamentos-participantes/mounjaro',
                    children: [{ kind: 'text', text: 'R$ 1.422,52 a R$ 3.499,00' }]
                  },
                  { kind: 'text', text: ' por caixa; combos de R$ 1.125 a R$ 2.299 por caixa' }
                ],
                [
                  {
                    kind: 'link',
                    url: 'https://www.programanovodia.com.br/produtos.html',
                    children: [{ kind: 'text', text: 'R$ 899,00 a R$ 1.749,00' }]
                  },
                  { kind: 'text', text: ' por caneta' }
                ]
              ]
            ]
          }
        ]
      },
      {
        heading: 'O que mostrou a comparação direta?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'O ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2416394',
                children: [{ kind: 'text', text: 'SURMOUNT-5' }]
              },
              {
                kind: 'text',
                text: ' incluiu 751 adultos com obesidade, sem diabetes, tratados por 72 semanas com a dose máxima tolerada de cada medicamento. A perda média foi de 20,2% com tirzepatida e 13,7% com semaglutida. A redução da cintura foi de 18,4 cm e 13,0 cm, respectivamente. Os efeitos gastrointestinais foram os mais comuns nos dois grupos.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Onde o Wegovy tem mais evidência',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'O Wegovy tem um grande estudo de desfechos cardiovasculares em pessoas sem diabetes. No '
              },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2307563',
                children: [{ kind: 'text', text: 'SELECT' }]
              },
              {
                kind: 'text',
                text: ', reduziu em 20% o risco de infarto, AVC ou morte cardiovascular em adultos com doença cardiovascular e excesso de peso. Também é aprovado para adolescentes a partir de 12 anos.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Onde o Mounjaro tem mais evidência',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Além da maior perda média de peso, o Mounjaro é aprovado para apneia obstrutiva do sono em adultos com obesidade, com base no '
              },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2404881',
                children: [{ kind: 'text', text: 'SURMOUNT-OSA' }]
              },
              { kind: 'text', text: ', e para diabetes tipo 2.' }
            ]
          }
        ]
      },
      {
        heading: 'Efeitos colaterais',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'O perfil é semelhante: náusea, diarreia, vômito e constipação, mais frequentes nos aumentos de dose. Os dois têm as mesmas precauções quanto a pancreatite, vesícula biliar, gravidez e histórico de carcinoma medular de tireoide.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Como o médico escolhe?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Pesam a quantidade de peso a perder, a presença de doença cardiovascular, apneia do sono ou diabetes, a tolerância e o custo mensal. A troca de um para o outro é possível, mas deve ser orientada pelo médico, com ajuste de dose.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'Qual a diferença entre Mounjaro e Wegovy?',
        answer: [
          {
            kind: 'text',
            text: 'Mounjaro é tirzepatida (GIP + GLP-1) e Wegovy é semaglutida (GLP-1). São moléculas, doses e fabricantes diferentes.'
          }
        ]
      },
      {
        question: 'Os dois são indicados para obesidade?',
        answer: [{ kind: 'text', text: 'Sim, para adultos com IMC ≥ 30, ou ≥ 27 com comorbidade relacionada ao peso.' }]
      },
      {
        question: 'Qual emagrece mais?',
        answer: [
          {
            kind: 'text',
            text: 'No estudo SURMOUNT-5, a perda média foi maior com tirzepatida (20,2%) do que com semaglutida (13,7%). A resposta individual varia.'
          }
        ]
      },
      {
        question: 'Os efeitos colaterais são iguais?',
        answer: [{ kind: 'text', text: 'São parecidos, principalmente gastrointestinais.' }]
      },
      {
        question: 'Qual custa mais?',
        answer: [{ kind: 'text', text: 'Em geral, o Mounjaro, sobretudo nas doses mais altas.' }]
      },
      { question: 'Os dois precisam de receita?', answer: [{ kind: 'text', text: 'Sim, com retenção de uma via.' }] },
      {
        question: 'É possível trocar de Wegovy para Mounjaro?',
        answer: [{ kind: 'text', text: 'Sim, com orientação médica e ajuste de dose.' }]
      },
      {
        question: 'Qual é mais adequado para mim?',
        answer: [
          {
            kind: 'text',
            text: 'Depende do seu diagnóstico, das doenças associadas, da tolerância e do custo. Essa decisão é do médico.'
          }
        ]
      }
    ],
    sources: [
      { title: 'Aronne LJ et al. SURMOUNT-5. NEJM, 2025.', url: 'https://doi.org/10.1056/NEJMoa2416394' },
      { title: 'Jastreboff AM et al. SURMOUNT-1. NEJM, 2022.', url: 'https://doi.org/10.1056/NEJMoa2206038' },
      { title: 'Wilding JPH et al. STEP 1. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2032183' },
      { title: 'Lincoff AM et al. SELECT. NEJM, 2023.', url: 'https://doi.org/10.1056/NEJMoa2307563' },
      { title: 'Malhotra A et al. SURMOUNT-OSA. NEJM, 2024.', url: 'https://doi.org/10.1056/NEJMoa2404881' }
    ],
    unresolved: [],
    article: {
      points: [
        'Mounjaro é tirzepatida; Wegovy é semaglutida 2,4 mg. Os dois são aprovados para obesidade.',
        'Na comparação direta (SURMOUNT-5), a perda média foi de 20,2% contra 13,7%.',
        'Wegovy tem indicação aprovada para redução do risco cardiovascular.'
      ],
      info: {
        after: 'O que mostrou a comparação direta?',
        text: 'O SURMOUNT-5 foi financiado pela Eli Lilly, fabricante do Mounjaro, e publicado no New England Journal of Medicine após revisão por pares.'
      },
      tip: {
        after: 'Como o médico escolhe?',
        text: 'Na troca de um medicamento para o outro, não comece pela dose que você usava antes. A troca segue um esquema definido pelo médico para evitar efeitos gastrointestinais fortes.'
      }
    }
  },
  mounjaro: {
    slug: 'mounjaro',
    title: 'Mounjaro: o que é, preço, doses, receita e como funciona | Medleve',
    description:
      'Mounjaro é tirzepatida, aprovada pela Anvisa para diabetes tipo 2, obesidade e apneia do sono. Veja doses, preço por dose, resultados dos estudos, efeitos colaterais e receita.',
    h1: 'Mounjaro: o que é, preço, doses, receita e como funciona',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Mounjaro é uma caneta de tirzepatida, da Eli Lilly, aplicada uma vez por semana. A Anvisa aprova o uso para diabetes tipo 2, para obesidade (IMC ≥ 30) ou sobrepeso (IMC ≥ 27) com comorbidade e para apneia obstrutiva do sono em adultos com obesidade. No estudo SURMOUNT-1, a perda média de peso foi de 15,0% a 20,9% em 72 semanas, conforme a dose. A venda exige receita com retenção.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'O que é Mounjaro?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Mounjaro é o nome comercial da ' },
              { kind: 'link', url: '/tirzepatida', children: [{ kind: 'text', text: 'tirzepatida' }] },
              { kind: 'text', text: ', o primeiro medicamento que ativa ao mesmo tempo os receptores de GIP e ' },
              { kind: 'link', url: '/glp-1', children: [{ kind: 'text', text: 'GLP-1' }] },
              { kind: 'text', text: '. É fabricado pela Eli Lilly e chegou às farmácias brasileiras em maio de 2025.' }
            ]
          }
        ]
      },
      {
        heading: 'Qual é o princípio ativo de Mounjaro?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Tirzepatida. Não é semaglutida: são moléculas diferentes, com mecanismos e doses diferentes.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Para que Mounjaro é indicado?',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Diabetes tipo 2' }] },
                { kind: 'text', text: ', junto com dieta e exercícios (aprovado em setembro de 2023).' }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Controle crônico do peso' }] },
                {
                  kind: 'text',
                  text: ' em adultos com IMC ≥ 30 kg/m², ou IMC ≥ 27 kg/m² com pelo menos uma comorbidade relacionada ao peso ('
                },
                {
                  kind: 'link',
                  url: 'https://www.em.com.br/saude/2025/06/7168362-anvisa-aprova-mounjaro-para-perda-de-peso-e-tratamento-de-obesidade.html',
                  children: [{ kind: 'text', text: 'aprovado em junho de 2025' }]
                },
                { kind: 'text', text: ').' }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Apneia obstrutiva do sono moderada a grave' }] },
                { kind: 'text', text: ' em adultos com obesidade (' },
                {
                  kind: 'link',
                  url: 'https://site.cff.org.br/noticia/Noticias-gerais/21/10/2025/anvisa-aprova-uso-de-mounjaro-para-tratamento-da-apneia-do-sono',
                  children: [{ kind: 'text', text: 'aprovado em outubro de 2025' }]
                },
                { kind: 'text', text: ').' }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Como Mounjaro funciona?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A tirzepatida aumenta a saciedade, reduz a fome e retarda o esvaziamento do estômago. Também melhora a secreção de insulina quando a glicose está elevada. A ação combinada em dois receptores é a explicação mais aceita para a perda de peso maior observada nos estudos.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quais doses de Mounjaro existem?',
        blocks: [
          {
            kind: 'paragraph',
            children: [{ kind: 'text', text: '2,5 mg, 5 mg, 7,5 mg, 10 mg, 12,5 mg e 15 mg, uma vez por semana.' }]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'O tratamento começa com 2,5 mg por quatro semanas, dose de adaptação. Depois passa a 5 mg. A partir daí, o médico pode aumentar 2,5 mg a cada quatro semanas, no mínimo, conforme a resposta e a tolerância. Muitos pacientes ficam em doses intermediárias.'
              }
            ]
          }
        ]
      },
      {
        heading: 'O que os estudos mostram?',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa2206038',
                      children: [{ kind: 'text', text: 'SURMOUNT-1' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                {
                  kind: 'text',
                  text: ' 2.539 adultos sem diabetes, 72 semanas. Perda média de 15,0% (5 mg), 19,5% (10 mg) e 20,9% (15 mg), contra 3,1% com placebo.'
                }
              ],
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa2416394',
                      children: [{ kind: 'text', text: 'SURMOUNT-5' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                {
                  kind: 'text',
                  text: ' comparação direta com semaglutida 2,4 mg. Perda de 20,2% com Mounjaro e 13,7% com semaglutida.'
                }
              ],
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1016/S0140-6736%2823%2901200-X',
                      children: [{ kind: 'text', text: 'SURMOUNT-2' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                { kind: 'text', text: ' em pessoas com diabetes tipo 2, perda de 12,8% (10 mg) e 14,7% (15 mg).' }
              ],
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa2404881',
                      children: [{ kind: 'text', text: 'SURMOUNT-OSA' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                { kind: 'text', text: ' redução de 25 a 29 eventos de apneia por hora de sono.' }
              ],
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa2107519',
                      children: [{ kind: 'text', text: 'SURPASS-2' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                { kind: 'text', text: ' no diabetes tipo 2, controle glicêmico superior ao da semaglutida 1 mg.' }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Mounjaro precisa de receita?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Sim. A venda exige ' },
              {
                kind: 'link',
                url: 'https://portal.afya.com.br/saude/medicamentos-agonistas-glp-1-terao-retencao-de-receita',
                children: [{ kind: 'text', text: 'receita em duas vias, com retenção de uma delas' }]
              },
              {
                kind: 'text',
                text: '. A receita vale 90 dias. Comprar sem receita ou de vendedores não autorizados é arriscado: não há garantia de origem nem de conservação do produto.'
              }
            ]
          }
        ]
      },
      {
        heading: 'A receita de Mounjaro pode ser digital?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Sim. A ' },
              {
                kind: 'link',
                url: 'https://sincofarmasp.com.br/2026/01/19/anvisa-estabelece-novas-regras-para-prescricao-e-dispensacao-de-medicamentos-agonistas-de-glp-1/',
                children: [{ kind: 'text', text: 'dispensação com receita digital é permitida' }]
              },
              {
                kind: 'text',
                text: ', desde que a receita tenha assinatura eletrônica válida e cumpra as exigências da Anvisa.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quanto custa Mounjaro?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Preços divulgados pela Eli Lilly no ' },
              {
                kind: 'link',
                url: 'https://www.lillymelhorparavoce.com.br/medicamentos-participantes/mounjaro',
                children: [{ kind: 'text', text: 'programa Lilly Melhor Para Você' }]
              },
              { kind: 'text', text: ', por caixa (quatro aplicações), consultados em 09/10/2026:' }
            ]
          },
          {
            kind: 'table',
            header: [
              [{ kind: 'text', text: 'Dose' }],
              [{ kind: 'text', text: 'Programa, e-commerce' }],
              [{ kind: 'text', text: 'Programa, loja física' }]
            ],
            rows: [
              [
                [{ kind: 'text', text: '2,5 mg' }],
                [{ kind: 'text', text: 'R$ 1.422,52' }],
                [{ kind: 'text', text: 'R$ 1.523,79' }]
              ],
              [
                [{ kind: 'text', text: '5 mg' }],
                [{ kind: 'text', text: 'R$ 1.779,43' }],
                [{ kind: 'text', text: 'R$ 1.880,56' }]
              ],
              [
                [{ kind: 'text', text: '7,5 mg' }],
                [{ kind: 'text', text: 'R$ 2.299,00' }],
                [{ kind: 'text', text: 'R$ 2.399,00' }]
              ],
              [
                [{ kind: 'text', text: '10 mg' }],
                [{ kind: 'text', text: 'R$ 2.699,00' }],
                [{ kind: 'text', text: 'R$ 2.799,00' }]
              ],
              [
                [{ kind: 'text', text: '12,5 mg' }],
                [{ kind: 'text', text: 'R$ 3.199,00' }],
                [{ kind: 'text', text: 'R$ 3.299,00' }]
              ],
              [
                [{ kind: 'text', text: '15 mg' }],
                [{ kind: 'text', text: 'R$ 3.499,00' }],
                [{ kind: 'text', text: 'R$ 3.599,00' }]
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              { kind: 'bold', children: [{ kind: 'text', text: 'Combos do programa' }] },
              { kind: 'text', text: ' (duas caixas compradas na mesma transação):' }
            ]
          },
          {
            kind: 'table',
            header: [
              [{ kind: 'text', text: 'Combo' }],
              [{ kind: 'text', text: 'Preço por caixa' }],
              [{ kind: 'text', text: 'Total' }]
            ],
            rows: [
              [
                [{ kind: 'text', text: 'Início de tratamento: 2,5 mg + 5 mg' }],
                [{ kind: 'text', text: 'R$ 1.125,00' }],
                [{ kind: 'text', text: 'R$ 2.250,00' }]
              ],
              [
                [{ kind: 'text', text: 'Manutenção 1: 7,5 mg e/ou 10 mg' }],
                [{ kind: 'text', text: 'R$ 1.999,00' }],
                [{ kind: 'text', text: 'R$ 3.998,00' }]
              ],
              [
                [{ kind: 'text', text: 'Manutenção 2: 12,5 mg e/ou 15 mg' }],
                [{ kind: 'text', text: 'R$ 2.299,00' }],
                [{ kind: 'text', text: 'R$ 4.598,00' }]
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'O combo de início vale uma única vez por CPF, para quem nunca comprou Mounjaro pelo programa. Todos os preços exigem cadastro no programa, receita válida e compra em farmácia participante. Com os combos, a caixa de 10 mg sai por R$ 1.999,00 em vez de R$ 2.699,00.'
              }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Os valores são os divulgados pelo fabricante e podem mudar sem aviso. O preço final depende da farmácia. O paciente pode comprar na farmácia de sua preferência ou em uma farmácia parceira disponível na plataforma.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Principais efeitos colaterais de Mounjaro',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'No ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2206038',
                children: [{ kind: 'text', text: 'SURMOUNT-1' }]
              },
              {
                kind: 'text',
                text: ', náusea ocorreu em 24,6% a 33,3% dos participantes, diarreia em 18,7% a 23,0% e constipação em 11,7% a 17,1%. A maioria foi leve a moderada e apareceu durante o aumento de dose. Entre 4,3% e 7,1% interromperam o tratamento por efeitos adversos.'
              }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Procure atendimento em caso de dor abdominal intensa e persistente, vômitos que impedem a hidratação ou sinais de reação alérgica.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Contraindicações de Mounjaro',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'text', text: 'Alergia à tirzepatida ou a componentes da fórmula.' }],
              [
                {
                  kind: 'text',
                  text: 'Histórico pessoal ou familiar de carcinoma medular de tireoide ou neoplasia endócrina múltipla tipo 2.'
                }
              ],
              [{ kind: 'text', text: 'Gravidez e amamentação.' }],
              [{ kind: 'text', text: 'Cautela em quem já teve pancreatite ou tem doença gastrointestinal grave.' }]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Mounjaro pode reduzir a absorção de anticoncepcionais orais no início do tratamento e após cada aumento de dose. Converse com o médico sobre um método adicional nesses períodos.'
              }
            ]
          }
        ]
      },
      {
        heading: 'O que acontece ao parar Mounjaro?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'No ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1001/jama.2023.24945',
                children: [{ kind: 'text', text: 'SURMOUNT-4' }]
              },
              {
                kind: 'text',
                text: ', após 36 semanas de tratamento, quem continuou com tirzepatida perdeu mais 5,5% do peso em um ano. Quem passou para placebo recuperou 14,0%.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Diferenças entre Mounjaro e outros medicamentos',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'link', url: '/mounjaro-ou-wegovy', children: [{ kind: 'text', text: 'Mounjaro ou Wegovy' }] }],
              [
                { kind: 'link', url: '/mounjaro-ou-ozempic', children: [{ kind: 'text', text: 'Mounjaro ou Ozempic' }] }
              ],
              [{ kind: 'link', url: '/mounjaro-ou-ozivy', children: [{ kind: 'text', text: 'Mounjaro ou Ozivy' }] }],
              [
                {
                  kind: 'link',
                  url: '/semaglutida-ou-tirzepatida',
                  children: [{ kind: 'text', text: 'Semaglutida ou tirzepatida' }]
                }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Consulta médica online',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Na Medleve, o médico avalia seu histórico, IMC, exames e contraindicações, por mensagem ou vídeo. Se houver indicação clínica, emite a receita digital. A compra pode ser feita na farmácia de sua preferência ou em uma farmácia parceira disponível na plataforma.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'O que é Mounjaro?',
        answer: [
          {
            kind: 'text',
            text: 'É uma caneta de tirzepatida, de aplicação semanal, que age nos receptores de GIP e GLP-1.'
          }
        ]
      },
      {
        question: 'Para que serve Mounjaro?',
        answer: [
          {
            kind: 'text',
            text: 'Para diabetes tipo 2, obesidade ou sobrepeso com comorbidade e apneia obstrutiva do sono em adultos com obesidade.'
          }
        ]
      },
      {
        question: 'Mounjaro é tirzepatida?',
        answer: [{ kind: 'text', text: 'Sim. Tirzepatida é o princípio ativo; Mounjaro é a marca.' }]
      },
      {
        question: 'Mounjaro pode ser usado para emagrecimento?',
        answer: [
          {
            kind: 'text',
            text: 'Sim, dentro da indicação aprovada: adultos com IMC ≥ 30, ou IMC ≥ 27 com comorbidade relacionada ao peso, com avaliação médica.'
          }
        ]
      },
      {
        question: 'Mounjaro precisa de receita?',
        answer: [{ kind: 'text', text: 'Sim, em duas vias, com retenção pela farmácia. A receita vale 90 dias.' }]
      },
      {
        question: 'A receita pode ser digital?',
        answer: [{ kind: 'text', text: 'Sim, com assinatura eletrônica válida e dentro das regras da Anvisa.' }]
      },
      {
        question: 'Quais doses existem?',
        answer: [{ kind: 'text', text: '2,5 mg, 5 mg, 7,5 mg, 10 mg, 12,5 mg e 15 mg.' }]
      },
      {
        question: 'Quanto custa Mounjaro?',
        answer: [
          {
            kind: 'text',
            text: 'Pelo programa Lilly Melhor Para Você, de R$ 1.422,52 (2,5 mg) a R$ 3.499,00 (15 mg) por caixa no e-commerce. Nos combos de duas caixas, de R$ 1.125,00 a R$ 2.299,00 por caixa.'
          }
        ]
      },
      {
        question: 'Quais são os efeitos colaterais mais comuns?',
        answer: [{ kind: 'text', text: 'Náusea, diarreia, constipação e vômito, principalmente nos aumentos de dose.' }]
      },
      {
        question: 'Mounjaro e Wegovy são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'Não. Mounjaro é tirzepatida e Wegovy é semaglutida. No estudo SURMOUNT-5, a perda média de peso foi de 20,2% com tirzepatida e 13,7% com semaglutida.'
          }
        ]
      },
      {
        question: 'Mounjaro e Ozempic são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'Não. São moléculas diferentes. Ozempic é semaglutida de até 1 mg, aprovada para diabetes tipo 2.'
          }
        ]
      },
      {
        question: 'Como funciona uma avaliação médica online para Mounjaro?',
        answer: [
          {
            kind: 'text',
            text: 'Você preenche um questionário, é atendido por mensagem ou vídeo e, se houver indicação, recebe a receita digital.'
          }
        ]
      }
    ],
    sources: [
      { title: 'Jastreboff AM et al. SURMOUNT-1. NEJM, 2022.', url: 'https://doi.org/10.1056/NEJMoa2206038' },
      { title: 'Garvey WT et al. SURMOUNT-2. Lancet, 2023.', url: 'https://doi.org/10.1016/S0140-6736%2823%2901200-X' },
      { title: 'Aronne LJ et al. SURMOUNT-4. JAMA, 2024.', url: 'https://doi.org/10.1001/jama.2023.24945' },
      { title: 'Aronne LJ et al. SURMOUNT-5. NEJM, 2025.', url: 'https://doi.org/10.1056/NEJMoa2416394' },
      { title: 'Malhotra A et al. SURMOUNT-OSA. NEJM, 2024.', url: 'https://doi.org/10.1056/NEJMoa2404881' },
      { title: 'Frías JP et al. SURPASS-2. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2107519' },
      {
        title: 'Estado de Minas. Anvisa aprova Mounjaro para perda de peso e tratamento de obesidade.',
        url: 'https://www.em.com.br/saude/2025/06/7168362-anvisa-aprova-mounjaro-para-perda-de-peso-e-tratamento-de-obesidade.html'
      },
      {
        title: 'Conselho Federal de Farmácia. Anvisa aprova uso de Mounjaro para apneia do sono.',
        url: 'https://site.cff.org.br/noticia/Noticias-gerais/21/10/2025/anvisa-aprova-uso-de-mounjaro-para-tratamento-da-apneia-do-sono'
      },
      {
        title: 'Eli Lilly. Programa Lilly Melhor Para Você: Mounjaro.',
        url: 'https://www.lillymelhorparavoce.com.br/medicamentos-participantes/mounjaro'
      },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' }
    ],
    unresolved: [],
    article: {
      points: [
        'Mounjaro é tirzepatida, aprovada para diabetes tipo 2, obesidade e apneia do sono.',
        'No SURMOUNT-1, a perda média de peso foi de 15,0% a 20,9%, conforme a dose.',
        'Pelo programa Lilly, combos de duas caixas saem de R$ 1.125 a R$ 2.299 por caixa.'
      ],
      info: {
        after: 'Quanto custa Mounjaro?',
        text: 'Os combos do programa Lilly Melhor Para Você exigem duas caixas na mesma compra. Para quem já está na fase de manutenção, isso reduz bastante o custo de cada caixa.'
      },
      tip: {
        after: 'Principais efeitos colaterais de Mounjaro',
        text: 'Beba água ao longo do dia, sem esperar a sede. Vômitos e diarreia nas semanas de aumento de dose podem causar desidratação.'
      }
    }
  },
  ozempic: {
    slug: 'ozempic',
    title: 'Ozempic: o que é, preço, doses, receita e como funciona | Medleve',
    description:
      'Ozempic é semaglutida de até 1 mg, aprovada pela Anvisa para diabetes tipo 2. Entenda indicações, doses, preço em 2026, efeitos colaterais e a diferença para o Wegovy.',
    h1: 'Ozempic: o que é, preço, doses, receita e como funciona',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Ozempic é uma caneta de semaglutida, da Novo Nordisk, aplicada uma vez por semana em doses de 0,25 mg, 0,5 mg ou 1 mg. No Brasil, é aprovado pela Anvisa para diabetes tipo 2, incluindo redução de risco cardiovascular e de progressão de doença renal nesses pacientes. Ozempic não tem indicação de bula para obesidade: a semaglutida aprovada para esse fim é a de 2,4 mg (Wegovy e Poviztra).'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'O que é Ozempic?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'É um medicamento injetável à base de ' },
              { kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'semaglutida' }] },
              { kind: 'text', text: ', um agonista do receptor de ' },
              { kind: 'link', url: '/glp-1', children: [{ kind: 'text', text: 'GLP-1' }] },
              {
                kind: 'text',
                text: '. Foi o primeiro produto com semaglutida a chegar ao Brasil e tornou-se o nome mais conhecido da classe.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Qual é o princípio ativo de Ozempic?',
        blocks: [
          {
            kind: 'paragraph',
            children: [{ kind: 'text', text: 'Semaglutida, o mesmo de Wegovy, Poviztra, Ozivy e Semavy.' }]
          }
        ]
      },
      {
        heading: 'Para que Ozempic é indicado no Brasil?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Conforme a ' },
              {
                kind: 'link',
                url: 'https://www.novonordisk.com.br/noticias-e-imprensa/busca-noticias/anvisa-aprova-novas-indicacoes-de-wegovy-e-ozempic-para-tratamento-de-doencas-no-coracao-e-nos-rins.html',
                children: [{ kind: 'text', text: 'Novo Nordisk' }]
              },
              { kind: 'text', text: ':' }
            ]
          },
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                { kind: 'text', text: 'Melhora do controle glicêmico em adultos com ' },
                { kind: 'bold', children: [{ kind: 'text', text: 'diabetes tipo 2' }] },
                { kind: 'text', text: ', junto com dieta e exercícios.' }
              ],
              [
                {
                  kind: 'text',
                  text: 'Redução de eventos cardiovasculares maiores em adultos com diabetes tipo 2 e doença cardíaca estabelecida.'
                }
              ],
              [
                {
                  kind: 'text',
                  text: 'Prevenção da progressão da doença renal crônica em pessoas com diabetes tipo 2 (indicação aprovada em 2026).'
                }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Ozempic é indicado para obesidade?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Não. A bula do Ozempic não inclui obesidade nem sobrepeso. Como a semaglutida também reduz o peso, o Ozempic passou a ser prescrito fora da indicação de bula. Esse uso é uma decisão do médico, tomada caso a caso. Quando o objetivo é tratar obesidade, existem medicamentos com essa indicação aprovada: '
              },
              { kind: 'link', url: '/wegovy', children: [{ kind: 'text', text: 'Wegovy' }] },
              { kind: 'text', text: ', ' },
              { kind: 'link', url: '/poviztra', children: [{ kind: 'text', text: 'Poviztra' }] },
              { kind: 'text', text: ' e ' },
              { kind: 'link', url: '/mounjaro', children: [{ kind: 'text', text: 'Mounjaro' }] },
              { kind: 'text', text: '.' }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'A dose faz diferença. No ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1016/S0140-6736%2821%2900213-0',
                children: [{ kind: 'text', text: 'STEP 2' }]
              },
              {
                kind: 'text',
                text: ', em pessoas com diabetes tipo 2 e excesso de peso, a perda média foi de 7,0% com semaglutida 1,0 mg e 9,6% com 2,4 mg.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Como Ozempic funciona?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Estimula a secreção de insulina quando a glicose está alta, reduz o glucagon, retarda o esvaziamento do estômago e aumenta a saciedade.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quais doses de Ozempic existem?',
        blocks: [
          {
            kind: 'table',
            header: [[{ kind: 'text', text: 'Etapa' }], [{ kind: 'text', text: 'Dose semanal' }]],
            rows: [
              [[{ kind: 'text', text: 'Início (4 semanas)' }], [{ kind: 'text', text: '0,25 mg' }]],
              [[{ kind: 'text', text: 'Manutenção' }], [{ kind: 'text', text: '0,5 mg' }]],
              [[{ kind: 'text', text: 'Se necessário' }], [{ kind: 'text', text: '1 mg' }]]
            ]
          },
          {
            kind: 'paragraph',
            children: [{ kind: 'text', text: 'A dose de 0,25 mg serve para adaptação e não é dose de tratamento.' }]
          }
        ]
      },
      {
        heading: 'O que os estudos mostram?',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa1607141',
                      children: [{ kind: 'text', text: 'SUSTAIN-6' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                {
                  kind: 'text',
                  text: ' em 3.297 pessoas com diabetes tipo 2, redução de 26% em infarto, AVC ou morte cardiovascular.'
                }
              ],
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa2403347',
                      children: [{ kind: 'text', text: 'FLOW' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                {
                  kind: 'text',
                  text: ' em 3.533 pessoas com diabetes tipo 2 e doença renal crônica, redução de 24% no risco de progressão da doença renal.'
                }
              ],
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa2107519',
                      children: [{ kind: 'text', text: 'SURPASS-2' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                {
                  kind: 'text',
                  text: ' na comparação com tirzepatida, a semaglutida 1 mg reduziu a hemoglobina glicada em 1,86 ponto e o peso em 5,7 kg em 40 semanas.'
                }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Ozempic precisa de receita?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Sim, ' },
              {
                kind: 'link',
                url: 'https://portal.afya.com.br/saude/medicamentos-agonistas-glp-1-terao-retencao-de-receita',
                children: [{ kind: 'text', text: 'em duas vias e com retenção pela farmácia' }]
              },
              { kind: 'text', text: '. A receita vale 90 dias e pode ser digital.' }
            ]
          }
        ]
      },
      {
        heading: 'Quanto custa Ozempic?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Preços divulgados pela Novo Nordisk no ' },
              {
                kind: 'link',
                url: 'https://www.programanovodia.com.br/produtos.html',
                children: [{ kind: 'text', text: 'programa NovoDia' }]
              },
              { kind: 'text', text: ', por caneta, consultados em 09/10/2026:' }
            ]
          },
          {
            kind: 'table',
            header: [
              [{ kind: 'text', text: 'Apresentação' }],
              [{ kind: 'text', text: 'Preço de lista' }],
              [{ kind: 'text', text: 'NovoDia, loja física' }],
              [{ kind: 'text', text: 'NovoDia, e-commerce' }]
            ],
            rows: [
              [
                [{ kind: 'text', text: '0,25 mg / 0,5 mg' }],
                [{ kind: 'text', text: 'R$ 1.314,38' }],
                [{ kind: 'text', text: 'R$ 1.075,00' }],
                [{ kind: 'text', text: 'R$ 975,00' }]
              ],
              [
                [{ kind: 'text', text: '1 mg' }],
                [{ kind: 'text', text: 'R$ 1.314,38' }],
                [{ kind: 'text', text: 'R$ 1.099,00' }],
                [{ kind: 'text', text: 'R$ 999,00' }]
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'O desconto exige cadastro gratuito no NovoDia e receita médica. Após o fim da patente da semaglutida, em março de 2026, chegaram opções de menor preço para diabetes tipo 2, como '
              },
              { kind: 'link', url: '/ozivy', children: [{ kind: 'text', text: 'Ozivy' }] },
              { kind: 'text', text: ' e ' },
              { kind: 'link', url: '/semavy', children: [{ kind: 'text', text: 'Semavy' }] },
              { kind: 'text', text: '.' }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Os valores são os divulgados pelo fabricante e podem mudar sem aviso. O preço final depende da farmácia. O paciente pode comprar na farmácia de sua preferência ou em uma farmácia parceira disponível na plataforma.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Principais efeitos colaterais de Ozempic',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Náusea, diarreia, vômito, constipação e dor abdominal, mais comuns no início. No SUSTAIN-6, houve mais complicações de retinopatia diabética no grupo semaglutida, sobretudo em quem já tinha retinopatia: esses pacientes precisam de acompanhamento oftalmológico. Há risco de hipoglicemia quando usado junto com insulina ou sulfonilureias.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Contraindicações de Ozempic',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'text', text: 'Alergia à semaglutida ou a componentes da fórmula.' }],
              [{ kind: 'text', text: 'Gravidez e amamentação.' }],
              [
                {
                  kind: 'text',
                  text: 'Histórico pessoal ou familiar de carcinoma medular de tireoide ou neoplasia endócrina múltipla tipo 2: avaliar com o médico.'
                }
              ],
              [{ kind: 'text', text: 'Não é indicado para diabetes tipo 1.' }]
            ]
          }
        ]
      },
      {
        heading: 'Diferenças entre Ozempic e outros medicamentos',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'link', url: '/wegovy-ou-ozempic', children: [{ kind: 'text', text: 'Wegovy ou Ozempic' }] }],
              [
                { kind: 'link', url: '/mounjaro-ou-ozempic', children: [{ kind: 'text', text: 'Mounjaro ou Ozempic' }] }
              ],
              [{ kind: 'link', url: '/ozivy-ou-ozempic', children: [{ kind: 'text', text: 'Ozivy ou Ozempic' }] }],
              [{ kind: 'link', url: '/semavy-ou-ozempic', children: [{ kind: 'text', text: 'Semavy ou Ozempic' }] }]
            ]
          }
        ]
      },
      {
        heading: 'Consulta médica online',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Na Medleve, o médico avalia seu caso por mensagem ou vídeo e define se há indicação de tratamento e qual medicamento é adequado. A receita, quando indicada, é digital.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'O que é Ozempic?',
        answer: [
          { kind: 'text', text: 'É uma caneta de semaglutida, de aplicação semanal, aprovada para diabetes tipo 2.' }
        ]
      },
      { question: 'Ozempic é semaglutida?', answer: [{ kind: 'text', text: 'Sim.' }] },
      {
        question: 'Para que Ozempic é indicado no Brasil?',
        answer: [
          {
            kind: 'text',
            text: 'Para diabetes tipo 2, incluindo redução de risco cardiovascular e de progressão de doença renal nesses pacientes.'
          }
        ]
      },
      {
        question: 'Ozempic é indicado para obesidade?',
        answer: [
          {
            kind: 'text',
            text: 'Não. A semaglutida com indicação para obesidade é a de 2,4 mg, vendida como Wegovy e Poviztra.'
          }
        ]
      },
      {
        question: 'Ozempic precisa de receita?',
        answer: [{ kind: 'text', text: 'Sim, em duas vias, com retenção. Vale 90 dias.' }]
      },
      { question: 'Quais doses existem?', answer: [{ kind: 'text', text: '0,25 mg, 0,5 mg e 1 mg.' }] },
      {
        question: 'Quanto custa Ozempic?',
        answer: [
          {
            kind: 'text',
            text: 'Pelo programa NovoDia, R$ 975,00 (0,25/0,5 mg) e R$ 999,00 (1 mg) por caneta no e-commerce. O preço de lista é R$ 1.314,38.'
          }
        ]
      },
      {
        question: 'Ozempic e Wegovy são iguais?',
        answer: [
          { kind: 'text', text: 'Têm o mesmo princípio ativo, mas Wegovy chega a 2,4 mg e é aprovado para obesidade.' }
        ]
      },
      {
        question: 'Ozempic e Ozivy são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'Ambos são semaglutida de até 1 mg para diabetes tipo 2. Ozempic é de origem biológica; Ozivy é sintético, fabricado pela EMS.'
          }
        ]
      },
      {
        question: 'Quais são os efeitos colaterais mais comuns?',
        answer: [{ kind: 'text', text: 'Náusea, diarreia, vômito e constipação.' }]
      }
    ],
    sources: [
      { title: 'Marso SP et al. SUSTAIN-6. NEJM, 2016.', url: 'https://doi.org/10.1056/NEJMoa1607141' },
      { title: 'Perkovic V et al. FLOW. NEJM, 2024.', url: 'https://doi.org/10.1056/NEJMoa2403347' },
      { title: 'Davies M et al. STEP 2. Lancet, 2021.', url: 'https://doi.org/10.1016/S0140-6736%2821%2900213-0' },
      { title: 'Frías JP et al. SURPASS-2. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2107519' },
      {
        title: 'Novo Nordisk Brasil. Anvisa aprova novas indicações de Wegovy e Ozempic.',
        url: 'https://www.novonordisk.com.br/noticias-e-imprensa/busca-noticias/anvisa-aprova-novas-indicacoes-de-wegovy-e-ozempic-para-tratamento-de-doencas-no-coracao-e-nos-rins.html'
      },
      { title: 'Novo Nordisk. Programa NovoDia: preços.', url: 'https://www.programanovodia.com.br/produtos.html' },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' }
    ],
    unresolved: [],
    article: {
      points: [
        'Ozempic é semaglutida de até 1 mg, aprovada para diabetes tipo 2.',
        'Não tem indicação de bula para obesidade: para isso existem Wegovy e Poviztra.',
        'Reduziu em 26% os eventos cardiovasculares no estudo SUSTAIN-6.'
      ],
      info: {
        after: 'Ozempic é indicado para obesidade?',
        text: 'A dose de 2,4 mg não existe na caneta do Ozempic. Tentar chegar a ela com cliques extras na caneta de 1 mg é perigoso.'
      },
      tip: {
        after: 'Principais efeitos colaterais de Ozempic',
        text: 'Se você também usa insulina ou sulfonilureia, tenha sempre à mão uma fonte de açúcar rápido e aprenda a reconhecer a hipoglicemia: tremor, suor frio, fome súbita e confusão.'
      }
    }
  },
  'ozivy-ou-ozempic': {
    slug: 'ozivy-ou-ozempic',
    title: 'Ozivy ou Ozempic: diferenças, conservação e preço | Medleve',
    description:
      'Ozivy e Ozempic são semaglutida para diabetes tipo 2. Ozivy é sintético e fabricado no Brasil pela EMS; Ozempic é biológico. Compare origem, conservação e preço.',
    h1: 'Ozivy ou Ozempic: quais são as diferenças?',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Ozivy e Ozempic são canetas semanais de semaglutida, em doses de 0,25 mg a 1 mg, aprovadas pela Anvisa para diabetes tipo 2. Ozempic é o medicamento de referência, de origem biológica, da Novo Nordisk. Ozivy é uma semaglutida sintética produzida no Brasil pela EMS, registrada como medicamento novo, e não como genérico. Ozivy custa menos e precisa ficar sempre na geladeira. Nenhum dos dois tem indicação de bula para obesidade.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'Comparação',
        blocks: [
          {
            kind: 'table',
            header: [[], [{ kind: 'text', text: 'Ozivy' }], [{ kind: 'text', text: 'Ozempic' }]],
            rows: [
              [
                [{ kind: 'text', text: 'Princípio ativo' }],
                [
                  { kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'Semaglutida' }] },
                  { kind: 'text', text: ' sintética' }
                ],
                [
                  { kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'Semaglutida' }] },
                  { kind: 'text', text: ' biológica' }
                ]
              ],
              [
                [{ kind: 'text', text: 'Fabricante' }],
                [{ kind: 'text', text: 'EMS (Hortolândia, SP)' }],
                [{ kind: 'text', text: 'Novo Nordisk (Dinamarca)' }]
              ],
              [
                [{ kind: 'text', text: 'Indicação aprovada' }],
                [{ kind: 'text', text: 'Diabetes tipo 2' }],
                [{ kind: 'text', text: 'Diabetes tipo 2 (inclui risco cardiovascular e doença renal)' }]
              ],
              [
                [{ kind: 'text', text: 'Doses' }],
                [{ kind: 'text', text: '0,25 / 0,5 / 1 mg' }],
                [{ kind: 'text', text: '0,25 / 0,5 / 1 mg' }]
              ],
              [
                [{ kind: 'text', text: 'Conservação após abrir' }],
                [{ kind: 'text', text: 'Geladeira, até 56 dias' }],
                [{ kind: 'text', text: 'Até 6 semanas abaixo de 30 °C ou na geladeira' }]
              ],
              [
                [{ kind: 'text', text: 'Preço no programa do fabricante' }],
                [
                  {
                    kind: 'link',
                    url: 'https://guiadafarmacia.com.br/ems-lanca-nova-condicao-de-precos-para-tratamento-com-ozivy/',
                    children: [{ kind: 'text', text: '3 canetas de 1 mg por R$ 999' }]
                  },
                  { kind: 'text', text: ' (programa Vida + Leve)' }
                ],
                [
                  {
                    kind: 'link',
                    url: 'https://www.programanovodia.com.br/produtos.html',
                    children: [{ kind: 'text', text: 'R$ 975 a R$ 999' }]
                  },
                  { kind: 'text', text: ' por caneta (NovoDia, e-commerce)' }
                ]
              ]
            ]
          }
        ]
      },
      {
        heading: 'Ozivy é genérico do Ozempic?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Não. A ' },
              {
                kind: 'link',
                url: 'https://www.bemparana.com.br/bem-estar/anvisa-aprova-primeira-caneta-nacional-com-a-mesma-substancia-do-ozempic/',
                children: [{ kind: 'text', text: 'Anvisa classificou o Ozivy como medicamento novo' }]
              },
              {
                kind: 'text',
                text: ', um análogo sintético de produto biológico, com avaliação própria de qualidade, segurança e eficácia.'
              }
            ]
          }
        ]
      },
      {
        heading: 'A evidência clínica é a mesma?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Os estudos de desfecho cardiovascular (' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa1607141',
                children: [{ kind: 'text', text: 'SUSTAIN-6' }]
              },
              { kind: 'text', text: ') e renal (' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2403347',
                children: [{ kind: 'text', text: 'FLOW' }]
              },
              {
                kind: 'text',
                text: ') foram realizados com a semaglutida da Novo Nordisk, e essas indicações constam da bula do Ozempic.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Posso trocar um pelo outro?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A troca deve ser orientada pelo médico, com receita do produto correspondente. Atenção à conservação: o Ozivy não deve ficar fora da geladeira.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'Ozivy e Ozempic são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'Têm o mesmo princípio ativo, as mesmas doses e a mesma indicação principal. Diferem na origem, no fabricante, na conservação e no preço.'
          }
        ]
      },
      {
        question: 'Ozivy é genérico do Ozempic?',
        answer: [{ kind: 'text', text: 'Não. É um medicamento novo, de semaglutida sintética.' }]
      },
      {
        question: 'Algum dos dois é indicado para obesidade?',
        answer: [{ kind: 'text', text: 'Não. Ambos são aprovados para diabetes tipo 2.' }]
      },
      { question: 'Qual custa menos?', answer: [{ kind: 'text', text: 'O Ozivy.' }] },
      {
        question: 'Ozivy precisa ficar na geladeira?',
        answer: [{ kind: 'text', text: 'Sim, antes e depois do primeiro uso.' }]
      },
      { question: 'Os dois precisam de receita?', answer: [{ kind: 'text', text: 'Sim, com retenção.' }] }
    ],
    sources: [
      {
        title: 'Bem Paraná / Folhapress. Anvisa aprova primeira caneta nacional com a mesma substância do Ozempic.',
        url: 'https://www.bemparana.com.br/bem-estar/anvisa-aprova-primeira-caneta-nacional-com-a-mesma-substancia-do-ozempic/'
      },
      { title: 'Drogaria Araujo. Ozivy: bula, doses e preço.', url: 'https://www.araujo.com.br/ozivy.html' },
      { title: 'Marso SP et al. SUSTAIN-6. NEJM, 2016.', url: 'https://doi.org/10.1056/NEJMoa1607141' },
      { title: 'Perkovic V et al. FLOW. NEJM, 2024.', url: 'https://doi.org/10.1056/NEJMoa2403347' },
      {
        title: 'Revista Oeste. Anvisa aprova 14 novas canetas para diabetes e obesidade.',
        url: 'https://revistaoeste.com/brasil/anvisa-aprova-14-novas-canetas-para-diabetes-e-obesidade/'
      }
    ],
    unresolved: [],
    article: {
      points: [
        'Ozivy e Ozempic têm o mesmo princípio ativo, as mesmas doses e a mesma indicação principal.',
        'Ozivy é sintético, produzido no Brasil pela EMS; Ozempic é biológico.',
        'Ozivy precisa ficar sempre na geladeira.'
      ],
      info: {
        after: 'Ozivy é genérico do Ozempic?',
        text: 'Depois de aberta, a caneta de Ozempic pode ficar até seis semanas fora da geladeira; a de Ozivy, não.'
      },
      tip: {
        after: 'Posso trocar um pelo outro?',
        text: 'Em viagens com Ozivy, leve a caneta em bolsa térmica com gelo reutilizável, sem contato direto com ele, e devolva à geladeira assim que chegar.'
      }
    }
  },
  ozivy: {
    slug: 'ozivy',
    title: 'Ozivy: o que é, preço, doses, receita e como funciona | Medleve',
    description:
      'Ozivy é a primeira semaglutida produzida no Brasil, da EMS, aprovada pela Anvisa para diabetes tipo 2. Veja doses, preço, conservação, efeitos e diferenças para Ozempic e Wegovy.',
    h1: 'Ozivy: o que é, preço, doses, receita e como funciona',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Ozivy é uma caneta de semaglutida sintética fabricada pela EMS em Hortolândia (SP), aplicada uma vez por semana. Foi o primeiro medicamento com semaglutida produzido no Brasil, registrado pela Anvisa em 26 de maio de 2026. A indicação aprovada é exclusivamente o diabetes tipo 2 em adultos. Ozivy não tem indicação de bula para emagrecimento e não é um genérico do Ozempic.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'O que é Ozivy?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'É um medicamento injetável à base de ' },
              { kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'semaglutida' }] },
              {
                kind: 'text',
                text: ', lançado pouco depois de a patente da molécula expirar no Brasil, em 20 de março de 2026. A '
              },
              {
                kind: 'link',
                url: 'https://www.bemparana.com.br/bem-estar/anvisa-aprova-primeira-caneta-nacional-com-a-mesma-substancia-do-ozempic/',
                children: [{ kind: 'text', text: 'Anvisa o classificou como medicamento novo' }]
              },
              {
                kind: 'text',
                text: ': um análogo sintético de um produto biológico. Por isso, não é genérico, similar nem biossimilar.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Qual é o princípio ativo de Ozivy?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Semaglutida produzida por síntese química, um agonista do receptor de ' },
              { kind: 'link', url: '/glp-1', children: [{ kind: 'text', text: 'GLP-1' }] },
              { kind: 'text', text: '.' }
            ]
          }
        ]
      },
      {
        heading: 'Para que Ozivy é indicado?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Para adultos com ' },
              {
                kind: 'link',
                url: 'https://www.araujo.com.br/ozivy.html',
                children: [{ kind: 'text', text: 'diabetes tipo 2' }]
              },
              {
                kind: 'text',
                text: ' cuja glicose não está controlada apenas com dieta e exercícios. Pode ser usado sozinho ou com outros antidiabéticos, conforme orientação médica.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Ozivy é indicado para emagrecimento?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Não. A bula do Ozivy não inclui obesidade nem sobrepeso, e suas doses vão até 1 mg por semana. A semaglutida aprovada para obesidade é a de 2,4 mg ('
              },
              { kind: 'link', url: '/wegovy', children: [{ kind: 'text', text: 'Wegovy' }] },
              { kind: 'text', text: ' e ' },
              { kind: 'link', url: '/poviztra', children: [{ kind: 'text', text: 'Poviztra' }] },
              { kind: 'text', text: '). O uso fora da indicação de bula é decisão do médico.' }
            ]
          }
        ]
      },
      {
        heading: 'Como Ozivy funciona?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Estimula a insulina quando a glicose está alta, reduz o glucagon, retarda o esvaziamento do estômago e aumenta a saciedade.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quais doses de Ozivy existem?',
        blocks: [
          {
            kind: 'table',
            header: [[{ kind: 'text', text: 'Apresentação' }], [{ kind: 'text', text: 'Uso' }]],
            rows: [
              [
                [{ kind: 'text', text: 'Caneta de 0,25 mg / 0,5 mg (1,5 mL)' }],
                [{ kind: 'text', text: 'Início e manutenção' }]
              ],
              [
                [{ kind: 'text', text: 'Caneta de 1 mg (3 mL)' }],
                [{ kind: 'text', text: 'Manutenção, quando necessário' }]
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'O tratamento começa com 0,25 mg por semana durante quatro semanas, passa para 0,5 mg e pode chegar a 1 mg.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Conservação',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Ozivy deve ficar na geladeira (2 °C a 8 °C) antes e depois do primeiro uso, protegido da luz e sem congelar. Depois de aberta, a caneta pode ser usada por até 56 dias. Esse ponto é diferente de Ozempic e Wegovy, que podem ficar fora da geladeira após o primeiro uso.'
              }
            ]
          }
        ]
      },
      {
        heading: 'O que os estudos mostram?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A eficácia da semaglutida no diabetes tipo 2 vem dos estudos com o produto de referência:'
              }
            ]
          },
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa1607141',
                      children: [{ kind: 'text', text: 'SUSTAIN-6' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                { kind: 'text', text: ' redução de 26% em infarto, AVC ou morte cardiovascular.' }
              ],
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa2107519',
                      children: [{ kind: 'text', text: 'SURPASS-2' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                {
                  kind: 'text',
                  text: ' semaglutida 1 mg reduziu a hemoglobina glicada em 1,86 ponto percentual e o peso em 5,7 kg em 40 semanas.'
                }
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Esses estudos foram feitos com a semaglutida da Novo Nordisk. O Ozivy passou por avaliação própria de qualidade, segurança e eficácia na Anvisa.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Ozivy precisa de receita?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Sim, ' },
              {
                kind: 'link',
                url: 'https://portal.afya.com.br/saude/medicamentos-agonistas-glp-1-terao-retencao-de-receita',
                children: [{ kind: 'text', text: 'em duas vias, com retenção' }]
              },
              { kind: 'text', text: '. A receita vale 90 dias e pode ser digital.' }
            ]
          }
        ]
      },
      {
        heading: 'Quanto custa Ozivy?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Preços divulgados pela EMS no ' },
              {
                kind: 'link',
                url: 'https://guiadafarmacia.com.br/ems-lanca-nova-condicao-de-precos-para-tratamento-com-ozivy/',
                children: [{ kind: 'text', text: 'programa Vida + Leve' }]
              },
              { kind: 'text', text: ', para a caneta de 1 mg, vigentes desde julho de 2026:' }
            ]
          },
          {
            kind: 'table',
            header: [
              [{ kind: 'text', text: 'Condição' }],
              [{ kind: 'text', text: 'Total' }],
              [{ kind: 'text', text: 'Preço por caneta' }]
            ],
            rows: [
              [
                [{ kind: 'text', text: 'Combo de 3 canetas' }],
                [{ kind: 'text', text: 'R$ 999,00' }],
                [{ kind: 'text', text: 'R$ 333,00' }]
              ],
              [
                [{ kind: 'text', text: 'Combo de 2 canetas' }],
                [{ kind: 'text', text: 'R$ 863,22' }],
                [{ kind: 'text', text: 'R$ 431,61' }]
              ],
              [
                [{ kind: 'text', text: '1 caneta, preço de lançamento (jun/2026)' }],
                [
                  {
                    kind: 'link',
                    url: 'https://revistaoeste.com/brasil/anvisa-aprova-14-novas-canetas-para-diabetes-e-obesidade/',
                    children: [{ kind: 'text', text: 'R$ 452 a R$ 498' }]
                  }
                ],
                [{ kind: 'text', text: 'R$ 452 a R$ 498' }]
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Os combos exigem cadastro no programa Vida + Leve, feito no portal ' },
              { kind: 'code', text: 'vidamaisleve.emssaude.com.br' },
              {
                kind: 'text',
                text: ' ou no balcão de uma farmácia participante, e receita válida. O combo de três canetas equivale a cerca de R$ 10 por dia de tratamento.'
              }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Os valores são os divulgados pelo fabricante e podem mudar sem aviso. O preço final depende da farmácia. O paciente pode comprar na farmácia de sua preferência ou em uma farmácia parceira disponível na plataforma.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Principais efeitos colaterais de Ozivy',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Muito comuns: náusea, diarreia, vômito e constipação. Comuns: dor abdominal, azia, distensão abdominal, redução do apetite e reação no local da aplicação. Procure atendimento em caso de dor abdominal intensa e persistente, sinais de desidratação ou de reação alérgica.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Contraindicações de Ozivy',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'text', text: 'Alergia à semaglutida ou a componentes da fórmula.' }],
              [
                {
                  kind: 'text',
                  text: 'Histórico pessoal ou familiar de carcinoma medular de tireoide ou neoplasia endócrina múltipla tipo 2.'
                }
              ],
              [{ kind: 'text', text: 'Diabetes tipo 1 e cetoacidose diabética.' }],
              [{ kind: 'text', text: 'Gravidez, amamentação e menores de 18 anos.' }]
            ]
          }
        ]
      },
      {
        heading: 'Diferenças entre Ozivy e outros medicamentos',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'link', url: '/ozivy-ou-ozempic', children: [{ kind: 'text', text: 'Ozivy ou Ozempic' }] }],
              [{ kind: 'link', url: '/wegovy-ou-ozivy', children: [{ kind: 'text', text: 'Wegovy ou Ozivy' }] }],
              [{ kind: 'link', url: '/mounjaro-ou-ozivy', children: [{ kind: 'text', text: 'Mounjaro ou Ozivy' }] }]
            ]
          }
        ]
      },
      {
        heading: 'Consulta médica online',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Na Medleve, o médico avalia seu caso por mensagem ou vídeo e define qual tratamento é adequado. A receita, quando indicada, é digital.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'O que é Ozivy?',
        answer: [
          {
            kind: 'text',
            text: 'É uma caneta de semaglutida sintética, fabricada pela EMS no Brasil, de aplicação semanal.'
          }
        ]
      },
      { question: 'Ozivy é semaglutida?', answer: [{ kind: 'text', text: 'Sim, produzida por síntese química.' }] },
      { question: 'Para que Ozivy é indicado?', answer: [{ kind: 'text', text: 'Para diabetes tipo 2 em adultos.' }] },
      {
        question: 'Ozivy é indicado para emagrecimento?',
        answer: [{ kind: 'text', text: 'Não. A indicação aprovada pela Anvisa é exclusivamente diabetes tipo 2.' }]
      },
      {
        question: 'Ozivy precisa de receita?',
        answer: [{ kind: 'text', text: 'Sim, em duas vias, com retenção. Vale 90 dias.' }]
      },
      {
        question: 'Quais doses existem?',
        answer: [{ kind: 'text', text: 'Caneta de 0,25 mg / 0,5 mg e caneta de 1 mg.' }]
      },
      {
        question: 'Quanto custa Ozivy?',
        answer: [
          {
            kind: 'text',
            text: 'Pelo programa Vida + Leve, da EMS, três canetas de 1 mg saem por R$ 999,00 (R$ 333,00 cada). A caneta avulsa foi lançada por R$ 452 a R$ 498.'
          }
        ]
      },
      {
        question: 'Ozivy e Ozempic são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'Têm o mesmo princípio ativo, a mesma faixa de dose e a mesma indicação. Ozivy é sintético e nacional; Ozempic é biológico. Ozivy não é genérico do Ozempic.'
          }
        ]
      },
      {
        question: 'Ozivy e Semavy são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'São duas semaglutidas sintéticas para diabetes tipo 2, de fabricantes diferentes (EMS e Hypera Pharma).'
          }
        ]
      },
      {
        question: 'Quais são os principais efeitos colaterais?',
        answer: [{ kind: 'text', text: 'Náusea, diarreia, vômito e constipação.' }]
      }
    ],
    sources: [
      {
        title: 'Bem Paraná / Folhapress. Anvisa aprova primeira caneta nacional com a mesma substância do Ozempic.',
        url: 'https://www.bemparana.com.br/bem-estar/anvisa-aprova-primeira-caneta-nacional-com-a-mesma-substancia-do-ozempic/'
      },
      {
        title: 'Revista Oeste. Anvisa aprova 14 novas canetas para diabetes e obesidade.',
        url: 'https://revistaoeste.com/brasil/anvisa-aprova-14-novas-canetas-para-diabetes-e-obesidade/'
      },
      { title: 'Drogaria Araujo. Ozivy: bula, doses e preço.', url: 'https://www.araujo.com.br/ozivy.html' },
      {
        title: 'Guia da Farmácia. EMS lança nova condição de preços para tratamento com Ozivy.',
        url: 'https://guiadafarmacia.com.br/ems-lanca-nova-condicao-de-precos-para-tratamento-com-ozivy/'
      },
      { title: 'Marso SP et al. SUSTAIN-6. NEJM, 2016.', url: 'https://doi.org/10.1056/NEJMoa1607141' },
      { title: 'Frías JP et al. SURPASS-2. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2107519' },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' }
    ],
    unresolved: [],
    article: {
      points: [
        'Ozivy é a primeira semaglutida produzida no Brasil, pela EMS.',
        'É aprovado exclusivamente para diabetes tipo 2, em doses de até 1 mg.',
        'Pelo programa Vida + Leve, três canetas de 1 mg saem por R$ 999.'
      ],
      info: {
        after: 'Conservação',
        text: 'Ao contrário de Ozempic e Wegovy, o Ozivy precisa continuar na geladeira mesmo depois de aberto.'
      },
      tip: {
        after: 'Principais efeitos colaterais de Ozivy',
        text: 'Guarde a caneta na prateleira do meio da geladeira, longe do congelador e da porta. Se ela congelar, não use, mesmo depois de descongelar.'
      }
    }
  },
  poviztra: {
    slug: 'poviztra',
    title: 'Poviztra: o que é, preço, doses, receita e como funciona | Medleve',
    description:
      'Poviztra é semaglutida 2,4 mg para obesidade e sobrepeso com comorbidade, da Novo Nordisk em parceria com a Eurofarma. Veja doses, indicação, efeitos e diferença para o Wegovy.',
    h1: 'Poviztra: o que é, preço, doses, receita e como funciona',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Poviztra é uma caneta de semaglutida de até 2,4 mg, aplicada uma vez por semana. É registrada pela Novo Nordisk e comercializada no Brasil em parceria com a Eurofarma. A bula indica o uso para adultos com obesidade (IMC ≥ 30) ou sobrepeso (IMC ≥ 27) com comorbidade e para adolescentes a partir de 12 anos com obesidade. Tem o mesmo princípio ativo e as mesmas doses do Wegovy.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'O que é Poviztra?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'É um medicamento injetável à base de ' },
              { kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'semaglutida' }] },
              { kind: 'text', text: ', agonista do receptor de ' },
              { kind: 'link', url: '/glp-1', children: [{ kind: 'text', text: 'GLP-1' }] },
              { kind: 'text', text: ', voltado ao tratamento da obesidade. Foi lançado no Brasil a partir de um ' },
              {
                kind: 'link',
                url: 'https://www.bemparana.com.br/bem-estar/anvisa-aprova-primeira-caneta-nacional-com-a-mesma-substancia-do-ozempic/',
                children: [{ kind: 'text', text: 'acordo entre a Novo Nordisk e a Eurofarma' }]
              },
              { kind: 'text', text: ', que também resultou no Extensior, para diabetes tipo 2.' }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Segundo a ' },
              {
                kind: 'link',
                url: 'https://bulas.eurofarma.com.br/storage/media/19087/EiQ7d1CQXpjMvG6Hw4EkvfJXo7lanSbKBK3v3DMl.pdf',
                children: [{ kind: 'text', text: 'bula' }]
              },
              {
                kind: 'text',
                text: ', o produto é fabricado pela Novo Nordisk na Dinamarca e registrado pela Novo Nordisk Farmacêutica do Brasil.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Qual é o princípio ativo de Poviztra?',
        blocks: [
          {
            kind: 'paragraph',
            children: [{ kind: 'text', text: 'Semaglutida de origem biológica, a mesma do Wegovy.' }]
          }
        ]
      },
      {
        heading: 'Para que Poviztra é indicado?',
        blocks: [
          { kind: 'paragraph', children: [{ kind: 'text', text: 'Conforme a bula:' }] },
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'text', text: 'Adultos com IMC ≥ 30 kg/m².' }],
              [
                {
                  kind: 'text',
                  text: 'Adultos com IMC ≥ 27 e < 30 kg/m² com problema de saúde relacionado ao peso, como diabetes, hipertensão, alteração de gorduras no sangue, apneia do sono ou histórico de infarto ou AVC.'
                }
              ],
              [
                {
                  kind: 'text',
                  text: 'Adolescentes a partir de 12 anos com obesidade e peso acima de 60 kg. O tratamento só deve continuar se houver redução de pelo menos 5% do IMC após 12 semanas na dose de 2,4 mg ou na dose máxima tolerada.'
                }
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'O uso deve acompanhar alimentação com redução de calorias e atividade física.' }
            ]
          }
        ]
      },
      {
        heading: 'Como Poviztra funciona?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Aumenta a saciedade, reduz a fome e retarda o esvaziamento do estômago, levando a menor ingestão de calorias.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quais doses de Poviztra existem?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Canetas de 0,25 mg, 0,5 mg, 1 mg, 1,7 mg e 2,4 mg, cada uma com quatro doses semanais.'
              }
            ]
          },
          {
            kind: 'table',
            header: [[{ kind: 'text', text: 'Período' }], [{ kind: 'text', text: 'Dose semanal' }]],
            rows: [
              [[{ kind: 'text', text: 'Semanas 1 a 4' }], [{ kind: 'text', text: '0,25 mg' }]],
              [[{ kind: 'text', text: 'Semanas 5 a 8' }], [{ kind: 'text', text: '0,5 mg' }]],
              [[{ kind: 'text', text: 'Semanas 9 a 12' }], [{ kind: 'text', text: '1 mg' }]],
              [[{ kind: 'text', text: 'Semanas 13 a 16' }], [{ kind: 'text', text: '1,7 mg' }]],
              [[{ kind: 'text', text: 'A partir da semana 17' }], [{ kind: 'text', text: '2,4 mg (manutenção)' }]]
            ]
          },
          { kind: 'paragraph', children: [{ kind: 'text', text: 'A bula orienta não ultrapassar 2,4 mg por semana.' }] }
        ]
      },
      {
        heading: 'O que os estudos mostram?',
        blocks: [
          {
            kind: 'paragraph',
            children: [{ kind: 'text', text: 'Poviztra contém a mesma semaglutida 2,4 mg avaliada no programa STEP:' }]
          },
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa2032183',
                      children: [{ kind: 'text', text: 'STEP 1' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                { kind: 'text', text: ' perda média de 14,9% do peso em 68 semanas, contra 2,4% com placebo.' }
              ],
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1038/s41591-022-02026-4',
                      children: [{ kind: 'text', text: 'STEP 5' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                { kind: 'text', text: ' perda de 15,2% mantida em dois anos.' }
              ],
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa2208601',
                      children: [{ kind: 'text', text: 'STEP TEENS' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                { kind: 'text', text: ' em adolescentes, queda de 16,1% do IMC.' }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Poviztra precisa de receita?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Sim, ' },
              {
                kind: 'link',
                url: 'https://portal.afya.com.br/saude/medicamentos-agonistas-glp-1-terao-retencao-de-receita',
                children: [{ kind: 'text', text: 'em duas vias, com retenção' }]
              },
              { kind: 'text', text: '. A receita vale 90 dias e pode ser digital.' }
            ]
          }
        ]
      },
      {
        heading: 'Quanto custa Poviztra?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Preços divulgados pela Eurofarma no ' },
              {
                kind: 'link',
                url: 'https://olhardigital.com.br/2026/08/22/medicina-e-saude/eurofarma-reduz-preco-do-poviztra-caneta-com-semaglutida-para-doses-de-17-mg-e-24-mg/',
                children: [{ kind: 'text', text: 'programa EuroCuida' }]
              },
              { kind: 'text', text: ', por caneta, vigentes desde agosto de 2026:' }
            ]
          },
          {
            kind: 'table',
            header: [
              [{ kind: 'text', text: 'Dose' }],
              [{ kind: 'text', text: 'Preço EuroCuida' }],
              [{ kind: 'text', text: 'Preço anterior' }]
            ],
            rows: [
              [
                [{ kind: 'text', text: '0,25 mg' }],
                [{ kind: 'text', text: 'R$ 445,00' }],
                [{ kind: 'text', text: '—' }]
              ],
              [
                [{ kind: 'text', text: '0,5 mg' }],
                [{ kind: 'text', text: 'R$ 445,00' }],
                [{ kind: 'text', text: '—' }]
              ],
              [[{ kind: 'text', text: '1 mg' }], [{ kind: 'text', text: 'R$ 490,00' }], [{ kind: 'text', text: '—' }]],
              [
                [{ kind: 'text', text: '1,7 mg' }],
                [{ kind: 'text', text: 'R$ 829,00' }],
                [{ kind: 'text', text: 'R$ 1.189,00' }]
              ],
              [
                [{ kind: 'text', text: '2,4 mg' }],
                [{ kind: 'text', text: 'R$ 1.169,00' }],
                [{ kind: 'text', text: 'R$ 1.444,00' }]
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Condições: é preciso estar cadastrado no EuroCuida. Os preços de 1,7 mg e 2,4 mg valem para quem comprou ao menos uma caixa de Poviztra nos 80 dias anteriores. Em junho de 2026, a Eurofarma também divulgou um '
              },
              {
                kind: 'link',
                url: 'https://neofeed.com.br/negocios/dona-do-mounjaro-corta-precos-e-acirra-a-disputa-das-canetas-emagrecedoras-no-brasil/en/',
                children: [{ kind: 'text', text: 'combo de início com as canetas de 0,25 mg e 0,5 mg por R$ 599' }]
              },
              {
                kind: 'text',
                text: ': confirmar a vigência no programa. Fora do programa, o preço é maior e varia entre farmácias.'
              }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Os valores são os divulgados pelo fabricante e podem mudar sem aviso. O preço final depende da farmácia. O paciente pode comprar na farmácia de sua preferência ou em uma farmácia parceira disponível na plataforma.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Conservação',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Antes do primeiro uso, guardar na geladeira (2 °C a 8 °C), sem congelar. Depois do primeiro uso, a caneta pode ficar por até seis semanas em temperatura abaixo de 30 °C ou na geladeira, protegida da luz.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Principais efeitos colaterais de Poviztra',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Segundo a bula, são muito comuns: dor de cabeça, náusea, vômito, diarreia, constipação, dor de estômago e cansaço. São comuns: tontura, má digestão, gases, refluxo, pedra na vesícula, queda de cabelo, reação no local da aplicação e alteração do paladar. Pancreatite é incomum, mas grave: dor abdominal forte e persistente exige atendimento.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Contraindicações de Poviztra',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'text', text: 'Alergia à semaglutida ou a componentes da fórmula.' }],
              [
                {
                  kind: 'text',
                  text: 'Gravidez e amamentação. Interromper ao menos dois meses antes de uma gravidez planejada.'
                }
              ],
              [
                {
                  kind: 'text',
                  text: 'Não recomendado para menores de 12 anos, em diabetes tipo 1, em insuficiência renal ou hepática grave e junto com outros produtos para perda de peso.'
                }
              ],
              [
                {
                  kind: 'text',
                  text: 'Histórico pessoal ou familiar de carcinoma medular de tireoide ou neoplasia endócrina múltipla tipo 2: informar o médico.'
                }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Diferenças entre Poviztra e outros medicamentos',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                { kind: 'link', url: '/wegovy-ou-poviztra', children: [{ kind: 'text', text: 'Wegovy ou Poviztra' }] },
                { kind: 'text', text: ': mesma molécula, mesmas doses, marcas diferentes.' }
              ],
              [
                {
                  kind: 'link',
                  url: '/semaglutida-ou-tirzepatida',
                  children: [{ kind: 'text', text: 'Semaglutida ou tirzepatida' }]
                }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Consulta médica online',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Na Medleve, o médico avalia seu caso por mensagem ou vídeo. Se houver indicação clínica, emite a receita digital, e você escolhe onde comprar.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'O que é Poviztra?',
        answer: [
          {
            kind: 'text',
            text: 'É uma caneta de semaglutida de até 2,4 mg, de aplicação semanal, indicada para obesidade e sobrepeso com comorbidade.'
          }
        ]
      },
      {
        question: 'Poviztra é semaglutida?',
        answer: [{ kind: 'text', text: 'Sim, a mesma semaglutida biológica do Wegovy.' }]
      },
      {
        question: 'Para que Poviztra é indicado?',
        answer: [
          {
            kind: 'text',
            text: 'Para adultos com IMC ≥ 30, ou ≥ 27 com comorbidade relacionada ao peso, e adolescentes a partir de 12 anos com obesidade.'
          }
        ]
      },
      {
        question: 'Poviztra precisa de receita?',
        answer: [{ kind: 'text', text: 'Sim, em duas vias, com retenção. Vale 90 dias.' }]
      },
      { question: 'Quais doses existem?', answer: [{ kind: 'text', text: '0,25 mg, 0,5 mg, 1 mg, 1,7 mg e 2,4 mg.' }] },
      {
        question: 'Quanto custa Poviztra?',
        answer: [
          {
            kind: 'text',
            text: 'Pelo programa EuroCuida, da Eurofarma, de R$ 445,00 (0,25 mg) a R$ 1.169,00 (2,4 mg) por caneta.'
          }
        ]
      },
      {
        question: 'Poviztra e Wegovy são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'Têm o mesmo princípio ativo, as mesmas doses e o mesmo fabricante. São marcas diferentes, com preço e disponibilidade próprios.'
          }
        ]
      },
      {
        question: 'Poviztra e Ozempic são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'Não. Ambos são semaglutida, mas Ozempic vai até 1 mg e é aprovado para diabetes tipo 2.'
          }
        ]
      },
      {
        question: 'Quais são os principais efeitos colaterais?',
        answer: [{ kind: 'text', text: 'Náusea, vômito, diarreia, constipação, dor de cabeça e cansaço.' }]
      },
      {
        question: 'Como funciona uma avaliação médica online para Poviztra?',
        answer: [
          {
            kind: 'text',
            text: 'Você preenche um questionário, é atendido por mensagem ou vídeo e, se houver indicação, recebe a receita digital.'
          }
        ]
      }
    ],
    sources: [
      {
        title: 'Bula de Poviztra (semaglutida).',
        url: 'https://bulas.eurofarma.com.br/storage/media/19087/EiQ7d1CQXpjMvG6Hw4EkvfJXo7lanSbKBK3v3DMl.pdf'
      },
      { title: 'Wilding JPH et al. STEP 1. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2032183' },
      { title: 'Garvey WT et al. STEP 5. Nature Medicine, 2022.', url: 'https://doi.org/10.1038/s41591-022-02026-4' },
      { title: 'Weghuber D et al. STEP TEENS. NEJM, 2022.', url: 'https://doi.org/10.1056/NEJMoa2208601' },
      {
        title: 'Olhar Digital. Eurofarma reduz preço do Poviztra.',
        url: 'https://olhardigital.com.br/2026/08/22/medicina-e-saude/eurofarma-reduz-preco-do-poviztra-caneta-com-semaglutida-para-doses-de-17-mg-e-24-mg/'
      },
      {
        title: 'Bem Paraná / Folhapress. Anvisa aprova primeira caneta nacional com a mesma substância do Ozempic.',
        url: 'https://www.bemparana.com.br/bem-estar/anvisa-aprova-primeira-caneta-nacional-com-a-mesma-substancia-do-ozempic/'
      },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' }
    ],
    unresolved: [],
    article: {
      points: [
        'Poviztra tem a mesma semaglutida e as mesmas doses do Wegovy.',
        'É indicado para obesidade, sobrepeso com comorbidade e adolescentes a partir de 12 anos.',
        'Pelo programa EuroCuida, de R$ 445 a R$ 1.169 por caneta.'
      ],
      info: {
        after: 'O que é Poviztra?',
        text: 'Poviztra e Wegovy são fabricados pela Novo Nordisk na Dinamarca. A diferença está na marca e na comercialização no Brasil.'
      },
      tip: {
        after: 'Principais efeitos colaterais de Poviztra',
        text: 'Em viagens, leve a caneta na bagagem de mão, em uma bolsa térmica, sem contato direto com gelo. Depois de aberta, ela pode ficar até seis semanas abaixo de 30 °C.'
      }
    }
  },
  'semaglutida-ou-tirzepatida': {
    slug: 'semaglutida-ou-tirzepatida',
    title: 'Semaglutida ou tirzepatida: diferenças, eficácia e efeitos | Medleve',
    description:
      'Compare semaglutida (Wegovy, Ozempic) e tirzepatida (Mounjaro): mecanismo, perda de peso no estudo SURMOUNT-5, evidência cardiovascular, efeitos colaterais e indicações.',
    h1: 'Semaglutida ou tirzepatida: quais são as diferenças?',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Semaglutida e tirzepatida são medicamentos injetáveis semanais usados no tratamento do diabetes tipo 2 e da obesidade. A semaglutida ativa o receptor de GLP-1. A tirzepatida ativa dois receptores, GIP e GLP-1. No estudo SURMOUNT-5, a perda média de peso em 72 semanas foi de 20,2% com tirzepatida e 13,7% com semaglutida 2,4 mg. A semaglutida tem mais evidência de redução de eventos cardiovasculares.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'Comparação',
        blocks: [
          {
            kind: 'table',
            header: [[], [{ kind: 'text', text: 'Semaglutida' }], [{ kind: 'text', text: 'Tirzepatida' }]],
            rows: [
              [
                [{ kind: 'text', text: 'Mecanismo' }],
                [{ kind: 'text', text: 'Agonista de GLP-1' }],
                [{ kind: 'text', text: 'Agonista de GIP e GLP-1' }]
              ],
              [
                [{ kind: 'text', text: 'Marcas no Brasil' }],
                [
                  { kind: 'link', url: '/wegovy', children: [{ kind: 'text', text: 'Wegovy' }] },
                  { kind: 'text', text: ', ' },
                  { kind: 'link', url: '/poviztra', children: [{ kind: 'text', text: 'Poviztra' }] },
                  { kind: 'text', text: ', ' },
                  { kind: 'link', url: '/ozempic', children: [{ kind: 'text', text: 'Ozempic' }] },
                  { kind: 'text', text: ', ' },
                  { kind: 'link', url: '/ozivy', children: [{ kind: 'text', text: 'Ozivy' }] },
                  { kind: 'text', text: ', ' },
                  { kind: 'link', url: '/semavy', children: [{ kind: 'text', text: 'Semavy' }] }
                ],
                [{ kind: 'link', url: '/mounjaro', children: [{ kind: 'text', text: 'Mounjaro' }] }]
              ],
              [
                [{ kind: 'text', text: 'Dose máxima semanal' }],
                [{ kind: 'text', text: '2,4 mg (obesidade); 1 mg (diabetes)' }],
                [{ kind: 'text', text: '15 mg' }]
              ],
              [
                [{ kind: 'text', text: 'Perda média de peso' }],
                [
                  { kind: 'text', text: '14,9% (' },
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2032183',
                    children: [{ kind: 'text', text: 'STEP 1' }]
                  },
                  { kind: 'text', text: ')' }
                ],
                [
                  { kind: 'text', text: '20,9% com 15 mg (' },
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2206038',
                    children: [{ kind: 'text', text: 'SURMOUNT-1' }]
                  },
                  { kind: 'text', text: ')' }
                ]
              ],
              [
                [
                  { kind: 'text', text: 'Comparação direta (' },
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2416394',
                    children: [{ kind: 'text', text: 'SURMOUNT-5' }]
                  },
                  { kind: 'text', text: ')' }
                ],
                [{ kind: 'text', text: '13,7%' }],
                [{ kind: 'text', text: '20,2%' }]
              ],
              [
                [{ kind: 'text', text: 'Desfecho cardiovascular em obesidade' }],
                [
                  { kind: 'text', text: 'Redução de 20% (' },
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2307563',
                    children: [{ kind: 'text', text: 'SELECT' }]
                  },
                  { kind: 'text', text: ')' }
                ],
                [{ kind: 'text', text: 'Sem indicação aprovada no Brasil até a data desta revisão' }]
              ],
              [
                [{ kind: 'text', text: 'Outras indicações' }],
                [{ kind: 'text', text: 'Adolescentes ≥ 12 anos; MASH; doença renal no diabetes' }],
                [{ kind: 'text', text: 'Apneia do sono com obesidade' }]
              ],
              [
                [{ kind: 'text', text: 'Opções de menor custo' }],
                [{ kind: 'text', text: 'Sim (Ozivy, Semavy e genéricos, para diabetes)' }],
                [{ kind: 'text', text: 'Não' }]
              ]
            ]
          }
        ]
      },
      {
        heading: 'Perda de peso',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'O ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2416394',
                children: [{ kind: 'text', text: 'SURMOUNT-5' }]
              },
              {
                kind: 'text',
                text: ' é o único grande estudo que comparou as duas moléculas diretamente em obesidade. Em 751 adultos sem diabetes, a tirzepatida levou a uma perda média de 20,2% do peso, contra 13,7% com semaglutida. A cintura diminuiu 18,4 cm e 13,0 cm, respectivamente.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Diabetes tipo 2',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'No ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2107519',
                children: [{ kind: 'text', text: 'SURPASS-2' }]
              },
              {
                kind: 'text',
                text: ', a tirzepatida reduziu a hemoglobina glicada em até 2,30 pontos percentuais, contra 1,86 com semaglutida 1 mg.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Coração e rins',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A semaglutida tem os resultados mais sólidos em desfechos: redução de 20% em eventos cardiovasculares em pessoas com obesidade e doença cardiovascular ('
              },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2307563',
                children: [{ kind: 'text', text: 'SELECT' }]
              },
              { kind: 'text', text: '), de 26% em pessoas com diabetes tipo 2 (' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa1607141',
                children: [{ kind: 'text', text: 'SUSTAIN-6' }]
              },
              { kind: 'text', text: ') e de 24% na progressão de doença renal (' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2403347',
                children: [{ kind: 'text', text: 'FLOW' }]
              },
              { kind: 'text', text: ').' }
            ]
          }
        ]
      },
      {
        heading: 'Efeitos colaterais',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Os dois causam principalmente náusea, diarreia, vômito e constipação, mais frequentes no aumento de dose. Compartilham as precauções sobre pancreatite, vesícula biliar, gravidez e histórico de carcinoma medular de tireoide. A tirzepatida exige atenção adicional com anticoncepcionais orais.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Manutenção',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Com as duas moléculas, interromper o tratamento leva à recuperação de parte do peso: cerca de dois terços em um ano após a semaglutida ('
              },
              {
                kind: 'link',
                url: 'https://doi.org/10.1111/dom.14725',
                children: [{ kind: 'text', text: 'extensão do STEP 1' }]
              },
              { kind: 'text', text: ') e 14,0% em 52 semanas após a tirzepatida (' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1001/jama.2023.24945',
                children: [{ kind: 'text', text: 'SURMOUNT-4' }]
              },
              { kind: 'text', text: ').' }
            ]
          }
        ]
      },
      {
        heading: 'Como o médico escolhe?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Considera o diagnóstico, a quantidade de peso a perder, a presença de doença cardiovascular, renal ou apneia do sono, a tolerância e o custo. Não há uma molécula melhor para todos os pacientes.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'Qual a diferença entre semaglutida e tirzepatida?',
        answer: [{ kind: 'text', text: 'A semaglutida ativa o receptor de GLP-1. A tirzepatida ativa GIP e GLP-1.' }]
      },
      {
        question: 'Qual emagrece mais?',
        answer: [
          {
            kind: 'text',
            text: 'Na comparação direta do SURMOUNT-5, a tirzepatida levou a maior perda média de peso (20,2% contra 13,7%).'
          }
        ]
      },
      {
        question: 'Qual tem mais evidência para o coração?',
        answer: [{ kind: 'text', text: 'A semaglutida, com os estudos SELECT e SUSTAIN-6.' }]
      },
      {
        question: 'Quais marcas usam cada uma?',
        answer: [
          { kind: 'text', text: 'Semaglutida: Wegovy, Poviztra, Ozempic, Ozivy e Semavy. Tirzepatida: Mounjaro.' }
        ]
      },
      {
        question: 'Os efeitos colaterais são iguais?',
        answer: [{ kind: 'text', text: 'São parecidos, principalmente gastrointestinais.' }]
      },
      {
        question: 'Qual é mais barata?',
        answer: [{ kind: 'text', text: 'Em geral, a semaglutida, sobretudo nas versões sintéticas para diabetes.' }]
      },
      {
        question: 'É possível trocar de uma para a outra?',
        answer: [{ kind: 'text', text: 'Sim, com orientação médica e ajuste de dose.' }]
      },
      {
        question: 'Qual é mais adequada para mim?',
        answer: [{ kind: 'text', text: 'Depende da avaliação médica do seu caso.' }]
      }
    ],
    sources: [
      { title: 'Aronne LJ et al. SURMOUNT-5. NEJM, 2025.', url: 'https://doi.org/10.1056/NEJMoa2416394' },
      { title: 'Wilding JPH et al. STEP 1. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2032183' },
      { title: 'Jastreboff AM et al. SURMOUNT-1. NEJM, 2022.', url: 'https://doi.org/10.1056/NEJMoa2206038' },
      { title: 'Frías JP et al. SURPASS-2. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2107519' },
      { title: 'Lincoff AM et al. SELECT. NEJM, 2023.', url: 'https://doi.org/10.1056/NEJMoa2307563' },
      { title: 'Marso SP et al. SUSTAIN-6. NEJM, 2016.', url: 'https://doi.org/10.1056/NEJMoa1607141' },
      { title: 'Perkovic V et al. FLOW. NEJM, 2024.', url: 'https://doi.org/10.1056/NEJMoa2403347' },
      {
        title: 'Wilding JPH et al. Extensão do STEP 1. Diabetes Obes Metab, 2022.',
        url: 'https://doi.org/10.1111/dom.14725'
      },
      { title: 'Aronne LJ et al. SURMOUNT-4. JAMA, 2024.', url: 'https://doi.org/10.1001/jama.2023.24945' }
    ],
    unresolved: [],
    article: {
      points: [
        'A semaglutida age em GLP-1; a tirzepatida, em GIP e GLP-1.',
        'Na comparação direta, a tirzepatida levou a mais perda de peso (20,2% contra 13,7%).',
        'A semaglutida tem mais evidência de redução de eventos cardiovasculares.'
      ],
      info: {
        after: 'Perda de peso',
        text: 'As duas moléculas exigem aumento gradual de dose, e os resultados dos estudos foram medidos depois de mais de um ano de tratamento.'
      },
      tip: {
        after: 'Manutenção',
        text: 'Pese-se sempre no mesmo dia da semana, de manhã e em jejum. Variações diárias de peso são normais e não indicam que o tratamento falhou.'
      }
    }
  },
  semaglutida: {
    slug: 'semaglutida',
    title: 'Semaglutida: o que é, para que serve, marcas e efeitos | Medleve',
    description:
      'Semaglutida é o princípio ativo de Wegovy, Poviztra, Ozempic, Ozivy e Semavy. Veja como funciona, as diferenças entre as marcas, resultados dos estudos e efeitos colaterais.',
    h1: 'Semaglutida: o que é, para que serve e quais marcas existem',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Semaglutida é um agonista do receptor de GLP-1 de aplicação semanal. No Brasil, é o princípio ativo de Wegovy e Poviztra (2,4 mg, para obesidade e sobrepeso com comorbidade) e de Ozempic, Ozivy e Semavy (até 1 mg, para diabetes tipo 2). No estudo STEP 1, a dose de 2,4 mg levou a uma perda média de 14,9% do peso em 68 semanas. A venda exige receita com retenção.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'O que é semaglutida?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'É uma molécula semelhante ao hormônio ' },
              { kind: 'link', url: '/glp-1', children: [{ kind: 'text', text: 'GLP-1' }] },
              {
                kind: 'text',
                text: ', modificada para permanecer ativa por cerca de uma semana. Existe em caneta injetável de uso subcutâneo semanal e também em comprimido diário (Rybelsus, para diabetes tipo 2).'
              }
            ]
          }
        ]
      },
      {
        heading: 'Como a semaglutida funciona?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Ela aumenta a saciedade, reduz a fome, retarda o esvaziamento do estômago e melhora a secreção de insulina quando a glicose está elevada. O resultado é menor ingestão de calorias e melhor controle glicêmico.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quais medicamentos usam semaglutida?',
        blocks: [
          {
            kind: 'table',
            header: [
              [{ kind: 'text', text: 'Marca' }],
              [{ kind: 'text', text: 'Dose de manutenção' }],
              [{ kind: 'text', text: 'Origem' }],
              [{ kind: 'text', text: 'Indicação aprovada pela Anvisa' }]
            ],
            rows: [
              [
                [{ kind: 'link', url: '/wegovy', children: [{ kind: 'text', text: 'Wegovy' }] }],
                [{ kind: 'text', text: '2,4 mg/semana' }],
                [{ kind: 'text', text: 'Biológica (Novo Nordisk)' }],
                [
                  {
                    kind: 'text',
                    text: 'Obesidade; sobrepeso com comorbidade; adolescentes ≥ 12 anos; redução de risco cardiovascular'
                  }
                ]
              ],
              [
                [{ kind: 'link', url: '/poviztra', children: [{ kind: 'text', text: 'Poviztra' }] }],
                [{ kind: 'text', text: '2,4 mg/semana' }],
                [{ kind: 'text', text: 'Biológica (Novo Nordisk, parceria com Eurofarma)' }],
                [{ kind: 'text', text: 'Obesidade; sobrepeso com comorbidade; adolescentes ≥ 12 anos' }]
              ],
              [
                [{ kind: 'link', url: '/ozempic', children: [{ kind: 'text', text: 'Ozempic' }] }],
                [{ kind: 'text', text: '0,5 a 1 mg/semana' }],
                [{ kind: 'text', text: 'Biológica (Novo Nordisk)' }],
                [{ kind: 'text', text: 'Diabetes tipo 2' }]
              ],
              [
                [{ kind: 'link', url: '/ozivy', children: [{ kind: 'text', text: 'Ozivy' }] }],
                [{ kind: 'text', text: '0,5 a 1 mg/semana' }],
                [{ kind: 'text', text: 'Sintética (EMS)' }],
                [{ kind: 'text', text: 'Diabetes tipo 2' }]
              ],
              [
                [{ kind: 'link', url: '/semavy', children: [{ kind: 'text', text: 'Semavy' }] }],
                [{ kind: 'text', text: '0,5 a 1 mg/semana' }],
                [{ kind: 'text', text: 'Sintética (Hypera Pharma)' }],
                [{ kind: 'text', text: 'Diabetes tipo 2' }]
              ]
            ]
          }
        ]
      },
      {
        heading: 'As marcas de semaglutida são iguais?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'O princípio ativo é o mesmo, mas os produtos não são intercambiáveis por conta própria. Eles diferem em três pontos:'
              }
            ]
          },
          {
            kind: 'list',
            ordered: true,
            items: [
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Dose máxima.' }] },
                { kind: 'text', text: ' Wegovy e Poviztra chegam a 2,4 mg. Ozempic, Ozivy e Semavy vão até 1 mg.' }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Indicação de bula.' }] },
                { kind: 'text', text: ' Só Wegovy e Poviztra têm indicação para obesidade.' }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Origem e registro.' }] },
                {
                  kind: 'text',
                  text: ' Ozivy e Semavy são semaglutidas sintéticas, registradas pela Anvisa como medicamentos novos, e '
                },
                {
                  kind: 'link',
                  url: 'https://www.bemparana.com.br/bem-estar/anvisa-aprova-primeira-caneta-nacional-com-a-mesma-substancia-do-ozempic/',
                  children: [{ kind: 'text', text: 'não como genéricos ou biossimilares' }]
                },
                { kind: 'text', text: '.' }
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'A dose influencia o resultado. No ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1016/S0140-6736%2821%2900213-0',
                children: [{ kind: 'text', text: 'STEP 2' }]
              },
              {
                kind: 'text',
                text: ', em pessoas com diabetes tipo 2, a perda média de peso foi de 9,6% com 2,4 mg, 7,0% com 1,0 mg e 3,4% com placebo.'
              }
            ]
          }
        ]
      },
      {
        heading: 'O que os estudos mostram?',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Peso:' }] },
                { kind: 'text', text: ' no ' },
                {
                  kind: 'link',
                  url: 'https://doi.org/10.1056/NEJMoa2032183',
                  children: [{ kind: 'text', text: 'STEP 1' }]
                },
                {
                  kind: 'text',
                  text: ', 1.961 adultos com obesidade ou sobrepeso perderam em média 14,9% do peso em 68 semanas com 2,4 mg, contra 2,4% com placebo. 86,4% perderam ao menos 5%.'
                }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Longo prazo:' }] },
                { kind: 'text', text: ' no ' },
                {
                  kind: 'link',
                  url: 'https://doi.org/10.1038/s41591-022-02026-4',
                  children: [{ kind: 'text', text: 'STEP 5' }]
                },
                { kind: 'text', text: ', a perda média foi de 15,2% após 104 semanas.' }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Coração:' }] },
                { kind: 'text', text: ' no ' },
                {
                  kind: 'link',
                  url: 'https://doi.org/10.1056/NEJMoa2307563',
                  children: [{ kind: 'text', text: 'SELECT' }]
                },
                {
                  kind: 'text',
                  text: ', com 17.604 adultos com doença cardiovascular e sobrepeso ou obesidade, sem diabetes, a semaglutida 2,4 mg reduziu em 20% o risco de infarto, AVC ou morte cardiovascular.'
                }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Diabetes:' }] },
                { kind: 'text', text: ' no ' },
                {
                  kind: 'link',
                  url: 'https://doi.org/10.1056/NEJMoa1607141',
                  children: [{ kind: 'text', text: 'SUSTAIN-6' }]
                },
                {
                  kind: 'text',
                  text: ', a semaglutida reduziu em 26% os eventos cardiovasculares maiores em pessoas com diabetes tipo 2.'
                }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Rins:' }] },
                { kind: 'text', text: ' no ' },
                {
                  kind: 'link',
                  url: 'https://doi.org/10.1056/NEJMoa2403347',
                  children: [{ kind: 'text', text: 'FLOW' }]
                },
                {
                  kind: 'text',
                  text: ', reduziu em 24% o risco de progressão da doença renal em pessoas com diabetes tipo 2 e doença renal crônica.'
                }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Adolescentes:' }] },
                { kind: 'text', text: ' no ' },
                {
                  kind: 'link',
                  url: 'https://doi.org/10.1056/NEJMoa2208601',
                  children: [{ kind: 'text', text: 'STEP TEENS' }]
                },
                { kind: 'text', text: ', o IMC caiu 16,1% com semaglutida e subiu 0,6% com placebo em 68 semanas.' }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Efeitos colaterais',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Segundo a ' },
              {
                kind: 'link',
                url: 'https://bulas.eurofarma.com.br/storage/media/19087/EiQ7d1CQXpjMvG6Hw4EkvfJXo7lanSbKBK3v3DMl.pdf',
                children: [{ kind: 'text', text: 'bula da semaglutida 2,4 mg' }]
              },
              {
                kind: 'text',
                text: ', são muito comuns (mais de 1 em cada 10 pessoas): dor de cabeça, náusea, vômito, diarreia, constipação, dor abdominal e cansaço. São comuns: tontura, azia, gases, refluxo, pedra na vesícula, queda de cabelo e reações no local da aplicação.'
              }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Procure atendimento se houver dor abdominal intensa e persistente, que pode irradiar para as costas (sinal de pancreatite), ou alteração súbita da visão.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quem não deve usar',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'text', text: 'Alergia à semaglutida ou a componentes da fórmula.' }],
              [
                {
                  kind: 'text',
                  text: 'Gravidez e amamentação. A bula orienta interromper o uso ao menos dois meses antes de uma gravidez planejada.'
                }
              ],
              [
                {
                  kind: 'text',
                  text: 'Histórico pessoal ou familiar de carcinoma medular de tireoide ou neoplasia endócrina múltipla tipo 2: avaliar com o médico.'
                }
              ],
              [
                {
                  kind: 'text',
                  text: 'Uso não recomendado em diabetes tipo 1, insuficiência renal ou hepática grave e retinopatia diabética sem acompanhamento.'
                }
              ]
            ]
          }
        ]
      },
      {
        heading: 'O que acontece ao parar?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Na ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1111/dom.14725',
                children: [{ kind: 'text', text: 'extensão do STEP 1' }]
              },
              {
                kind: 'text',
                text: ', um ano depois de interromper a semaglutida os participantes recuperaram cerca de dois terços do peso perdido. No '
              },
              {
                kind: 'link',
                url: 'https://doi.org/10.1001/jama.2021.3224',
                children: [{ kind: 'text', text: 'STEP 4' }]
              },
              {
                kind: 'text',
                text: ', quem manteve o tratamento continuou perdendo peso (mais 7,9%), enquanto quem passou para placebo recuperou 6,9%.'
              }
            ]
          }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'O que é semaglutida?',
        answer: [
          {
            kind: 'text',
            text: 'É um medicamento que imita o hormônio GLP-1, aplicado uma vez por semana, usado para diabetes tipo 2 e, na dose de 2,4 mg, para obesidade.'
          }
        ]
      },
      {
        question: 'Como a semaglutida funciona?',
        answer: [
          {
            kind: 'text',
            text: 'Aumenta a saciedade, reduz a fome, retarda o esvaziamento do estômago e melhora o controle da glicose.'
          }
        ]
      },
      {
        question: 'Quais medicamentos usam semaglutida?',
        answer: [
          {
            kind: 'text',
            text: 'Wegovy, Poviztra, Ozempic, Ozivy, Semavy e o comprimido Rybelsus, além de genéricos registrados em 2026.'
          }
        ]
      },
      {
        question: 'Wegovy, Ozempic, Poviztra, Semavy e Ozivy são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'Têm o mesmo princípio ativo, mas doses máximas e indicações diferentes. Wegovy e Poviztra chegam a 2,4 mg e são aprovados para obesidade; os outros vão até 1 mg e são aprovados para diabetes tipo 2.'
          }
        ]
      },
      {
        question: 'Semaglutida serve para obesidade?',
        answer: [
          {
            kind: 'text',
            text: 'Na dose de 2,4 mg (Wegovy e Poviztra), sim: é aprovada para obesidade e para sobrepeso com comorbidade relacionada ao peso.'
          }
        ]
      },
      {
        question: 'Semaglutida serve para diabetes?',
        answer: [
          { kind: 'text', text: 'Sim. Em doses de até 1 mg (Ozempic, Ozivy, Semavy), é aprovada para diabetes tipo 2.' }
        ]
      },
      {
        question: 'Semaglutida precisa de receita?',
        answer: [
          {
            kind: 'text',
            text: 'Sim, com retenção de uma via pela farmácia. A receita vale 90 dias e pode ser digital.'
          }
        ]
      },
      {
        question: 'Quais são os efeitos colaterais mais comuns?',
        answer: [{ kind: 'text', text: 'Náusea, diarreia, vômito, constipação, dor abdominal e dor de cabeça.' }]
      },
      {
        question: 'Qual a diferença entre semaglutida e tirzepatida?',
        answer: [
          {
            kind: 'text',
            text: 'A tirzepatida age em dois receptores (GIP e GLP-1). No SURMOUNT-5, levou a uma perda média de 20,2% do peso, contra 13,7% com semaglutida 2,4 mg. Veja '
          },
          {
            kind: 'link',
            url: '/semaglutida-ou-tirzepatida',
            children: [{ kind: 'text', text: 'semaglutida ou tirzepatida' }]
          },
          { kind: 'text', text: '.' }
        ]
      },
      {
        question: 'Como saber qual marca de semaglutida é adequada ao meu caso?',
        answer: [
          {
            kind: 'text',
            text: 'Depende do diagnóstico, da dose necessária, das contraindicações e do custo. Essa escolha é feita pelo médico na consulta.'
          }
        ]
      }
    ],
    sources: [
      { title: 'Wilding JPH et al. STEP 1. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2032183' },
      { title: 'Davies M et al. STEP 2. Lancet, 2021.', url: 'https://doi.org/10.1016/S0140-6736%2821%2900213-0' },
      { title: 'Rubino D et al. STEP 4. JAMA, 2021.', url: 'https://doi.org/10.1001/jama.2021.3224' },
      { title: 'Garvey WT et al. STEP 5. Nature Medicine, 2022.', url: 'https://doi.org/10.1038/s41591-022-02026-4' },
      { title: 'Weghuber D et al. STEP TEENS. NEJM, 2022.', url: 'https://doi.org/10.1056/NEJMoa2208601' },
      { title: 'Lincoff AM et al. SELECT. NEJM, 2023.', url: 'https://doi.org/10.1056/NEJMoa2307563' },
      { title: 'Marso SP et al. SUSTAIN-6. NEJM, 2016.', url: 'https://doi.org/10.1056/NEJMoa1607141' },
      { title: 'Perkovic V et al. FLOW. NEJM, 2024.', url: 'https://doi.org/10.1056/NEJMoa2403347' },
      {
        title: 'Wilding JPH et al. Extensão do STEP 1. Diabetes Obes Metab, 2022.',
        url: 'https://doi.org/10.1111/dom.14725'
      },
      {
        title: 'Bula de Poviztra (semaglutida 2,4 mg).',
        url: 'https://bulas.eurofarma.com.br/storage/media/19087/EiQ7d1CQXpjMvG6Hw4EkvfJXo7lanSbKBK3v3DMl.pdf'
      },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' }
    ],
    unresolved: [],
    article: {
      points: [
        'A semaglutida é o princípio ativo de Wegovy, Poviztra, Ozempic, Ozivy e Semavy.',
        'Na dose de 2,4 mg, a perda média de peso foi de 14,9% em 68 semanas (STEP 1).',
        'No estudo SELECT, reduziu em 20% o risco de infarto, AVC ou morte cardiovascular.'
      ],
      info: {
        after: 'As marcas de semaglutida são iguais?',
        text: 'As canetas de semaglutida não são intercambiáveis: concentração, dose máxima e indicação mudam de uma marca para outra. Qualquer troca exige nova receita.'
      },
      tip: {
        after: 'Efeitos colaterais',
        text: 'Escolha um dia fixo da semana para a aplicação e programe um lembrete no celular. Se esquecer uma dose, siga a orientação da bula sobre o prazo para aplicá-la e nunca aplique duas doses juntas.'
      }
    }
  },
  'semavy-ou-ozempic': {
    slug: 'semavy-ou-ozempic',
    title: 'Semavy ou Ozempic: diferenças, indicação e preço | Medleve',
    description:
      'Semavy e Ozempic são semaglutida para diabetes tipo 2. Semavy é sintética, da Hypera Pharma; Ozempic é biológico, da Novo Nordisk. Compare origem, registro e preço.',
    h1: 'Semavy ou Ozempic: quais são as diferenças?',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Semavy e Ozempic são canetas semanais de semaglutida aprovadas pela Anvisa para diabetes tipo 2. Ozempic é o medicamento de referência, de origem biológica, da Novo Nordisk. Semavy é uma semaglutida sintética, da Hypera Pharma, registrada em julho de 2026 como medicamento novo, e não como genérico. A principal diferença prática é o preço, menor no Semavy. Nenhum dos dois tem indicação de bula para obesidade.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'Comparação',
        blocks: [
          {
            kind: 'table',
            header: [[], [{ kind: 'text', text: 'Semavy' }], [{ kind: 'text', text: 'Ozempic' }]],
            rows: [
              [
                [{ kind: 'text', text: 'Princípio ativo' }],
                [
                  { kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'Semaglutida' }] },
                  { kind: 'text', text: ' sintética' }
                ],
                [
                  { kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'Semaglutida' }] },
                  { kind: 'text', text: ' biológica' }
                ]
              ],
              [
                [{ kind: 'text', text: 'Fabricante' }],
                [{ kind: 'text', text: 'Hypera Pharma' }],
                [{ kind: 'text', text: 'Novo Nordisk' }]
              ],
              [
                [{ kind: 'text', text: 'Indicação aprovada' }],
                [{ kind: 'text', text: 'Diabetes tipo 2' }],
                [{ kind: 'text', text: 'Diabetes tipo 2 (inclui risco cardiovascular e doença renal)' }]
              ],
              [
                [{ kind: 'text', text: 'Classificação na Anvisa' }],
                [{ kind: 'text', text: 'Medicamento novo' }],
                [{ kind: 'text', text: 'Medicamento de referência' }]
              ],
              [
                [{ kind: 'text', text: 'Preço no programa do fabricante' }],
                [
                  {
                    kind: 'link',
                    url: 'https://www.voysaude.com.br/blog/semavy-o-que-e-preco',
                    children: [{ kind: 'text', text: 'R$ 333 por caneta de 1 mg' }]
                  },
                  { kind: 'text', text: ' (Mantecorp Saúde)' }
                ],
                [
                  {
                    kind: 'link',
                    url: 'https://www.programanovodia.com.br/produtos.html',
                    children: [{ kind: 'text', text: 'R$ 975 a R$ 999' }]
                  },
                  { kind: 'text', text: ' por caneta (NovoDia, e-commerce)' }
                ]
              ]
            ]
          }
        ]
      },
      {
        heading: 'Semavy é genérico do Ozempic?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Não. Pela regulação brasileira, não existe genérico de produto biológico. O Semavy foi '
              },
              {
                kind: 'link',
                url: 'https://www.bemparana.com.br/bem-estar/nova-caneta-de-semaglutida-sintetica-produzida-no-brasil-e-a-semavy-da-hypera-pharma/',
                children: [{ kind: 'text', text: 'registrado como medicamento novo' }]
              },
              { kind: 'text', text: ', com dossiê próprio. Os primeiros genéricos de semaglutida foram ' },
              {
                kind: 'link',
                url: 'https://revistaoeste.com/brasil/anvisa-aprova-14-novas-canetas-para-diabetes-e-obesidade/',
                children: [{ kind: 'text', text: 'registrados em agosto de 2026' }]
              },
              { kind: 'text', text: '.' }
            ]
          }
        ]
      },
      {
        heading: 'A evidência clínica é a mesma?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Os grandes estudos de desfecho, como o ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa1607141',
                children: [{ kind: 'text', text: 'SUSTAIN-6' }]
              },
              { kind: 'text', text: ' e o ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2403347',
                children: [{ kind: 'text', text: 'FLOW' }]
              },
              {
                kind: 'text',
                text: ', foram feitos com a semaglutida da Novo Nordisk. As indicações de redução de risco cardiovascular e renal constam da bula do Ozempic.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Posso trocar um pelo outro?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A troca deve ser decidida pelo médico, que emite a receita com o nome do produto.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'Semavy e Ozempic são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'Têm o mesmo princípio ativo e a mesma indicação principal. Diferem na origem (sintética ou biológica), no fabricante e no preço.'
          }
        ]
      },
      { question: 'Semavy é genérico do Ozempic?', answer: [{ kind: 'text', text: 'Não. É um medicamento novo.' }] },
      {
        question: 'Algum dos dois é indicado para obesidade?',
        answer: [{ kind: 'text', text: 'Não. Ambos são aprovados para diabetes tipo 2.' }]
      },
      { question: 'Qual custa menos?', answer: [{ kind: 'text', text: 'O Semavy.' }] },
      {
        question: 'Os efeitos colaterais são iguais?',
        answer: [{ kind: 'text', text: 'São os esperados para a semaglutida: náusea, diarreia, vômito e constipação.' }]
      },
      { question: 'Os dois precisam de receita?', answer: [{ kind: 'text', text: 'Sim, com retenção.' }] }
    ],
    sources: [
      {
        title: 'Bem Paraná / Folhapress. Nova caneta de semaglutida sintética é a Semavy, da Hypera Pharma.',
        url: 'https://www.bemparana.com.br/bem-estar/nova-caneta-de-semaglutida-sintetica-produzida-no-brasil-e-a-semavy-da-hypera-pharma/'
      },
      {
        title: 'Revista Oeste. Anvisa aprova 14 novas canetas para diabetes e obesidade.',
        url: 'https://revistaoeste.com/brasil/anvisa-aprova-14-novas-canetas-para-diabetes-e-obesidade/'
      },
      { title: 'Marso SP et al. SUSTAIN-6. NEJM, 2016.', url: 'https://doi.org/10.1056/NEJMoa1607141' },
      { title: 'Perkovic V et al. FLOW. NEJM, 2024.', url: 'https://doi.org/10.1056/NEJMoa2403347' },
      {
        title: 'Voy Saúde. Ozempic genérico: preço e o que já chegou ao Brasil em 2026.',
        url: 'https://www.voysaude.com.br/blog/ozempic-generico-preco-brasil-2026'
      }
    ],
    unresolved: [],
    article: {
      points: [
        'Semavy e Ozempic são semaglutida aprovada para diabetes tipo 2.',
        'Semavy é sintético e foi registrado como medicamento novo, não como genérico.',
        'Pelo programa do fabricante, o Semavy custa cerca de um terço do Ozempic.'
      ],
      info: {
        after: 'Semavy é genérico do Ozempic?',
        text: 'No Brasil não existe genérico de medicamento biológico. Por isso Semavy e Ozivy foram registrados como medicamentos novos.'
      },
      tip: {
        after: 'Posso trocar um pelo outro?',
        text: 'Ao mudar de caneta, leia as instruções de uso e de conservação do novo produto, mesmo sendo a mesma molécula: o funcionamento da caneta pode ser diferente.'
      }
    }
  },
  semavy: {
    slug: 'semavy',
    title: 'Semavy: o que é, preço, doses, receita e como funciona | Medleve',
    description:
      'Semavy é a caneta de semaglutida sintética da Hypera Pharma, aprovada pela Anvisa para diabetes tipo 2. Veja indicação, preço, diferenças para Ozempic e Ozivy e efeitos.',
    h1: 'Semavy: o que é, preço, doses, receita e como funciona',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Semavy é uma caneta de semaglutida sintética, da Hypera Pharma (marca Mantecorp), aplicada uma vez por semana. Foi aprovada pela Anvisa em julho de 2026 para o tratamento do diabetes tipo 2 em adultos, junto com dieta e exercícios. Semavy não tem indicação de bula para emagrecimento. É classificada como medicamento novo, e não como genérico, similar ou biossimilar.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'O que é Semavy?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'É um medicamento injetável à base de ' },
              { kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'semaglutida' }] },
              {
                kind: 'text',
                text: ', lançado após o fim da patente da molécula no Brasil, em março de 2026. A semaglutida do Semavy é produzida por síntese química, diferente da semaglutida de origem biológica de Ozempic e Wegovy.'
              }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'A Anvisa ' },
              {
                kind: 'link',
                url: 'https://revistaoeste.com/brasil/anvisa-aprova-14-novas-canetas-para-diabetes-e-obesidade/',
                children: [{ kind: 'text', text: 'registrou o Semavy em 29 de julho de 2026' }]
              },
              { kind: 'text', text: '. Assim como o Ozivy, ele ' },
              {
                kind: 'link',
                url: 'https://www.bemparana.com.br/bem-estar/nova-caneta-de-semaglutida-sintetica-produzida-no-brasil-e-a-semavy-da-hypera-pharma/',
                children: [{ kind: 'text', text: 'não é enquadrado como genérico, similar ou biossimilar' }]
              },
              { kind: 'text', text: '.' }
            ]
          }
        ]
      },
      {
        heading: 'Qual é o princípio ativo de Semavy?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Semaglutida sintética, um agonista do receptor de ' },
              { kind: 'link', url: '/glp-1', children: [{ kind: 'text', text: 'GLP-1' }] },
              { kind: 'text', text: '.' }
            ]
          }
        ]
      },
      {
        heading: 'Para que Semavy é indicado?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Para o ' },
              {
                kind: 'link',
                url: 'https://www.drogaraia.com.br/blog/saude/medicamentos/semavy-nova-caneta-de-semaglutida-nacional-entenda-indicacoes-e-diferencas-para-as-outras',
                children: [{ kind: 'text', text: 'tratamento do diabetes tipo 2 em adultos' }]
              },
              { kind: 'text', text: ', como complemento à dieta e à atividade física.' }
            ]
          }
        ]
      },
      {
        heading: 'Semavy é indicado para emagrecimento?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Não. A indicação aprovada é diabetes tipo 2. Os medicamentos com indicação de bula para obesidade ou sobrepeso com comorbidade são '
              },
              { kind: 'link', url: '/wegovy', children: [{ kind: 'text', text: 'Wegovy' }] },
              { kind: 'text', text: ', ' },
              { kind: 'link', url: '/poviztra', children: [{ kind: 'text', text: 'Poviztra' }] },
              { kind: 'text', text: ' e ' },
              { kind: 'link', url: '/mounjaro', children: [{ kind: 'text', text: 'Mounjaro' }] },
              { kind: 'text', text: '. O uso de qualquer medicamento fora da indicação de bula é decisão do médico.' }
            ]
          }
        ]
      },
      {
        heading: 'Como Semavy funciona?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Como toda semaglutida: melhora a secreção de insulina quando a glicose está alta, reduz o glucagon, retarda o esvaziamento do estômago e aumenta a saciedade.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quais doses de Semavy existem?',
        blocks: [
          {
            kind: 'table',
            header: [
              [{ kind: 'text', text: 'Apresentação' }],
              [{ kind: 'text', text: 'Conteúdo' }],
              [{ kind: 'text', text: 'Uso' }]
            ],
            rows: [
              [
                [{ kind: 'text', text: 'Caneta de 1,5 mL' }],
                [{ kind: 'text', text: '2 mg de semaglutida' }],
                [{ kind: 'text', text: 'Doses de 0,25 mg e 0,5 mg (início do tratamento)' }]
              ],
              [
                [{ kind: 'text', text: 'Caneta de 3 mL' }],
                [{ kind: 'text', text: '4 mg de semaglutida' }],
                [{ kind: 'text', text: 'Quatro doses de 1 mg (um mês)' }]
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'O esquema é o da semaglutida para diabetes tipo 2: 0,25 mg por semana durante quatro semanas, depois 0,5 mg, com possibilidade de aumento para 1 mg após pelo menos mais quatro semanas, conforme orientação médica. Fonte: '
              },
              {
                kind: 'link',
                url: 'https://www.voysaude.com.br/blog/semavy-o-que-e-preco',
                children: [{ kind: 'text', text: 'Voy Saúde' }]
              },
              { kind: 'text', text: '. Conferir com a bula vigente.' }
            ]
          }
        ]
      },
      {
        heading: 'O que os estudos mostram?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A eficácia da semaglutida no diabetes tipo 2 foi estabelecida nos estudos com o produto de referência:'
              }
            ]
          },
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa1607141',
                      children: [{ kind: 'text', text: 'SUSTAIN-6' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                {
                  kind: 'text',
                  text: ' redução de 26% em eventos cardiovasculares maiores em pessoas com diabetes tipo 2.'
                }
              ],
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa2107519',
                      children: [{ kind: 'text', text: 'SURPASS-2' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                {
                  kind: 'text',
                  text: ' semaglutida 1 mg reduziu a hemoglobina glicada em 1,86 ponto percentual em 40 semanas.'
                }
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Esses estudos foram feitos com a semaglutida da Novo Nordisk. O Semavy foi registrado pela Anvisa com base em seu próprio dossiê de qualidade, segurança e eficácia.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Semavy precisa de receita?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Sim, ' },
              {
                kind: 'link',
                url: 'https://portal.afya.com.br/saude/medicamentos-agonistas-glp-1-terao-retencao-de-receita',
                children: [{ kind: 'text', text: 'em duas vias, com retenção' }]
              },
              { kind: 'text', text: '. A receita vale 90 dias e pode ser digital.' }
            ]
          }
        ]
      },
      {
        heading: 'Quanto custa Semavy?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Preços divulgados pela fabricante no ' },
              {
                kind: 'link',
                url: 'https://www.voysaude.com.br/blog/semavy-o-que-e-preco',
                children: [{ kind: 'text', text: 'programa Mantecorp Saúde' }]
              },
              { kind: 'text', text: ', desde o lançamento, em 4 de setembro de 2026:' }
            ]
          },
          {
            kind: 'table',
            header: [[{ kind: 'text', text: 'Condição' }], [{ kind: 'text', text: 'Preço da caneta de 1 mg' }]],
            rows: [
              [[{ kind: 'text', text: 'Programa Mantecorp Saúde' }], [{ kind: 'text', text: 'R$ 333,00' }]],
              [
                [{ kind: 'text', text: 'Portal do programa, usuários cadastrados' }],
                [{ kind: 'text', text: 'a partir de R$ 278,89' }]
              ],
              [
                [{ kind: 'text', text: 'Sem o programa (referência de mercado)' }],
                [{ kind: 'text', text: 'cerca de R$ 465,00' }]
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A fabricante informa que o preço varia conforme a farmácia e as condições do programa.'
              }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Os valores são os divulgados pelo fabricante e podem mudar sem aviso. O preço final depende da farmácia. O paciente pode comprar na farmácia de sua preferência ou em uma farmácia parceira disponível na plataforma.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Principais efeitos colaterais de Semavy',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Os efeitos esperados são os da semaglutida: náusea, diarreia, vômito, constipação e dor abdominal, sobretudo no início. Há risco de hipoglicemia quando usada com insulina ou sulfonilureias. Consulte a bula do produto no '
              },
              {
                kind: 'link',
                url: 'https://consultas.anvisa.gov.br/#/bulario/',
                children: [{ kind: 'text', text: 'Bulário da Anvisa' }]
              },
              { kind: 'text', text: '.' }
            ]
          }
        ]
      },
      {
        heading: 'Contraindicações de Semavy',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'text', text: 'Alergia à semaglutida ou a componentes da fórmula.' }],
              [{ kind: 'text', text: 'Gravidez e amamentação.' }],
              [
                {
                  kind: 'text',
                  text: 'Histórico pessoal ou familiar de carcinoma medular de tireoide ou neoplasia endócrina múltipla tipo 2.'
                }
              ],
              [{ kind: 'text', text: 'Não é indicado para diabetes tipo 1.' }]
            ]
          }
        ]
      },
      {
        heading: 'Diferenças entre Semavy e outros medicamentos',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'link', url: '/semavy-ou-ozempic', children: [{ kind: 'text', text: 'Semavy ou Ozempic' }] }],
              [
                { kind: 'link', url: '/ozivy', children: [{ kind: 'text', text: 'Ozivy' }] },
                { kind: 'text', text: ': também semaglutida sintética para diabetes tipo 2, fabricada pela EMS.' }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Consulta médica online',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Na Medleve, o médico avalia seu caso por mensagem ou vídeo e define qual tratamento é adequado. A receita, quando indicada, é digital.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'O que é Semavy?',
        answer: [
          { kind: 'text', text: 'É uma caneta de semaglutida sintética, da Hypera Pharma, de aplicação semanal.' }
        ]
      },
      { question: 'Semavy é semaglutida?', answer: [{ kind: 'text', text: 'Sim, produzida por síntese química.' }] },
      {
        question: 'Para que Semavy é indicado?',
        answer: [{ kind: 'text', text: 'Para diabetes tipo 2 em adultos, junto com dieta e exercícios.' }]
      },
      {
        question: 'Semavy é indicado para emagrecimento?',
        answer: [{ kind: 'text', text: 'Não. A indicação aprovada pela Anvisa é diabetes tipo 2.' }]
      },
      {
        question: 'Semavy precisa de receita?',
        answer: [{ kind: 'text', text: 'Sim, em duas vias, com retenção. Vale 90 dias.' }]
      },
      {
        question: 'Quais doses existem?',
        answer: [
          {
            kind: 'text',
            text: 'Caneta de 1,5 mL, para as doses de 0,25 mg e 0,5 mg, e caneta de 3 mL, com quatro doses de 1 mg.'
          }
        ]
      },
      {
        question: 'Quanto custa Semavy?',
        answer: [
          {
            kind: 'text',
            text: 'Pelo programa Mantecorp Saúde, R$ 333,00 por caneta de 1 mg. Sem o programa, cerca de R$ 465,00.'
          }
        ]
      },
      {
        question: 'Semavy e Ozempic são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'Têm o mesmo princípio ativo e a mesma indicação. Ozempic é de origem biológica; Semavy é sintético e custa menos.'
          }
        ]
      },
      {
        question: 'Semavy e Ozivy são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'São dois medicamentos de semaglutida sintética para diabetes tipo 2, de fabricantes diferentes (Hypera Pharma e EMS).'
          }
        ]
      },
      {
        question: 'Quais são os principais efeitos colaterais?',
        answer: [{ kind: 'text', text: 'Náusea, diarreia, vômito e constipação.' }]
      }
    ],
    sources: [
      {
        title: 'Revista Oeste. Anvisa aprova 14 novas canetas para diabetes e obesidade.',
        url: 'https://revistaoeste.com/brasil/anvisa-aprova-14-novas-canetas-para-diabetes-e-obesidade/'
      },
      {
        title: 'Bem Paraná / Folhapress. Nova caneta de semaglutida sintética é a Semavy, da Hypera Pharma.',
        url: 'https://www.bemparana.com.br/bem-estar/nova-caneta-de-semaglutida-sintetica-produzida-no-brasil-e-a-semavy-da-hypera-pharma/'
      },
      {
        title: 'Droga Raia. Semavy: indicações e diferenças para as outras canetas.',
        url: 'https://www.drogaraia.com.br/blog/saude/medicamentos/semavy-nova-caneta-de-semaglutida-nacional-entenda-indicacoes-e-diferencas-para-as-outras'
      },
      { title: 'Marso SP et al. SUSTAIN-6. NEJM, 2016.', url: 'https://doi.org/10.1056/NEJMoa1607141' },
      { title: 'Frías JP et al. SURPASS-2. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2107519' },
      {
        title: 'Voy Saúde. Semavy: o que é, para que serve e quanto custa a caneta.',
        url: 'https://www.voysaude.com.br/blog/semavy-o-que-e-preco'
      },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' }
    ],
    unresolved: [],
    article: {
      points: [
        'Semavy é uma semaglutida sintética da Hypera Pharma, aprovada para diabetes tipo 2.',
        'Não tem indicação de bula para emagrecimento.',
        'Pelo programa Mantecorp Saúde, R$ 333 por caneta de 1 mg.'
      ],
      info: {
        after: 'Semavy é indicado para emagrecimento?',
        text: 'Semavy e Ozivy são semaglutidas sintéticas registradas em 2026 para diabetes tipo 2. Nenhuma das duas é genérico do Ozempic.'
      },
      tip: {
        after: 'Quanto custa Semavy?',
        text: 'Antes de cada aplicação, confira a dose no contador da caneta e verifique se o líquido está transparente e incolor. Não use se estiver turvo ou com partículas.'
      }
    }
  },
  tirzepatida: {
    slug: 'tirzepatida',
    title: 'Tirzepatida: o que é, como funciona, doses e efeitos | Medleve',
    description:
      'Tirzepatida é o princípio ativo do Mounjaro. Entenda a ação dupla em GIP e GLP-1, as indicações aprovadas pela Anvisa, os resultados dos estudos SURMOUNT e os efeitos colaterais.',
    h1: 'Tirzepatida: o que é, como funciona e para que é indicada',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Tirzepatida é um agonista duplo dos receptores de GIP e GLP-1, aplicado uma vez por semana. No Brasil, é o princípio ativo do Mounjaro, aprovado pela Anvisa para diabetes tipo 2, para obesidade ou sobrepeso com comorbidade e para apneia obstrutiva do sono em adultos com obesidade. No estudo SURMOUNT-1, a perda média de peso chegou a 20,9% em 72 semanas com a dose de 15 mg.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'O que é tirzepatida?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'É uma molécula única que ativa dois receptores hormonais ligados ao apetite e ao metabolismo: GIP e '
              },
              { kind: 'link', url: '/glp-1', children: [{ kind: 'text', text: 'GLP-1' }] },
              {
                kind: 'text',
                text: '. Por isso é chamada de agonista duplo. Hoje, a única marca de tirzepatida registrada no Brasil é o '
              },
              { kind: 'link', url: '/mounjaro', children: [{ kind: 'text', text: 'Mounjaro' }] },
              { kind: 'text', text: ', da Eli Lilly.' }
            ]
          }
        ]
      },
      {
        heading: 'Como a tirzepatida funciona?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A ação no receptor de GLP-1 aumenta a saciedade, retarda o esvaziamento do estômago e melhora a secreção de insulina. A ação no receptor de GIP soma efeitos sobre o apetite e o metabolismo da gordura. Na prática, a pessoa sente menos fome e come menos.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Para que a tirzepatida é indicada?',
        blocks: [
          { kind: 'paragraph', children: [{ kind: 'text', text: 'Segundo a bula do Mounjaro registrada na Anvisa:' }] },
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Diabetes tipo 2' }] },
                { kind: 'text', text: ', em conjunto com dieta e exercícios. ' },
                {
                  kind: 'link',
                  url: 'https://www.em.com.br/saude/2025/06/7168362-anvisa-aprova-mounjaro-para-perda-de-peso-e-tratamento-de-obesidade.html',
                  children: [{ kind: 'text', text: 'Aprovada em setembro de 2023' }]
                },
                { kind: 'text', text: '.' }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Controle crônico do peso' }] },
                {
                  kind: 'text',
                  text: ' em adultos com IMC ≥ 30 kg/m², ou IMC ≥ 27 kg/m² com pelo menos uma comorbidade relacionada ao peso. '
                },
                {
                  kind: 'link',
                  url: 'https://www.em.com.br/saude/2025/06/7168362-anvisa-aprova-mounjaro-para-perda-de-peso-e-tratamento-de-obesidade.html',
                  children: [{ kind: 'text', text: 'Aprovada em junho de 2025' }]
                },
                { kind: 'text', text: '.' }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Apneia obstrutiva do sono moderada a grave' }] },
                { kind: 'text', text: ' em adultos com obesidade. ' },
                {
                  kind: 'link',
                  url: 'https://site.cff.org.br/noticia/Noticias-gerais/21/10/2025/anvisa-aprova-uso-de-mounjaro-para-tratamento-da-apneia-do-sono',
                  children: [{ kind: 'text', text: 'Aprovada em outubro de 2025' }]
                },
                { kind: 'text', text: '.' }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Doses',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'O tratamento começa com 2,5 mg por semana, durante quatro semanas, e sobe em passos de 2,5 mg conforme a tolerância e a orientação médica. As doses disponíveis são 2,5 mg, 5 mg, 7,5 mg, 10 mg, 12,5 mg e 15 mg. Nem todo paciente precisa chegar à dose máxima.'
              }
            ]
          }
        ]
      },
      {
        heading: 'O que os estudos mostram?',
        blocks: [
          {
            kind: 'table',
            header: [
              [{ kind: 'text', text: 'Estudo' }],
              [{ kind: 'text', text: 'População' }],
              [{ kind: 'text', text: 'Resultado principal' }]
            ],
            rows: [
              [
                [
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2206038',
                    children: [{ kind: 'text', text: 'SURMOUNT-1' }]
                  }
                ],
                [{ kind: 'text', text: '2.539 adultos com obesidade ou sobrepeso, sem diabetes, 72 semanas' }],
                [
                  {
                    kind: 'text',
                    text: 'Perda média de 15,0% (5 mg), 19,5% (10 mg) e 20,9% (15 mg), contra 3,1% com placebo'
                  }
                ]
              ],
              [
                [
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1016/S0140-6736%2823%2901200-X',
                    children: [{ kind: 'text', text: 'SURMOUNT-2' }]
                  }
                ],
                [{ kind: 'text', text: 'Adultos com obesidade e diabetes tipo 2, 72 semanas' }],
                [{ kind: 'text', text: 'Perda média de 12,8% (10 mg) e 14,7% (15 mg), contra 3,2% com placebo' }]
              ],
              [
                [
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2416394',
                    children: [{ kind: 'text', text: 'SURMOUNT-5' }]
                  }
                ],
                [{ kind: 'text', text: '751 adultos com obesidade, sem diabetes, 72 semanas' }],
                [{ kind: 'text', text: '20,2% com tirzepatida, contra 13,7% com semaglutida 2,4 mg' }]
              ],
              [
                [
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1001/jama.2023.24945',
                    children: [{ kind: 'text', text: 'SURMOUNT-4' }]
                  }
                ],
                [{ kind: 'text', text: 'Manutenção após 36 semanas de tratamento' }],
                [{ kind: 'text', text: 'Quem continuou perdeu mais 5,5%; quem passou a placebo recuperou 14,0%' }]
              ],
              [
                [
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2404881',
                    children: [{ kind: 'text', text: 'SURMOUNT-OSA' }]
                  }
                ],
                [{ kind: 'text', text: 'Adultos com obesidade e apneia do sono' }],
                [{ kind: 'text', text: 'Redução de 25 a 29 eventos de apneia por hora, contra cerca de 5 com placebo' }]
              ],
              [
                [
                  {
                    kind: 'link',
                    url: 'https://doi.org/10.1056/NEJMoa2107519',
                    children: [{ kind: 'text', text: 'SURPASS-2' }]
                  }
                ],
                [{ kind: 'text', text: '1.879 adultos com diabetes tipo 2, 40 semanas' }],
                [{ kind: 'text', text: 'Maior redução de hemoglobina glicada e de peso do que semaglutida 1 mg' }]
              ]
            ]
          }
        ]
      },
      {
        heading: 'Efeitos colaterais',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Os mais comuns são gastrointestinais e aparecem sobretudo no início e nos aumentos de dose. No '
              },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2206038',
                children: [{ kind: 'text', text: 'SURMOUNT-1' }]
              },
              {
                kind: 'text',
                text: ', náusea ocorreu em 24,6% a 33,3% dos participantes, diarreia em 18,7% a 23,0% e constipação em 11,7% a 17,1%, conforme a dose. Entre 4,3% e 7,1% interromperam o tratamento por efeitos adversos.'
              }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Eventos menos frequentes incluem pancreatite, doença da vesícula biliar e hipoglicemia quando usada junto com insulina ou sulfonilureias.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quem não deve usar',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'text', text: 'Alergia à tirzepatida ou a componentes da fórmula.' }],
              [
                {
                  kind: 'text',
                  text: 'Histórico pessoal ou familiar de carcinoma medular de tireoide ou neoplasia endócrina múltipla tipo 2.'
                }
              ],
              [{ kind: 'text', text: 'Gravidez e amamentação.' }],
              [{ kind: 'text', text: 'Cautela em quem já teve pancreatite ou tem doença gastrointestinal grave.' }]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A tirzepatida pode reduzir a absorção de anticoncepcionais orais no início do tratamento e após cada aumento de dose. A '
              },
              {
                kind: 'link',
                url: 'https://consultas.anvisa.gov.br/#/bulario/',
                children: [{ kind: 'text', text: 'bula' }]
              },
              {
                kind: 'text',
                text: ' orienta discutir com o médico um método contraceptivo adicional ou não oral nesses períodos.'
              }
            ]
          }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'O que é tirzepatida?',
        answer: [
          {
            kind: 'text',
            text: 'É um medicamento injetável semanal que ativa os receptores de GIP e GLP-1. No Brasil, é vendido como Mounjaro.'
          }
        ]
      },
      {
        question: 'Como a tirzepatida funciona?',
        answer: [
          {
            kind: 'text',
            text: 'Aumenta a saciedade, reduz o apetite, retarda o esvaziamento do estômago e melhora o controle da glicose.'
          }
        ]
      },
      {
        question: 'Mounjaro é tirzepatida?',
        answer: [{ kind: 'text', text: 'Sim. Mounjaro é o nome comercial; tirzepatida é o princípio ativo.' }]
      },
      {
        question: 'Para que tirzepatida é indicada?',
        answer: [
          {
            kind: 'text',
            text: 'Diabetes tipo 2, obesidade ou sobrepeso com comorbidade e apneia obstrutiva do sono moderada a grave em adultos com obesidade.'
          }
        ]
      },
      {
        question: 'Tirzepatida precisa de receita?',
        answer: [
          {
            kind: 'text',
            text: 'Sim, com retenção de uma via pela farmácia. A receita vale 90 dias e pode ser digital.'
          }
        ]
      },
      {
        question: 'Quais doses existem?',
        answer: [{ kind: 'text', text: '2,5 mg, 5 mg, 7,5 mg, 10 mg, 12,5 mg e 15 mg, uma vez por semana.' }]
      },
      {
        question: 'Quais são os efeitos colaterais mais comuns?',
        answer: [{ kind: 'text', text: 'Náusea, diarreia, constipação e vômito.' }]
      },
      {
        question: 'Qual a diferença entre tirzepatida e semaglutida?',
        answer: [
          {
            kind: 'text',
            text: 'A tirzepatida age em GIP e GLP-1; a semaglutida, só em GLP-1. No SURMOUNT-5, a tirzepatida levou a maior perda de peso (20,2% contra 13,7%).'
          }
        ]
      },
      {
        question: 'Tirzepatida e Wegovy são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'Não. Wegovy é semaglutida. São moléculas diferentes, com doses e esquemas diferentes. Veja '
          },
          { kind: 'link', url: '/mounjaro-ou-wegovy', children: [{ kind: 'text', text: 'Mounjaro ou Wegovy' }] },
          { kind: 'text', text: '.' }
        ]
      },
      {
        question: 'Como funciona uma avaliação médica online para tirzepatida?',
        answer: [
          {
            kind: 'text',
            text: 'Você responde a um questionário de saúde e conversa com um médico por mensagem ou vídeo. Se houver indicação, ele emite a receita digital.'
          }
        ]
      }
    ],
    sources: [
      { title: 'Jastreboff AM et al. SURMOUNT-1. NEJM, 2022.', url: 'https://doi.org/10.1056/NEJMoa2206038' },
      { title: 'Garvey WT et al. SURMOUNT-2. Lancet, 2023.', url: 'https://doi.org/10.1016/S0140-6736%2823%2901200-X' },
      { title: 'Aronne LJ et al. SURMOUNT-4. JAMA, 2024.', url: 'https://doi.org/10.1001/jama.2023.24945' },
      { title: 'Aronne LJ et al. SURMOUNT-5. NEJM, 2025.', url: 'https://doi.org/10.1056/NEJMoa2416394' },
      { title: 'Malhotra A et al. SURMOUNT-OSA. NEJM, 2024.', url: 'https://doi.org/10.1056/NEJMoa2404881' },
      { title: 'Frías JP et al. SURPASS-2. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2107519' },
      {
        title: 'Estado de Minas. Anvisa aprova Mounjaro para perda de peso e tratamento de obesidade.',
        url: 'https://www.em.com.br/saude/2025/06/7168362-anvisa-aprova-mounjaro-para-perda-de-peso-e-tratamento-de-obesidade.html'
      },
      {
        title: 'Conselho Federal de Farmácia. Anvisa aprova uso de Mounjaro para tratamento da apneia do sono.',
        url: 'https://site.cff.org.br/noticia/Noticias-gerais/21/10/2025/anvisa-aprova-uso-de-mounjaro-para-tratamento-da-apneia-do-sono'
      },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' }
    ],
    unresolved: [],
    article: {
      points: [
        'A tirzepatida age em dois receptores, GIP e GLP-1.',
        'No Brasil, é vendida como Mounjaro, aprovado para diabetes tipo 2, obesidade e apneia do sono.',
        'No SURMOUNT-1, a perda média de peso chegou a 20,9% com a dose de 15 mg.'
      ],
      info: {
        after: 'Para que a tirzepatida é indicada?',
        text: 'O Mounjaro é a única tirzepatida registrada no Brasil. Produtos vendidos como tirzepatida manipulada ou importada sem registro não têm garantia de qualidade nem de dose.'
      },
      tip: {
        after: 'Quem não deve usar',
        text: 'Se você usa anticoncepcional oral, combine com o médico um método de barreira adicional nas quatro semanas após o início do tratamento e após cada aumento de dose.'
      }
    }
  },
  'wegovy-ou-ozempic': {
    slug: 'wegovy-ou-ozempic',
    title: 'Wegovy ou Ozempic: diferenças, doses e indicações | Medleve',
    description:
      'Wegovy e Ozempic têm o mesmo princípio ativo, a semaglutida. Veja o que muda: dose máxima, indicação aprovada pela Anvisa, resultados de perda de peso e preço.',
    h1: 'Wegovy ou Ozempic: quais são as diferenças?',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Wegovy e Ozempic contêm o mesmo princípio ativo, a semaglutida, e são fabricados pela Novo Nordisk. A diferença está na dose e na indicação. Wegovy chega a 2,4 mg por semana e é aprovado pela Anvisa para obesidade e sobrepeso com comorbidade. Ozempic vai até 1 mg por semana e é aprovado para diabetes tipo 2. No estudo STEP 2, a dose de 2,4 mg levou a mais perda de peso do que a de 1 mg.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'Comparação',
        blocks: [
          {
            kind: 'table',
            header: [[], [{ kind: 'text', text: 'Wegovy' }], [{ kind: 'text', text: 'Ozempic' }]],
            rows: [
              [
                [{ kind: 'text', text: 'Princípio ativo' }],
                [{ kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'Semaglutida' }] }],
                [{ kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'Semaglutida' }] }]
              ],
              [
                [{ kind: 'text', text: 'Fabricante' }],
                [{ kind: 'text', text: 'Novo Nordisk' }],
                [{ kind: 'text', text: 'Novo Nordisk' }]
              ],
              [
                [{ kind: 'text', text: 'Indicação aprovada' }],
                [
                  {
                    kind: 'text',
                    text: 'Obesidade/sobrepeso com comorbidade; adolescentes ≥ 12 anos; risco cardiovascular; MASH'
                  }
                ],
                [{ kind: 'text', text: 'Diabetes tipo 2 (inclui risco cardiovascular e doença renal)' }]
              ],
              [
                [{ kind: 'text', text: 'Doses' }],
                [{ kind: 'text', text: '0,25 / 0,5 / 1 / 1,7 / 2,4 mg' }],
                [{ kind: 'text', text: '0,25 / 0,5 / 1 mg' }]
              ],
              [
                [{ kind: 'text', text: 'Dose de manutenção' }],
                [{ kind: 'text', text: '2,4 mg' }],
                [{ kind: 'text', text: '0,5 a 1 mg' }]
              ],
              [
                [{ kind: 'text', text: 'Preço no programa do fabricante' }],
                [
                  {
                    kind: 'link',
                    url: 'https://www.programanovodia.com.br/produtos.html',
                    children: [{ kind: 'text', text: 'R$ 899,00 a R$ 1.749,00' }]
                  },
                  { kind: 'text', text: ' por caneta (NovoDia, e-commerce)' }
                ],
                [
                  {
                    kind: 'link',
                    url: 'https://www.programanovodia.com.br/produtos.html',
                    children: [{ kind: 'text', text: 'R$ 975 a R$ 999' }]
                  },
                  { kind: 'text', text: ' por caneta (NovoDia, e-commerce)' }
                ]
              ]
            ]
          }
        ]
      },
      {
        heading: 'A dose muda o resultado?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Sim. O ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1016/S0140-6736%2821%2900213-0',
                children: [{ kind: 'text', text: 'STEP 2' }]
              },
              {
                kind: 'text',
                text: ' comparou as duas doses em adultos com diabetes tipo 2 e excesso de peso. Em 68 semanas, a perda média foi de 9,6% com 2,4 mg, 7,0% com 1,0 mg e 3,4% com placebo. Em pessoas sem diabetes, o '
              },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2032183',
                children: [{ kind: 'text', text: 'STEP 1' }]
              },
              { kind: 'text', text: ' mostrou perda média de 14,9% com 2,4 mg.' }
            ]
          }
        ]
      },
      {
        heading: 'Posso usar Ozempic no lugar do Wegovy?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Não por conta própria. As canetas têm concentrações e doses diferentes, e o Ozempic não tem indicação de bula para obesidade. A escolha do medicamento e da dose é do médico.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Efeitos colaterais',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'São os mesmos em natureza, por ser a mesma molécula: náusea, diarreia, vômito e constipação. Doses maiores tendem a causar mais efeitos gastrointestinais, o que justifica o aumento gradual.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'Wegovy e Ozempic são iguais?',
        answer: [{ kind: 'text', text: 'Têm o mesmo princípio ativo, mas doses máximas e indicações diferentes.' }]
      },
      {
        question: 'Qual é indicado para obesidade?',
        answer: [{ kind: 'text', text: 'O Wegovy. Ozempic é aprovado para diabetes tipo 2.' }]
      },
      {
        question: 'As doses são iguais?',
        answer: [{ kind: 'text', text: 'Não. Wegovy chega a 2,4 mg; Ozempic, a 1 mg.' }]
      },
      {
        question: 'Qual emagrece mais?',
        answer: [
          { kind: 'text', text: 'A dose de 2,4 mg levou a mais perda de peso do que a de 1 mg no estudo STEP 2.' }
        ]
      },
      {
        question: 'Os efeitos colaterais são iguais?',
        answer: [{ kind: 'text', text: 'São do mesmo tipo, principalmente gastrointestinais.' }]
      },
      { question: 'Os dois precisam de receita?', answer: [{ kind: 'text', text: 'Sim, com retenção.' }] },
      { question: 'Posso trocar um pelo outro?', answer: [{ kind: 'text', text: 'Só com orientação médica.' }] }
    ],
    sources: [
      { title: 'Davies M et al. STEP 2. Lancet, 2021.', url: 'https://doi.org/10.1016/S0140-6736%2821%2900213-0' },
      { title: 'Wilding JPH et al. STEP 1. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2032183' },
      {
        title: 'Novo Nordisk Brasil. Anvisa aprova novas indicações de Wegovy e Ozempic.',
        url: 'https://www.novonordisk.com.br/noticias-e-imprensa/busca-noticias/anvisa-aprova-novas-indicacoes-de-wegovy-e-ozempic-para-tratamento-de-doencas-no-coracao-e-nos-rins.html'
      },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' }
    ],
    unresolved: [],
    article: {
      points: [
        'Wegovy e Ozempic têm o mesmo princípio ativo, a semaglutida.',
        'Wegovy chega a 2,4 mg e é aprovado para obesidade; Ozempic vai até 1 mg, para diabetes tipo 2.',
        'No STEP 2, a dose de 2,4 mg levou a mais perda de peso do que a de 1 mg.'
      ],
      info: {
        after: 'Posso usar Ozempic no lugar do Wegovy?',
        text: 'As duas canetas têm concentrações diferentes. Usar uma no lugar da outra, ajustando cliques por conta própria, pode levar a erro de dose.'
      },
      tip: {
        after: 'A dose muda o resultado?',
        text: 'Os efeitos gastrointestinais costumam aparecer nos dias seguintes à aplicação. Aplicar sempre no mesmo dia ajuda a prever os dias mais sensíveis e a planejar refeições leves.'
      }
    }
  },
  'wegovy-ou-ozivy': {
    slug: 'wegovy-ou-ozivy',
    title: 'Wegovy ou Ozivy: diferenças, indicações e preço | Medleve',
    description:
      'Wegovy é semaglutida 2,4 mg para obesidade. Ozivy é semaglutida sintética nacional de até 1 mg para diabetes tipo 2. Compare dose, indicação, conservação e preço.',
    h1: 'Wegovy ou Ozivy: quais são as diferenças?',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Wegovy e Ozivy têm semaglutida como princípio ativo, mas não são equivalentes. Wegovy, da Novo Nordisk, chega a 2,4 mg por semana e é aprovado pela Anvisa para obesidade e sobrepeso com comorbidade. Ozivy, da EMS, é uma semaglutida sintética de até 1 mg por semana, aprovada exclusivamente para diabetes tipo 2. Ozivy custa menos, mas não tem indicação de bula para emagrecimento.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'Comparação',
        blocks: [
          {
            kind: 'table',
            header: [[], [{ kind: 'text', text: 'Wegovy' }], [{ kind: 'text', text: 'Ozivy' }]],
            rows: [
              [
                [{ kind: 'text', text: 'Princípio ativo' }],
                [
                  { kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'Semaglutida' }] },
                  { kind: 'text', text: ' biológica' }
                ],
                [
                  { kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'Semaglutida' }] },
                  { kind: 'text', text: ' sintética' }
                ]
              ],
              [
                [{ kind: 'text', text: 'Fabricante' }],
                [{ kind: 'text', text: 'Novo Nordisk' }],
                [{ kind: 'text', text: 'EMS (Brasil)' }]
              ],
              [
                [{ kind: 'text', text: 'Indicação aprovada' }],
                [
                  {
                    kind: 'text',
                    text: 'Obesidade/sobrepeso com comorbidade; adolescentes ≥ 12 anos; risco cardiovascular'
                  }
                ],
                [{ kind: 'text', text: 'Diabetes tipo 2' }]
              ],
              [
                [{ kind: 'text', text: 'Dose máxima' }],
                [{ kind: 'text', text: '2,4 mg/semana' }],
                [{ kind: 'text', text: '1 mg/semana' }]
              ],
              [
                [{ kind: 'text', text: 'Conservação após abrir' }],
                [{ kind: 'text', text: 'Até 6 semanas abaixo de 30 °C ou na geladeira' }],
                [{ kind: 'text', text: 'Sempre na geladeira, até 56 dias' }]
              ],
              [
                [{ kind: 'text', text: 'Preço no programa do fabricante' }],
                [
                  {
                    kind: 'link',
                    url: 'https://www.programanovodia.com.br/produtos.html',
                    children: [{ kind: 'text', text: 'R$ 899,00 a R$ 1.749,00' }]
                  },
                  { kind: 'text', text: ' por caneta (NovoDia, e-commerce)' }
                ],
                [
                  {
                    kind: 'link',
                    url: 'https://guiadafarmacia.com.br/ems-lanca-nova-condicao-de-precos-para-tratamento-com-ozivy/',
                    children: [{ kind: 'text', text: '3 canetas de 1 mg por R$ 999' }]
                  },
                  { kind: 'text', text: ' (programa Vida + Leve)' }
                ]
              ]
            ]
          }
        ]
      },
      {
        heading: 'Ozivy é um Wegovy mais barato?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Não. A dose máxima do Ozivy é menos da metade da dose de manutenção do Wegovy, e a indicação é outra. A '
              },
              {
                kind: 'link',
                url: 'https://www.bemparana.com.br/bem-estar/anvisa-aprova-primeira-caneta-nacional-com-a-mesma-substancia-do-ozempic/',
                children: [{ kind: 'text', text: 'Anvisa registrou o Ozivy como medicamento novo' }]
              },
              { kind: 'text', text: ', para diabetes tipo 2, e não como genérico.' }
            ]
          }
        ]
      },
      {
        heading: 'A dose muda o resultado?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'No ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1016/S0140-6736%2821%2900213-0',
                children: [{ kind: 'text', text: 'STEP 2' }]
              },
              {
                kind: 'text',
                text: ', a perda média de peso foi de 9,6% com semaglutida 2,4 mg e 7,0% com 1,0 mg, em pessoas com diabetes tipo 2. Esse estudo usou a semaglutida de referência.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'Wegovy e Ozivy são iguais?',
        answer: [{ kind: 'text', text: 'Não. Têm a mesma molécula, mas doses, indicações e fabricantes diferentes.' }]
      },
      {
        question: 'Ozivy é indicado para obesidade?',
        answer: [{ kind: 'text', text: 'Não. É aprovado para diabetes tipo 2.' }]
      },
      {
        question: 'Ozivy é genérico do Wegovy?',
        answer: [{ kind: 'text', text: 'Não. É um medicamento novo, de semaglutida sintética.' }]
      },
      { question: 'Qual custa menos?', answer: [{ kind: 'text', text: 'O Ozivy.' }] },
      {
        question: 'Posso substituir Wegovy por Ozivy?',
        answer: [{ kind: 'text', text: 'Não por conta própria. A decisão é do médico.' }]
      },
      { question: 'Os dois precisam de receita?', answer: [{ kind: 'text', text: 'Sim, com retenção.' }] }
    ],
    sources: [
      { title: 'Davies M et al. STEP 2. Lancet, 2021.', url: 'https://doi.org/10.1016/S0140-6736%2821%2900213-0' },
      {
        title: 'Bem Paraná / Folhapress. Anvisa aprova primeira caneta nacional com a mesma substância do Ozempic.',
        url: 'https://www.bemparana.com.br/bem-estar/anvisa-aprova-primeira-caneta-nacional-com-a-mesma-substancia-do-ozempic/'
      },
      { title: 'Drogaria Araujo. Ozivy: bula, doses e preço.', url: 'https://www.araujo.com.br/ozivy.html' },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' }
    ],
    unresolved: [],
    article: {
      points: [
        'Wegovy é semaglutida 2,4 mg para obesidade; Ozivy é semaglutida sintética de até 1 mg para diabetes tipo 2.',
        'Ozivy não é genérico do Wegovy.',
        'Ozivy custa menos, mas não tem indicação de bula para emagrecimento.'
      ],
      info: {
        after: 'Ozivy é um Wegovy mais barato?',
        text: 'A dose máxima do Ozivy (1 mg) é menos da metade da dose de manutenção do Wegovy (2,4 mg).'
      },
      tip: {
        after: 'A dose muda o resultado?',
        text: 'Se o custo pesa na escolha, fale disso na consulta. O médico pode discutir as opções aprovadas para o seu caso e os programas de desconto dos fabricantes.'
      }
    }
  },
  'wegovy-ou-poviztra': {
    slug: 'wegovy-ou-poviztra',
    title: 'Wegovy ou Poviztra: são iguais? Diferenças e preço | Medleve',
    description:
      'Wegovy e Poviztra têm a mesma semaglutida 2,4 mg, as mesmas doses e a mesma indicação para obesidade. Entenda o que muda entre as duas marcas.',
    h1: 'Wegovy ou Poviztra: quais são as diferenças?',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Wegovy e Poviztra contêm a mesma semaglutida, nas mesmas doses (0,25 mg a 2,4 mg por semana), e são fabricados pela Novo Nordisk. Os dois são indicados para adultos com obesidade ou sobrepeso com comorbidade e para adolescentes a partir de 12 anos com obesidade. Poviztra é comercializado no Brasil em parceria com a Eurofarma. Na prática, as diferenças estão na marca, no preço e na disponibilidade.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'Comparação',
        blocks: [
          {
            kind: 'table',
            header: [[], [{ kind: 'text', text: 'Wegovy' }], [{ kind: 'text', text: 'Poviztra' }]],
            rows: [
              [
                [{ kind: 'text', text: 'Princípio ativo' }],
                [{ kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'Semaglutida' }] }],
                [{ kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'Semaglutida' }] }]
              ],
              [
                [{ kind: 'text', text: 'Fabricante' }],
                [{ kind: 'text', text: 'Novo Nordisk' }],
                [{ kind: 'text', text: 'Novo Nordisk' }]
              ],
              [
                [{ kind: 'text', text: 'Comercialização no Brasil' }],
                [{ kind: 'text', text: 'Novo Nordisk' }],
                [{ kind: 'text', text: 'Parceria Novo Nordisk e Eurofarma' }]
              ],
              [
                [{ kind: 'text', text: 'Doses' }],
                [{ kind: 'text', text: '0,25 / 0,5 / 1 / 1,7 / 2,4 mg' }],
                [{ kind: 'text', text: '0,25 / 0,5 / 1 / 1,7 / 2,4 mg' }]
              ],
              [
                [{ kind: 'text', text: 'Indicação para obesidade' }],
                [{ kind: 'text', text: 'Sim' }],
                [{ kind: 'text', text: 'Sim' }]
              ],
              [
                [{ kind: 'text', text: 'Adolescentes ≥ 12 anos' }],
                [{ kind: 'text', text: 'Sim' }],
                [{ kind: 'text', text: 'Sim' }]
              ],
              [
                [{ kind: 'text', text: 'Preço no programa do fabricante' }],
                [
                  {
                    kind: 'link',
                    url: 'https://www.programanovodia.com.br/produtos.html',
                    children: [{ kind: 'text', text: 'R$ 899,00 a R$ 1.749,00' }]
                  },
                  { kind: 'text', text: ' por caneta (NovoDia, e-commerce)' }
                ],
                [
                  {
                    kind: 'link',
                    url: 'https://olhardigital.com.br/2026/08/22/medicina-e-saude/eurofarma-reduz-preco-do-poviztra-caneta-com-semaglutida-para-doses-de-17-mg-e-24-mg/',
                    children: [{ kind: 'text', text: 'R$ 445,00 a R$ 1.169,00' }]
                  },
                  { kind: 'text', text: ' por caneta (EuroCuida)' }
                ]
              ]
            ]
          }
        ]
      },
      {
        heading: 'Por que existem duas marcas?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Com o fim da patente da semaglutida no Brasil, em março de 2026, a Novo Nordisk '
              },
              {
                kind: 'link',
                url: 'https://www.bemparana.com.br/bem-estar/anvisa-aprova-primeira-caneta-nacional-com-a-mesma-substancia-do-ozempic/',
                children: [{ kind: 'text', text: 'fez parceria com a Eurofarma' }]
              },
              {
                kind: 'text',
                text: ', que passou a comercializar a semaglutida sob as marcas Poviztra (obesidade) e Extensior (diabetes).'
              }
            ]
          }
        ]
      },
      {
        heading: 'O efeito é o mesmo?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'A ' },
              {
                kind: 'link',
                url: 'https://bulas.eurofarma.com.br/storage/media/19087/EiQ7d1CQXpjMvG6Hw4EkvfJXo7lanSbKBK3v3DMl.pdf',
                children: [{ kind: 'text', text: 'bula do Poviztra' }]
              },
              {
                kind: 'text',
                text: ' indica o mesmo princípio ativo, o mesmo fabricante e o mesmo esquema de doses do Wegovy. Os estudos da semaglutida 2,4 mg, como o '
              },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2032183',
                children: [{ kind: 'text', text: 'STEP 1' }]
              },
              { kind: 'text', text: ' (perda média de 14,9% em 68 semanas), valem para a molécula.' }
            ]
          }
        ]
      },
      {
        heading: 'Há diferença de indicação?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'As duas marcas têm indicação para controle de peso. Indicações adicionais aprovadas mais recentemente para o Wegovy, como a redução de risco cardiovascular e a dose de até 7,2 mg, devem ser conferidas na bula vigente de cada produto no '
              },
              {
                kind: 'link',
                url: 'https://consultas.anvisa.gov.br/#/bulario/',
                children: [{ kind: 'text', text: 'Bulário da Anvisa' }]
              },
              { kind: 'text', text: '.' }
            ]
          }
        ]
      },
      {
        heading: 'Posso trocar de uma para a outra?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Por terem a mesma molécula e as mesmas doses, a troca costuma ser simples, mas deve ser feita com orientação do médico e nova receita com o nome do produto prescrito.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'Wegovy e Poviztra são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'Têm o mesmo princípio ativo, as mesmas doses e o mesmo fabricante. São marcas diferentes.'
          }
        ]
      },
      { question: 'Os dois são indicados para obesidade?', answer: [{ kind: 'text', text: 'Sim.' }] },
      {
        question: 'As doses são iguais?',
        answer: [{ kind: 'text', text: 'Sim: 0,25 mg, 0,5 mg, 1 mg, 1,7 mg e 2,4 mg.' }]
      },
      {
        question: 'Qual custa menos?',
        answer: [
          {
            kind: 'text',
            text: 'Nos programas dos fabricantes, o Poviztra: R$ 1.169,00 na dose de 2,4 mg pelo EuroCuida, contra R$ 1.749,00 do Wegovy pelo NovoDia no e-commerce.'
          }
        ]
      },
      {
        question: 'Os efeitos colaterais são iguais?',
        answer: [{ kind: 'text', text: 'Sim, por ser a mesma molécula.' }]
      },
      {
        question: 'Posso trocar de Wegovy para Poviztra?',
        answer: [{ kind: 'text', text: 'Sim, com orientação médica e receita do produto correspondente.' }]
      }
    ],
    sources: [
      {
        title: 'Bula de Poviztra (semaglutida).',
        url: 'https://bulas.eurofarma.com.br/storage/media/19087/EiQ7d1CQXpjMvG6Hw4EkvfJXo7lanSbKBK3v3DMl.pdf'
      },
      { title: 'Wilding JPH et al. STEP 1. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2032183' },
      {
        title: 'Bem Paraná / Folhapress. Anvisa aprova primeira caneta nacional com a mesma substância do Ozempic.',
        url: 'https://www.bemparana.com.br/bem-estar/anvisa-aprova-primeira-caneta-nacional-com-a-mesma-substancia-do-ozempic/'
      },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' }
    ],
    unresolved: [],
    article: {
      points: [
        'Wegovy e Poviztra têm a mesma semaglutida, as mesmas doses e o mesmo fabricante.',
        'As duas marcas são indicadas para obesidade e para adolescentes a partir de 12 anos.',
        'A diferença prática está no preço e na disponibilidade.'
      ],
      info: {
        after: 'Por que existem duas marcas?',
        text: 'Como a molécula e as doses são as mesmas, a escolha entre as duas marcas costuma ser decidida pelo preço e pela disponibilidade na farmácia.'
      },
      tip: {
        after: 'Posso trocar de uma para a outra?',
        text: 'Ao trocar de marca, peça ao médico uma receita nova com o nome do produto e mantenha a mesma dose e o mesmo dia da semana.'
      }
    }
  },
  wegovy: {
    slug: 'wegovy',
    title: 'Wegovy: o que é, preço, doses, receita e como funciona | Medleve',
    description:
      'Wegovy é semaglutida 2,4 mg, aprovada pela Anvisa para obesidade e sobrepeso com comorbidade. Veja doses, preço, resultados dos estudos, efeitos colaterais e como obter receita.',
    h1: 'Wegovy: o que é, preço, doses, receita e como funciona',
    sections: [
      {
        heading: 'Resposta rápida',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Wegovy é uma caneta de semaglutida 2,4 mg, aplicada uma vez por semana, fabricada pela Novo Nordisk. A Anvisa aprova o uso para obesidade (IMC ≥ 30) ou sobrepeso (IMC ≥ 27) com comorbidade, para adolescentes a partir de 12 anos com obesidade e para reduzir o risco cardiovascular. No estudo STEP 1, a perda média de peso foi de 14,9% em 68 semanas. A venda exige receita com retenção.'
              }
            ]
          }
        ]
      },
      { heading: '', blocks: [{ kind: 'cta' }] },
      {
        heading: 'O que é Wegovy?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Wegovy é um medicamento injetável à base de ' },
              { kind: 'link', url: '/semaglutida', children: [{ kind: 'text', text: 'semaglutida' }] },
              { kind: 'text', text: ', um agonista do receptor de ' },
              { kind: 'link', url: '/glp-1', children: [{ kind: 'text', text: 'GLP-1' }] },
              {
                kind: 'text',
                text: '. Foi desenvolvido especificamente para o tratamento da obesidade, com dose de manutenção de 2,4 mg por semana, maior do que a do Ozempic.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Qual é o princípio ativo de Wegovy?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Semaglutida, o mesmo de Ozempic, Poviztra, Ozivy e Semavy. O que muda entre eles é a dose máxima, a indicação de bula e o fabricante.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Para que Wegovy é indicado?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Segundo a ' },
              {
                kind: 'link',
                url: 'https://www.novonordisk.com.br/noticias-e-imprensa/busca-noticias/anvisa-aprova-novas-indicacoes-de-wegovy-e-ozempic-para-tratamento-de-doencas-no-coracao-e-nos-rins.html',
                children: [{ kind: 'text', text: 'Novo Nordisk' }]
              },
              { kind: 'text', text: ' e a bula registrada na Anvisa:' }
            ]
          },
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Controle de peso em adultos' }] },
                {
                  kind: 'text',
                  text: ' com IMC ≥ 30 kg/m², ou IMC ≥ 27 kg/m² com pelo menos uma comorbidade relacionada ao peso, junto com dieta de baixa caloria e atividade física.'
                }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Adolescentes a partir de 12 anos' }] },
                { kind: 'text', text: ' com obesidade e peso acima de 60 kg.' }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Redução do risco cardiovascular' }] },
                {
                  kind: 'text',
                  text: ' (infarto, AVC ou morte cardiovascular) em adultos com doença cardiovascular estabelecida e obesidade ou sobrepeso. Indicação aprovada em 2026.'
                }
              ],
              [
                { kind: 'bold', children: [{ kind: 'text', text: 'Esteato-hepatite metabólica (MASH)' }] },
                { kind: 'text', text: ' em adultos. Indicação aprovada em dezembro de 2025.' }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Como Wegovy funciona?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A semaglutida age no cérebro, aumentando a saciedade e reduzindo a fome, e no estômago, retardando o esvaziamento. A pessoa come menos sem precisar de tanto esforço para controlar o apetite.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quais doses de Wegovy existem?',
        blocks: [
          {
            kind: 'paragraph',
            children: [{ kind: 'text', text: 'O tratamento é escalonado para reduzir os efeitos gastrointestinais:' }]
          },
          {
            kind: 'table',
            header: [[{ kind: 'text', text: 'Período' }], [{ kind: 'text', text: 'Dose semanal' }]],
            rows: [
              [[{ kind: 'text', text: 'Semanas 1 a 4' }], [{ kind: 'text', text: '0,25 mg' }]],
              [[{ kind: 'text', text: 'Semanas 5 a 8' }], [{ kind: 'text', text: '0,5 mg' }]],
              [[{ kind: 'text', text: 'Semanas 9 a 12' }], [{ kind: 'text', text: '1 mg' }]],
              [[{ kind: 'text', text: 'Semanas 13 a 16' }], [{ kind: 'text', text: '1,7 mg' }]],
              [[{ kind: 'text', text: 'A partir da semana 17' }], [{ kind: 'text', text: '2,4 mg (manutenção)' }]]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Cada caneta contém quatro doses, o equivalente a um mês. O médico pode manter uma dose por mais tempo se houver efeitos adversos.'
              }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Em maio de 2026, a Anvisa ' },
              {
                kind: 'link',
                url: 'https://www.poder360.com.br/poder-saude/anvisa-aprova-dose-maior-do-remedio-wegovy-para-obesidade/',
                children: [{ kind: 'text', text: 'aprovou uma dose de manutenção de até 7,2 mg' }]
              },
              {
                kind: 'text',
                text: ' para adultos com IMC ≥ 30 que não responderam adequadamente a 2,4 mg. É uma opção de exceção, definida pelo médico.'
              }
            ]
          }
        ]
      },
      {
        heading: 'O que os estudos mostram?',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa2032183',
                      children: [{ kind: 'text', text: 'STEP 1' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                {
                  kind: 'text',
                  text: ' 1.961 adultos, 68 semanas. Perda média de 14,9% do peso com Wegovy e 2,4% com placebo. 86,4% perderam ao menos 5% e cerca de um terço perdeu 20% ou mais.'
                }
              ],
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1038/s41591-022-02026-4',
                      children: [{ kind: 'text', text: 'STEP 5' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                { kind: 'text', text: ' a perda se manteve em 15,2% após dois anos de uso.' }
              ],
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa2307563',
                      children: [{ kind: 'text', text: 'SELECT' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                {
                  kind: 'text',
                  text: ' em 17.604 adultos com doença cardiovascular, redução de 20% em infarto, AVC ou morte cardiovascular.'
                }
              ],
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa2208601',
                      children: [{ kind: 'text', text: 'STEP TEENS' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                { kind: 'text', text: ' em adolescentes, o IMC caiu 16,1% com Wegovy e subiu 0,6% com placebo.' }
              ],
              [
                {
                  kind: 'bold',
                  children: [
                    {
                      kind: 'link',
                      url: 'https://doi.org/10.1056/NEJMoa2413258',
                      children: [{ kind: 'text', text: 'ESSENCE' }]
                    },
                    { kind: 'text', text: ':' }
                  ]
                },
                {
                  kind: 'text',
                  text: ' resolução da esteato-hepatite em 62,9% dos pacientes, contra 34,3% com placebo.'
                }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Wegovy precisa de receita?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Sim. Desde junho de 2025, a venda de agonistas de GLP-1 exige ' },
              {
                kind: 'link',
                url: 'https://portal.afya.com.br/saude/medicamentos-agonistas-glp-1-terao-retencao-de-receita',
                children: [{ kind: 'text', text: 'receita em duas vias, com retenção de uma delas pela farmácia' }]
              },
              { kind: 'text', text: '. A receita vale 90 dias.' }
            ]
          }
        ]
      },
      {
        heading: 'A receita de Wegovy pode ser digital?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Sim. A ' },
              {
                kind: 'link',
                url: 'https://sincofarmasp.com.br/2026/01/19/anvisa-estabelece-novas-regras-para-prescricao-e-dispensacao-de-medicamentos-agonistas-de-glp-1/',
                children: [{ kind: 'text', text: 'receita digital é aceita' }]
              },
              {
                kind: 'text',
                text: ' quando tem assinatura eletrônica válida, código verificável e atende às exigências da Anvisa.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Quanto custa Wegovy?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Preços divulgados pela Novo Nordisk no ' },
              {
                kind: 'link',
                url: 'https://www.programanovodia.com.br/produtos.html',
                children: [{ kind: 'text', text: 'programa NovoDia' }]
              },
              { kind: 'text', text: ', por caneta (quatro doses), consultados em 09/10/2026:' }
            ]
          },
          {
            kind: 'table',
            header: [
              [{ kind: 'text', text: 'Dose' }],
              [{ kind: 'text', text: 'Preço de lista' }],
              [{ kind: 'text', text: 'NovoDia, loja física' }],
              [{ kind: 'text', text: 'NovoDia, e-commerce' }]
            ],
            rows: [
              [
                [{ kind: 'text', text: '0,25 mg' }],
                [{ kind: 'text', text: 'R$ 1.314,38' }],
                [{ kind: 'text', text: 'R$ 949,00' }],
                [{ kind: 'text', text: 'R$ 899,00' }]
              ],
              [
                [{ kind: 'text', text: '0,5 mg' }],
                [{ kind: 'text', text: 'R$ 1.314,38' }],
                [{ kind: 'text', text: 'R$ 1.075,00' }],
                [{ kind: 'text', text: 'R$ 975,00' }]
              ],
              [
                [{ kind: 'text', text: '1 mg' }],
                [{ kind: 'text', text: 'R$ 1.314,38' }],
                [{ kind: 'text', text: 'R$ 1.099,00' }],
                [{ kind: 'text', text: 'R$ 999,00' }]
              ],
              [
                [{ kind: 'text', text: '1,7 mg' }],
                [{ kind: 'text', text: 'R$ 1.968,82' }],
                [{ kind: 'text', text: 'R$ 1.499,00' }],
                [{ kind: 'text', text: 'R$ 1.399,00' }]
              ],
              [
                [{ kind: 'text', text: '2,4 mg' }],
                [{ kind: 'text', text: 'R$ 2.532,31' }],
                [{ kind: 'text', text: 'R$ 1.849,00' }],
                [{ kind: 'text', text: 'R$ 1.749,00' }]
              ]
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'O desconto do NovoDia exige cadastro gratuito no programa e receita médica, e vale nas farmácias credenciadas. Comprar pelo e-commerce sai de R$ 50 a R$ 100 mais barato por caneta do que na loja física.'
              }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Os valores são os divulgados pelo fabricante e podem mudar sem aviso. O preço final depende da farmácia. O paciente pode comprar na farmácia de sua preferência ou em uma farmácia parceira disponível na plataforma.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Principais efeitos colaterais de Wegovy',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'No ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1056/NEJMoa2032183',
                children: [{ kind: 'text', text: 'STEP 1' }]
              },
              {
                kind: 'text',
                text: ', os efeitos mais frequentes foram náusea (44,2%), diarreia (31,5%), vômito (24,8%) e constipação (23,4%), em geral leves a moderados e passageiros. 4,5% dos participantes interromperam o tratamento por efeitos gastrointestinais.'
              }
            ]
          },
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'A bula também lista como muito comuns dor de cabeça, dor abdominal e cansaço, e como comuns tontura, refluxo, gases, pedra na vesícula e queda de cabelo. Dor abdominal intensa e persistente exige atendimento médico, pois pode indicar pancreatite.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Contraindicações de Wegovy',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [{ kind: 'text', text: 'Alergia à semaglutida ou a componentes da fórmula.' }],
              [
                {
                  kind: 'text',
                  text: 'Gravidez e amamentação. Interromper ao menos dois meses antes de uma gravidez planejada.'
                }
              ],
              [
                {
                  kind: 'text',
                  text: 'Histórico pessoal ou familiar de carcinoma medular de tireoide ou neoplasia endócrina múltipla tipo 2: avaliar com o médico.'
                }
              ],
              [
                {
                  kind: 'text',
                  text: 'Não recomendado em diabetes tipo 1 nem junto com outros medicamentos para perda de peso.'
                }
              ]
            ]
          }
        ]
      },
      {
        heading: 'O que acontece ao parar Wegovy?',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              { kind: 'text', text: 'Na ' },
              {
                kind: 'link',
                url: 'https://doi.org/10.1111/dom.14725',
                children: [{ kind: 'text', text: 'extensão do STEP 1' }]
              },
              {
                kind: 'text',
                text: ', os participantes recuperaram cerca de dois terços do peso perdido um ano após a interrupção. Por isso, a duração do tratamento e a forma de interrompê-lo devem ser planejadas com o médico.'
              }
            ]
          }
        ]
      },
      {
        heading: 'Diferenças entre Wegovy e outros medicamentos',
        blocks: [
          {
            kind: 'list',
            ordered: false,
            items: [
              [
                { kind: 'link', url: '/wegovy-ou-poviztra', children: [{ kind: 'text', text: 'Wegovy ou Poviztra' }] },
                { kind: 'text', text: ': mesma semaglutida 2,4 mg, marcas diferentes.' }
              ],
              [
                { kind: 'link', url: '/wegovy-ou-ozempic', children: [{ kind: 'text', text: 'Wegovy ou Ozempic' }] },
                { kind: 'text', text: ': mesma molécula, doses e indicações diferentes.' }
              ],
              [
                { kind: 'link', url: '/wegovy-ou-ozivy', children: [{ kind: 'text', text: 'Wegovy ou Ozivy' }] },
                { kind: 'text', text: ': obesidade versus diabetes tipo 2.' }
              ],
              [
                { kind: 'link', url: '/mounjaro-ou-wegovy', children: [{ kind: 'text', text: 'Mounjaro ou Wegovy' }] },
                { kind: 'text', text: ': tirzepatida versus semaglutida.' }
              ]
            ]
          }
        ]
      },
      {
        heading: 'Consulta médica online',
        blocks: [
          {
            kind: 'paragraph',
            children: [
              {
                kind: 'text',
                text: 'Na Medleve, você responde a um questionário de saúde e é atendido por um médico, por mensagem ou vídeo. Ele avalia histórico, IMC, contraindicações e objetivos. Se houver indicação clínica, emite a receita digital. Depois, você compra na farmácia de sua preferência ou em uma farmácia parceira disponível na plataforma.'
              }
            ]
          },
          { kind: 'cta' }
        ]
      },
      { heading: 'Perguntas frequentes', blocks: [] },
      { heading: 'Fontes', blocks: [] }
    ],
    faq: [
      {
        question: 'O que é Wegovy?',
        answer: [
          {
            kind: 'text',
            text: 'É uma caneta de semaglutida 2,4 mg, de aplicação semanal, aprovada para o tratamento da obesidade e do sobrepeso com comorbidade.'
          }
        ]
      },
      {
        question: 'Wegovy é semaglutida?',
        answer: [{ kind: 'text', text: 'Sim. Semaglutida é o princípio ativo de Wegovy.' }]
      },
      {
        question: 'Para que Wegovy é indicado?',
        answer: [
          {
            kind: 'text',
            text: 'Para controle de peso em adultos com IMC ≥ 30, ou ≥ 27 com comorbidade, em adolescentes a partir de 12 anos com obesidade e para redução do risco cardiovascular em adultos com doença cardiovascular e excesso de peso.'
          }
        ]
      },
      {
        question: 'Wegovy precisa de receita?',
        answer: [{ kind: 'text', text: 'Sim, em duas vias, com retenção pela farmácia. A receita vale 90 dias.' }]
      },
      {
        question: 'A receita pode ser digital?',
        answer: [
          { kind: 'text', text: 'Sim, desde que tenha assinatura eletrônica válida e siga as regras da Anvisa.' }
        ]
      },
      {
        question: 'Quais doses existem?',
        answer: [
          {
            kind: 'text',
            text: '0,25 mg, 0,5 mg, 1 mg, 1,7 mg e 2,4 mg. Uma dose de até 7,2 mg foi aprovada em 2026 para casos específicos.'
          }
        ]
      },
      {
        question: 'Quanto custa Wegovy?',
        answer: [
          {
            kind: 'text',
            text: 'Pelo programa NovoDia, da Novo Nordisk, de R$ 899,00 (0,25 mg) a R$ 1.749,00 (2,4 mg) por caneta no e-commerce. Sem o programa, o preço de lista vai de R$ 1.314,38 a R$ 2.532,31.'
          }
        ]
      },
      {
        question: 'Wegovy e Ozempic são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'Têm o mesmo princípio ativo. Wegovy chega a 2,4 mg e é aprovado para obesidade; Ozempic vai até 1 mg e é aprovado para diabetes tipo 2.'
          }
        ]
      },
      {
        question: 'Wegovy e Mounjaro são iguais?',
        answer: [
          {
            kind: 'text',
            text: 'Não. Wegovy é semaglutida; Mounjaro é tirzepatida. No estudo SURMOUNT-5, a perda média de peso foi maior com tirzepatida.'
          }
        ]
      },
      {
        question: 'Quais são os efeitos colaterais mais comuns?',
        answer: [
          {
            kind: 'text',
            text: 'Náusea, diarreia, vômito e constipação, mais frequentes no início e nos aumentos de dose.'
          }
        ]
      },
      {
        question: 'Como funciona uma avaliação médica online para Wegovy?',
        answer: [
          {
            kind: 'text',
            text: 'Você preenche um questionário, conversa com o médico por mensagem ou vídeo e, se houver indicação, recebe a receita digital.'
          }
        ]
      }
    ],
    sources: [
      { title: 'Wilding JPH et al. STEP 1. NEJM, 2021.', url: 'https://doi.org/10.1056/NEJMoa2032183' },
      { title: 'Garvey WT et al. STEP 5. Nature Medicine, 2022.', url: 'https://doi.org/10.1038/s41591-022-02026-4' },
      { title: 'Lincoff AM et al. SELECT. NEJM, 2023.', url: 'https://doi.org/10.1056/NEJMoa2307563' },
      { title: 'Weghuber D et al. STEP TEENS. NEJM, 2022.', url: 'https://doi.org/10.1056/NEJMoa2208601' },
      { title: 'Sanyal AJ et al. ESSENCE. NEJM, 2025.', url: 'https://doi.org/10.1056/NEJMoa2413258' },
      {
        title: 'Wilding JPH et al. Extensão do STEP 1. Diabetes Obes Metab, 2022.',
        url: 'https://doi.org/10.1111/dom.14725'
      },
      {
        title: 'Novo Nordisk Brasil. Anvisa aprova novas indicações de Wegovy e Ozempic.',
        url: 'https://www.novonordisk.com.br/noticias-e-imprensa/busca-noticias/anvisa-aprova-novas-indicacoes-de-wegovy-e-ozempic-para-tratamento-de-doencas-no-coracao-e-nos-rins.html'
      },
      { title: 'Novo Nordisk. Programa NovoDia: preços.', url: 'https://www.programanovodia.com.br/produtos.html' },
      {
        title: 'Poder360. Anvisa aprova dose maior do remédio Wegovy para obesidade.',
        url: 'https://www.poder360.com.br/poder-saude/anvisa-aprova-dose-maior-do-remedio-wegovy-para-obesidade/'
      },
      {
        title: 'Afya. Medicamentos agonistas GLP-1 terão retenção de receita.',
        url: 'https://portal.afya.com.br/saude/medicamentos-agonistas-glp-1-terao-retencao-de-receita'
      },
      { title: 'Anvisa. Bulário Eletrônico.', url: 'https://consultas.anvisa.gov.br/#/bulario/' }
    ],
    unresolved: [],
    article: {
      points: [
        'Wegovy é semaglutida 2,4 mg, aprovada para obesidade, sobrepeso com comorbidade e adolescentes a partir de 12 anos.',
        'Perda média de 14,9% do peso em 68 semanas no estudo STEP 1.',
        'Pelo programa NovoDia, de R$ 899 a R$ 1.749 por caneta no e-commerce.'
      ],
      info: {
        after: 'Quais doses de Wegovy existem?',
        text: 'Cada caneta de Wegovy tem quatro doses, o equivalente a um mês. Na fase de aumento de dose, você usa uma caneta de dose diferente a cada mês.'
      },
      tip: {
        after: 'Principais efeitos colaterais de Wegovy',
        text: 'Alterne o local da aplicação a cada semana entre abdome, coxa e parte de trás do braço, sem repetir o mesmo ponto. Isso reduz vermelhidão e incômodo na pele.'
      }
    }
  }
}

export const CONTENT_RULES: ContentRules = {
  reviewer: {
    '@type': 'Person',
    '@id': 'https://www.medleve.com/equipe-medica/carlos-seraphim#person',
    name: 'Carlos Eduardo Seraphim',
    honorificPrefix: 'Dr.',
    jobTitle: 'Médico endocrinologista',
    url: 'https://www.medleve.com/equipe-medica/carlos-seraphim',
    mainEntityOfPage: 'https://www.medleve.com/equipe-medica/carlos-seraphim',
    identifier: { '@type': 'PropertyValue', propertyID: 'CRM-SP', value: '156663' },
    alumniOf: { '@type': 'CollegeOrUniversity', name: 'Faculdade de Medicina da Universidade de São Paulo' },
    worksFor: { '@id': 'https://www.medleve.com/#organization' },
    sameAs: [
      'https://scholar.google.com/citations?user=cSBC7bAAAAAJ',
      'https://br.linkedin.com/in/carlos-eduardo-seraphim',
      'https://www.youtube.com/@endocrinoetalks',
      'https://www.drcarlosseraphim.com.br/sobre-o-dr-carlos-seraphim'
    ]
  },
  disclaimer:
    'Este conteúdo é informativo e não substitui consulta médica. Medicamentos à base de semaglutida e tirzepatida são vendidos somente com prescrição e retenção de receita. A indicação de qualquer tratamento depende de avaliação individual feita pelo médico.'
}
